"use strict";
(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // node_modules/flickity/node_modules/ev-emitter/ev-emitter.js
  var require_ev_emitter = __commonJS({
    "node_modules/flickity/node_modules/ev-emitter/ev-emitter.js"(exports, module) {
      (function(global, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory();
        } else {
          global.EvEmitter = factory();
        }
      })(typeof window != "undefined" ? window : exports, function() {
        function EvEmitter() {
        }
        let proto = EvEmitter.prototype;
        proto.on = function(eventName, listener) {
          if (!eventName || !listener) return this;
          let events = this._events = this._events || {};
          let listeners = events[eventName] = events[eventName] || [];
          if (!listeners.includes(listener)) {
            listeners.push(listener);
          }
          return this;
        };
        proto.once = function(eventName, listener) {
          if (!eventName || !listener) return this;
          this.on(eventName, listener);
          let onceEvents = this._onceEvents = this._onceEvents || {};
          let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
          onceListeners[listener] = true;
          return this;
        };
        proto.off = function(eventName, listener) {
          let listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) return this;
          let index = listeners.indexOf(listener);
          if (index != -1) {
            listeners.splice(index, 1);
          }
          return this;
        };
        proto.emitEvent = function(eventName, args) {
          let listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) return this;
          listeners = listeners.slice(0);
          args = args || [];
          let onceListeners = this._onceEvents && this._onceEvents[eventName];
          for (let listener of listeners) {
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
              this.off(eventName, listener);
              delete onceListeners[listener];
            }
            listener.apply(this, args);
          }
          return this;
        };
        proto.allOff = function() {
          delete this._events;
          delete this._onceEvents;
          return this;
        };
        return EvEmitter;
      });
    }
  });

  // node_modules/get-size/get-size.js
  var require_get_size = __commonJS({
    "node_modules/get-size/get-size.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory();
        } else {
          window2.getSize = factory();
        }
      })(window, function factory() {
        function getStyleSize(value) {
          let num = parseFloat(value);
          let isValid = value.indexOf("%") == -1 && !isNaN(num);
          return isValid && num;
        }
        let measurements = [
          "paddingLeft",
          "paddingRight",
          "paddingTop",
          "paddingBottom",
          "marginLeft",
          "marginRight",
          "marginTop",
          "marginBottom",
          "borderLeftWidth",
          "borderRightWidth",
          "borderTopWidth",
          "borderBottomWidth"
        ];
        let measurementsLength = measurements.length;
        function getZeroSize() {
          let size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
          };
          measurements.forEach((measurement) => {
            size[measurement] = 0;
          });
          return size;
        }
        function getSize(elem) {
          if (typeof elem == "string") elem = document.querySelector(elem);
          let isElement = elem && typeof elem == "object" && elem.nodeType;
          if (!isElement) return;
          let style = getComputedStyle(elem);
          if (style.display == "none") return getZeroSize();
          let size = {};
          size.width = elem.offsetWidth;
          size.height = elem.offsetHeight;
          let isBorderBox = size.isBorderBox = style.boxSizing == "border-box";
          measurements.forEach((measurement) => {
            let value = style[measurement];
            let num = parseFloat(value);
            size[measurement] = !isNaN(num) ? num : 0;
          });
          let paddingWidth = size.paddingLeft + size.paddingRight;
          let paddingHeight = size.paddingTop + size.paddingBottom;
          let marginWidth = size.marginLeft + size.marginRight;
          let marginHeight = size.marginTop + size.marginBottom;
          let borderWidth = size.borderLeftWidth + size.borderRightWidth;
          let borderHeight = size.borderTopWidth + size.borderBottomWidth;
          let styleWidth = getStyleSize(style.width);
          if (styleWidth !== false) {
            size.width = styleWidth + // add padding and border unless it's already including it
            (isBorderBox ? 0 : paddingWidth + borderWidth);
          }
          let styleHeight = getStyleSize(style.height);
          if (styleHeight !== false) {
            size.height = styleHeight + // add padding and border unless it's already including it
            (isBorderBox ? 0 : paddingHeight + borderHeight);
          }
          size.innerWidth = size.width - (paddingWidth + borderWidth);
          size.innerHeight = size.height - (paddingHeight + borderHeight);
          size.outerWidth = size.width + marginWidth;
          size.outerHeight = size.height + marginHeight;
          return size;
        }
        return getSize;
      });
    }
  });

  // node_modules/fizzy-ui-utils/utils.js
  var require_utils = __commonJS({
    "node_modules/fizzy-ui-utils/utils.js"(exports, module) {
      (function(global, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(global);
        } else {
          global.fizzyUIUtils = factory(global);
        }
      })(exports, function factory(global) {
        let utils = {};
        utils.extend = function(a, b) {
          return Object.assign(a, b);
        };
        utils.modulo = function(num, div) {
          return (num % div + div) % div;
        };
        utils.makeArray = function(obj) {
          if (Array.isArray(obj)) return obj;
          if (obj === null || obj === void 0) return [];
          let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
          if (isArrayLike) return [...obj];
          return [obj];
        };
        utils.removeFrom = function(ary, obj) {
          let index = ary.indexOf(obj);
          if (index != -1) {
            ary.splice(index, 1);
          }
        };
        utils.getParent = function(elem, selector) {
          while (elem.parentNode && elem != document.body) {
            elem = elem.parentNode;
            if (elem.matches(selector)) return elem;
          }
        };
        utils.getQueryElement = function(elem) {
          if (typeof elem == "string") {
            return document.querySelector(elem);
          }
          return elem;
        };
        utils.handleEvent = function(event) {
          let method = "on" + event.type;
          if (this[method]) {
            this[method](event);
          }
        };
        utils.filterFindElements = function(elems, selector) {
          elems = utils.makeArray(elems);
          return elems.filter((elem) => elem instanceof HTMLElement).reduce((ffElems, elem) => {
            if (!selector) {
              ffElems.push(elem);
              return ffElems;
            }
            if (elem.matches(selector)) {
              ffElems.push(elem);
            }
            let childElems = elem.querySelectorAll(selector);
            ffElems = ffElems.concat(...childElems);
            return ffElems;
          }, []);
        };
        utils.debounceMethod = function(_class, methodName, threshold) {
          threshold = threshold || 100;
          let method = _class.prototype[methodName];
          let timeoutName = methodName + "Timeout";
          _class.prototype[methodName] = function() {
            clearTimeout(this[timeoutName]);
            let args = arguments;
            this[timeoutName] = setTimeout(() => {
              method.apply(this, args);
              delete this[timeoutName];
            }, threshold);
          };
        };
        utils.docReady = function(onDocReady) {
          let readyState = document.readyState;
          if (readyState == "complete" || readyState == "interactive") {
            setTimeout(onDocReady);
          } else {
            document.addEventListener("DOMContentLoaded", onDocReady);
          }
        };
        utils.toDashed = function(str) {
          return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + "-" + $2;
          }).toLowerCase();
        };
        let console2 = global.console;
        utils.htmlInit = function(WidgetClass, namespace) {
          utils.docReady(function() {
            let dashedNamespace = utils.toDashed(namespace);
            let dataAttr = "data-" + dashedNamespace;
            let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
            let jQuery = global.jQuery;
            [...dataAttrElems].forEach((elem) => {
              let attr = elem.getAttribute(dataAttr);
              let options;
              try {
                options = attr && JSON.parse(attr);
              } catch (error) {
                if (console2) {
                  console2.error(`Error parsing ${dataAttr} on ${elem.className}: ${error}`);
                }
                return;
              }
              let instance = new WidgetClass(elem, options);
              if (jQuery) {
                jQuery.data(elem, namespace, instance);
              }
            });
          });
        };
        return utils;
      });
    }
  });

  // node_modules/flickity/js/cell.js
  var require_cell = __commonJS({
    "node_modules/flickity/js/cell.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(require_get_size());
        } else {
          window2.Flickity = window2.Flickity || {};
          window2.Flickity.Cell = factory(window2.getSize);
        }
      })(typeof window != "undefined" ? window : exports, function factory(getSize) {
        const cellClassName = "flickity-cell";
        function Cell(elem) {
          this.element = elem;
          this.element.classList.add(cellClassName);
          this.x = 0;
          this.unselect();
        }
        let proto = Cell.prototype;
        proto.destroy = function() {
          this.unselect();
          this.element.classList.remove(cellClassName);
          this.element.style.transform = "";
          this.element.removeAttribute("aria-hidden");
        };
        proto.getSize = function() {
          this.size = getSize(this.element);
        };
        proto.select = function() {
          this.element.classList.add("is-selected");
          this.element.removeAttribute("aria-hidden");
        };
        proto.unselect = function() {
          this.element.classList.remove("is-selected");
          this.element.setAttribute("aria-hidden", "true");
        };
        proto.remove = function() {
          this.element.remove();
        };
        return Cell;
      });
    }
  });

  // node_modules/flickity/js/slide.js
  var require_slide = __commonJS({
    "node_modules/flickity/js/slide.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory();
        } else {
          window2.Flickity = window2.Flickity || {};
          window2.Flickity.Slide = factory();
        }
      })(typeof window != "undefined" ? window : exports, function factory() {
        function Slide(beginMargin, endMargin, cellAlign) {
          this.beginMargin = beginMargin;
          this.endMargin = endMargin;
          this.cellAlign = cellAlign;
          this.cells = [];
          this.outerWidth = 0;
          this.height = 0;
        }
        let proto = Slide.prototype;
        proto.addCell = function(cell) {
          this.cells.push(cell);
          this.outerWidth += cell.size.outerWidth;
          this.height = Math.max(cell.size.outerHeight, this.height);
          if (this.cells.length === 1) {
            this.x = cell.x;
            this.firstMargin = cell.size[this.beginMargin];
          }
        };
        proto.updateTarget = function() {
          let lastCell = this.getLastCell();
          let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
          let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
          this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
        };
        proto.getLastCell = function() {
          return this.cells[this.cells.length - 1];
        };
        proto.select = function() {
          this.cells.forEach((cell) => cell.select());
        };
        proto.unselect = function() {
          this.cells.forEach((cell) => cell.unselect());
        };
        proto.getCellElements = function() {
          return this.cells.map((cell) => cell.element);
        };
        return Slide;
      });
    }
  });

  // node_modules/flickity/js/animate.js
  var require_animate = __commonJS({
    "node_modules/flickity/js/animate.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(require_utils());
        } else {
          window2.Flickity = window2.Flickity || {};
          window2.Flickity.animatePrototype = factory(window2.fizzyUIUtils);
        }
      })(typeof window != "undefined" ? window : exports, function factory(utils) {
        let proto = {};
        proto.startAnimation = function() {
          if (this.isAnimating) return;
          this.isAnimating = true;
          this.restingFrames = 0;
          this.animate();
        };
        proto.animate = function() {
          this.applyDragForce();
          this.applySelectedAttraction();
          let previousX = this.x;
          this.integratePhysics();
          this.positionSlider();
          this.settle(previousX);
          if (this.isAnimating) requestAnimationFrame(() => this.animate());
        };
        proto.positionSlider = function() {
          let x = this.x;
          if (this.isWrapping) {
            x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
            this.shiftWrapCells(x);
          }
          this.setTranslateX(x, this.isAnimating);
          this.dispatchScrollEvent();
        };
        proto.setTranslateX = function(x, is3d) {
          x += this.cursorPosition;
          if (this.options.rightToLeft) x = -x;
          let translateX = this.getPositionValue(x);
          this.slider.style.transform = is3d ? `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
        };
        proto.dispatchScrollEvent = function() {
          let firstSlide = this.slides[0];
          if (!firstSlide) return;
          let positionX = -this.x - firstSlide.target;
          let progress = positionX / this.slidesWidth;
          this.dispatchEvent("scroll", null, [progress, positionX]);
        };
        proto.positionSliderAtSelected = function() {
          if (!this.cells.length) return;
          this.x = -this.selectedSlide.target;
          this.velocity = 0;
          this.positionSlider();
        };
        proto.getPositionValue = function(position) {
          if (this.options.percentPosition) {
            return Math.round(position / this.size.innerWidth * 1e4) * 0.01 + "%";
          } else {
            return Math.round(position) + "px";
          }
        };
        proto.settle = function(previousX) {
          let isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
          if (isResting) this.restingFrames++;
          if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            this.positionSlider();
            this.dispatchEvent("settle", null, [this.selectedIndex]);
          }
        };
        proto.shiftWrapCells = function(x) {
          let beforeGap = this.cursorPosition + x;
          this._shiftCells(this.beforeShiftCells, beforeGap, -1);
          let afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
          this._shiftCells(this.afterShiftCells, afterGap, 1);
        };
        proto._shiftCells = function(cells, gap, shift) {
          cells.forEach((cell) => {
            let cellShift = gap > 0 ? shift : 0;
            this._wrapShiftCell(cell, cellShift);
            gap -= cell.size.outerWidth;
          });
        };
        proto._unshiftCells = function(cells) {
          if (!cells || !cells.length) return;
          cells.forEach((cell) => this._wrapShiftCell(cell, 0));
        };
        proto._wrapShiftCell = function(cell, shift) {
          this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
        };
        proto.integratePhysics = function() {
          this.x += this.velocity;
          this.velocity *= this.getFrictionFactor();
        };
        proto.applyForce = function(force) {
          this.velocity += force;
        };
        proto.getFrictionFactor = function() {
          return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
        };
        proto.getRestingPosition = function() {
          return this.x + this.velocity / (1 - this.getFrictionFactor());
        };
        proto.applyDragForce = function() {
          if (!this.isDraggable || !this.isPointerDown) return;
          let dragVelocity = this.dragX - this.x;
          let dragForce = dragVelocity - this.velocity;
          this.applyForce(dragForce);
        };
        proto.applySelectedAttraction = function() {
          let dragDown = this.isDraggable && this.isPointerDown;
          if (dragDown || this.isFreeScrolling || !this.slides.length) return;
          let distance = this.selectedSlide.target * -1 - this.x;
          let force = distance * this.options.selectedAttraction;
          this.applyForce(force);
        };
        return proto;
      });
    }
  });

  // node_modules/flickity/js/core.js
  var require_core = __commonJS({
    "node_modules/flickity/js/core.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(
            window2,
            require_ev_emitter(),
            require_get_size(),
            require_utils(),
            require_cell(),
            require_slide(),
            require_animate()
          );
        } else {
          let _Flickity = window2.Flickity;
          window2.Flickity = factory(
            window2,
            window2.EvEmitter,
            window2.getSize,
            window2.fizzyUIUtils,
            _Flickity.Cell,
            _Flickity.Slide,
            _Flickity.animatePrototype
          );
        }
      })(
        typeof window != "undefined" ? window : exports,
        function factory(window2, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
          const { getComputedStyle: getComputedStyle2, console: console2 } = window2;
          let { jQuery } = window2;
          let GUID = 0;
          let instances = {};
          function Flickity2(element, options) {
            let queryElement = utils.getQueryElement(element);
            if (!queryElement) {
              if (console2) console2.error(`Bad element for Flickity: ${queryElement || element}`);
              return;
            }
            this.element = queryElement;
            if (this.element.flickityGUID) {
              let instance = instances[this.element.flickityGUID];
              if (instance) instance.option(options);
              return instance;
            }
            if (jQuery) {
              this.$element = jQuery(this.element);
            }
            this.options = __spreadValues({}, this.constructor.defaults);
            this.option(options);
            this._create();
          }
          Flickity2.defaults = {
            accessibility: true,
            // adaptiveHeight: false,
            cellAlign: "center",
            // cellSelector: undefined,
            // contain: false,
            freeScrollFriction: 0.075,
            // friction when free-scrolling
            friction: 0.28,
            // friction when selecting
            namespaceJQueryEvents: true,
            // initialIndex: 0,
            percentPosition: true,
            resize: true,
            selectedAttraction: 0.025,
            setGallerySize: true
            // watchCSS: false,
            // wrapAround: false
          };
          Flickity2.create = {};
          let proto = Flickity2.prototype;
          Object.assign(proto, EvEmitter.prototype);
          proto._create = function() {
            let { resize, watchCSS, rightToLeft } = this.options;
            let id = this.guid = ++GUID;
            this.element.flickityGUID = id;
            instances[id] = this;
            this.selectedIndex = 0;
            this.restingFrames = 0;
            this.x = 0;
            this.velocity = 0;
            this.beginMargin = rightToLeft ? "marginRight" : "marginLeft";
            this.endMargin = rightToLeft ? "marginLeft" : "marginRight";
            this.viewport = document.createElement("div");
            this.viewport.className = "flickity-viewport";
            this._createSlider();
            this.focusableElems = [this.element];
            if (resize || watchCSS) {
              window2.addEventListener("resize", this);
            }
            for (let eventName in this.options.on) {
              let listener = this.options.on[eventName];
              this.on(eventName, listener);
            }
            for (let method in Flickity2.create) {
              Flickity2.create[method].call(this);
            }
            if (watchCSS) {
              this.watchCSS();
            } else {
              this.activate();
            }
          };
          proto.option = function(opts) {
            Object.assign(this.options, opts);
          };
          proto.activate = function() {
            if (this.isActive) return;
            this.isActive = true;
            this.element.classList.add("flickity-enabled");
            if (this.options.rightToLeft) {
              this.element.classList.add("flickity-rtl");
            }
            this.getSize();
            let cellElems = this._filterFindCellElements(this.element.children);
            this.slider.append(...cellElems);
            this.viewport.append(this.slider);
            this.element.append(this.viewport);
            this.reloadCells();
            if (this.options.accessibility) {
              this.element.tabIndex = 0;
              this.element.addEventListener("keydown", this);
            }
            this.emitEvent("activate");
            this.selectInitialIndex();
            this.isInitActivated = true;
            this.dispatchEvent("ready");
          };
          proto._createSlider = function() {
            let slider = document.createElement("div");
            slider.className = "flickity-slider";
            this.slider = slider;
          };
          proto._filterFindCellElements = function(elems) {
            return utils.filterFindElements(elems, this.options.cellSelector);
          };
          proto.reloadCells = function() {
            this.cells = this._makeCells(this.slider.children);
            this.positionCells();
            this._updateWrapShiftCells();
            this.setGallerySize();
          };
          proto._makeCells = function(elems) {
            let cellElems = this._filterFindCellElements(elems);
            return cellElems.map((cellElem) => new Cell(cellElem));
          };
          proto.getLastCell = function() {
            return this.cells[this.cells.length - 1];
          };
          proto.getLastSlide = function() {
            return this.slides[this.slides.length - 1];
          };
          proto.positionCells = function() {
            this._sizeCells(this.cells);
            this._positionCells(0);
          };
          proto._positionCells = function(index) {
            index = index || 0;
            this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
            let cellX = 0;
            if (index > 0) {
              let startCell = this.cells[index - 1];
              cellX = startCell.x + startCell.size.outerWidth;
            }
            this.cells.slice(index).forEach((cell) => {
              cell.x = cellX;
              this._renderCellPosition(cell, cellX);
              cellX += cell.size.outerWidth;
              this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
            });
            this.slideableWidth = cellX;
            this.updateSlides();
            this._containSlides();
            this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
          };
          proto._renderCellPosition = function(cell, x) {
            let sideOffset = this.options.rightToLeft ? -1 : 1;
            let renderX = x * sideOffset;
            if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
            let positionValue = this.getPositionValue(renderX);
            cell.element.style.transform = `translateX( ${positionValue} )`;
          };
          proto._sizeCells = function(cells) {
            cells.forEach((cell) => cell.getSize());
          };
          proto.updateSlides = function() {
            this.slides = [];
            if (!this.cells.length) return;
            let { beginMargin, endMargin } = this;
            let slide = new Slide(beginMargin, endMargin, this.cellAlign);
            this.slides.push(slide);
            let canCellFit = this._getCanCellFit();
            this.cells.forEach((cell, i) => {
              if (!slide.cells.length) {
                slide.addCell(cell);
                return;
              }
              let slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);
              if (canCellFit(i, slideWidth)) {
                slide.addCell(cell);
              } else {
                slide.updateTarget();
                slide = new Slide(beginMargin, endMargin, this.cellAlign);
                this.slides.push(slide);
                slide.addCell(cell);
              }
            });
            slide.updateTarget();
            this.updateSelectedSlide();
          };
          proto._getCanCellFit = function() {
            let { groupCells } = this.options;
            if (!groupCells) return () => false;
            if (typeof groupCells == "number") {
              let number = parseInt(groupCells, 10);
              return (i) => i % number !== 0;
            }
            let percent = 1;
            let percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
            if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
            let groupWidth = (this.size.innerWidth + 1) * percent;
            return (i, slideWidth) => slideWidth <= groupWidth;
          };
          proto._init = proto.reposition = function() {
            this.positionCells();
            this.positionSliderAtSelected();
          };
          proto.getSize = function() {
            this.size = getSize(this.element);
            this.setCellAlign();
            this.cursorPosition = this.size.innerWidth * this.cellAlign;
          };
          let cellAlignShorthands = {
            left: 0,
            center: 0.5,
            right: 1
          };
          proto.setCellAlign = function() {
            let { cellAlign, rightToLeft } = this.options;
            let shorthand = cellAlignShorthands[cellAlign];
            this.cellAlign = shorthand !== void 0 ? shorthand : cellAlign;
            if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
          };
          proto.setGallerySize = function() {
            if (!this.options.setGallerySize) return;
            let height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = `${height}px`;
          };
          proto._updateWrapShiftCells = function() {
            this.isWrapping = this.getIsWrapping();
            if (!this.isWrapping) return;
            this._unshiftCells(this.beforeShiftCells);
            this._unshiftCells(this.afterShiftCells);
            let beforeGapX = this.cursorPosition;
            let lastIndex = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
            let afterGapX = this.size.innerWidth - this.cursorPosition;
            this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
          };
          proto.getIsWrapping = function() {
            let { wrapAround } = this.options;
            if (!wrapAround || this.slides.length < 2) return false;
            if (wrapAround !== "fill") return true;
            let gapWidth = this.slideableWidth - this.size.innerWidth;
            if (gapWidth > this.size.innerWidth) return true;
            for (let cell of this.cells) {
              if (cell.size.outerWidth > gapWidth) return false;
            }
            return true;
          };
          proto._getGapCells = function(gapX, cellIndex, increment) {
            let cells = [];
            while (gapX > 0) {
              let cell = this.cells[cellIndex];
              if (!cell) break;
              cells.push(cell);
              cellIndex += increment;
              gapX -= cell.size.outerWidth;
            }
            return cells;
          };
          proto._containSlides = function() {
            let isContaining = this.options.contain && !this.isWrapping && this.cells.length;
            if (!isContaining) return;
            let contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
            let isContentSmaller = contentWidth < this.size.innerWidth;
            if (isContentSmaller) {
              this.slides.forEach((slide) => {
                slide.target = contentWidth * this.cellAlign;
              });
            } else {
              let beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
              let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
              this.slides.forEach((slide) => {
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
              });
            }
          };
          proto.dispatchEvent = function(type, event, args) {
            let emitArgs = event ? [event].concat(args) : args;
            this.emitEvent(type, emitArgs);
            if (jQuery && this.$element) {
              type += this.options.namespaceJQueryEvents ? ".flickity" : "";
              let $event = type;
              if (event) {
                let jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
              }
              this.$element.trigger($event, args);
            }
          };
          const unidraggerEvents = [
            "dragStart",
            "dragMove",
            "dragEnd",
            "pointerDown",
            "pointerMove",
            "pointerEnd",
            "staticClick"
          ];
          let _emitEvent = proto.emitEvent;
          proto.emitEvent = function(eventName, args) {
            if (eventName === "staticClick") {
              let clickedCell = this.getParentCell(args[0].target);
              let cellElem = clickedCell && clickedCell.element;
              let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
              args = args.concat(cellElem, cellIndex);
            }
            _emitEvent.call(this, eventName, args);
            let isUnidraggerEvent = unidraggerEvents.includes(eventName);
            if (!isUnidraggerEvent || !jQuery || !this.$element) return;
            eventName += this.options.namespaceJQueryEvents ? ".flickity" : "";
            let event = args.shift(0);
            let jQEvent = new jQuery.Event(event);
            jQEvent.type = eventName;
            this.$element.trigger(jQEvent, args);
          };
          proto.select = function(index, isWrap, isInstant) {
            if (!this.isActive) return;
            index = parseInt(index, 10);
            this._wrapSelect(index);
            if (this.isWrapping || isWrap) {
              index = utils.modulo(index, this.slides.length);
            }
            if (!this.slides[index]) return;
            let prevIndex = this.selectedIndex;
            this.selectedIndex = index;
            this.updateSelectedSlide();
            if (isInstant) {
              this.positionSliderAtSelected();
            } else {
              this.startAnimation();
            }
            if (this.options.adaptiveHeight) {
              this.setGallerySize();
            }
            this.dispatchEvent("select", null, [index]);
            if (index !== prevIndex) {
              this.dispatchEvent("change", null, [index]);
            }
          };
          proto._wrapSelect = function(index) {
            if (!this.isWrapping) return;
            const { selectedIndex, slideableWidth, slides: { length } } = this;
            if (!this.isDragSelect) {
              let wrapIndex = utils.modulo(index, length);
              let delta = Math.abs(wrapIndex - selectedIndex);
              let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
              let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
              if (backWrapDelta < delta) {
                index += length;
              } else if (forewardWrapDelta < delta) {
                index -= length;
              }
            }
            if (index < 0) {
              this.x -= slideableWidth;
            } else if (index >= length) {
              this.x += slideableWidth;
            }
          };
          proto.previous = function(isWrap, isInstant) {
            this.select(this.selectedIndex - 1, isWrap, isInstant);
          };
          proto.next = function(isWrap, isInstant) {
            this.select(this.selectedIndex + 1, isWrap, isInstant);
          };
          proto.updateSelectedSlide = function() {
            let slide = this.slides[this.selectedIndex];
            if (!slide) return;
            this.unselectSelectedSlide();
            this.selectedSlide = slide;
            slide.select();
            this.selectedCells = slide.cells;
            this.selectedElements = slide.getCellElements();
            this.selectedCell = slide.cells[0];
            this.selectedElement = this.selectedElements[0];
          };
          proto.unselectSelectedSlide = function() {
            if (this.selectedSlide) this.selectedSlide.unselect();
          };
          proto.selectInitialIndex = function() {
            let initialIndex = this.options.initialIndex;
            if (this.isInitActivated) {
              this.select(this.selectedIndex, false, true);
              return;
            }
            if (initialIndex && typeof initialIndex == "string") {
              let cell = this.queryCell(initialIndex);
              if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
              }
            }
            let index = 0;
            if (initialIndex && this.slides[initialIndex]) {
              index = initialIndex;
            }
            this.select(index, false, true);
          };
          proto.selectCell = function(value, isWrap, isInstant) {
            let cell = this.queryCell(value);
            if (!cell) return;
            let index = this.getCellSlideIndex(cell);
            this.select(index, isWrap, isInstant);
          };
          proto.getCellSlideIndex = function(cell) {
            let cellSlide = this.slides.find((slide) => slide.cells.includes(cell));
            return this.slides.indexOf(cellSlide);
          };
          proto.getCell = function(elem) {
            for (let cell of this.cells) {
              if (cell.element === elem) return cell;
            }
          };
          proto.getCells = function(elems) {
            elems = utils.makeArray(elems);
            return elems.map((elem) => this.getCell(elem)).filter(Boolean);
          };
          proto.getCellElements = function() {
            return this.cells.map((cell) => cell.element);
          };
          proto.getParentCell = function(elem) {
            let cell = this.getCell(elem);
            if (cell) return cell;
            let closest = elem.closest(".flickity-slider > *");
            return this.getCell(closest);
          };
          proto.getAdjacentCellElements = function(adjCount, index) {
            if (!adjCount) return this.selectedSlide.getCellElements();
            index = index === void 0 ? this.selectedIndex : index;
            let len = this.slides.length;
            if (1 + adjCount * 2 >= len) {
              return this.getCellElements();
            }
            let cellElems = [];
            for (let i = index - adjCount; i <= index + adjCount; i++) {
              let slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
              let slide = this.slides[slideIndex];
              if (slide) {
                cellElems = cellElems.concat(slide.getCellElements());
              }
            }
            return cellElems;
          };
          proto.queryCell = function(selector) {
            if (typeof selector == "number") {
              return this.cells[selector];
            }
            let isSelectorString = typeof selector == "string" && !selector.match(/^[#.]?[\d/]/);
            if (isSelectorString) {
              selector = this.element.querySelector(selector);
            }
            return this.getCell(selector);
          };
          proto.uiChange = function() {
            this.emitEvent("uiChange");
          };
          proto.onresize = function() {
            this.watchCSS();
            this.resize();
          };
          utils.debounceMethod(Flickity2, "onresize", 150);
          proto.resize = function() {
            if (!this.isActive || this.isAnimating || this.isDragging) return;
            this.getSize();
            if (this.isWrapping) {
              this.x = utils.modulo(this.x, this.slideableWidth);
            }
            this.positionCells();
            this._updateWrapShiftCells();
            this.setGallerySize();
            this.emitEvent("resize");
            let selectedElement = this.selectedElements && this.selectedElements[0];
            this.selectCell(selectedElement, false, true);
          };
          proto.watchCSS = function() {
            if (!this.options.watchCSS) return;
            let afterContent = getComputedStyle2(this.element, ":after").content;
            if (afterContent.includes("flickity")) {
              this.activate();
            } else {
              this.deactivate();
            }
          };
          proto.onkeydown = function(event) {
            let { activeElement } = document;
            let handler = Flickity2.keyboardHandlers[event.key];
            if (!this.options.accessibility || !activeElement || !handler) return;
            let isFocused = this.focusableElems.some((elem) => activeElement === elem);
            if (isFocused) handler.call(this);
          };
          Flickity2.keyboardHandlers = {
            ArrowLeft: function() {
              this.uiChange();
              let leftMethod = this.options.rightToLeft ? "next" : "previous";
              this[leftMethod]();
            },
            ArrowRight: function() {
              this.uiChange();
              let rightMethod = this.options.rightToLeft ? "previous" : "next";
              this[rightMethod]();
            }
          };
          proto.focus = function() {
            this.element.focus({ preventScroll: true });
          };
          proto.deactivate = function() {
            if (!this.isActive) return;
            this.element.classList.remove("flickity-enabled");
            this.element.classList.remove("flickity-rtl");
            this.unselectSelectedSlide();
            this.cells.forEach((cell) => cell.destroy());
            this.viewport.remove();
            this.element.append(...this.slider.children);
            if (this.options.accessibility) {
              this.element.removeAttribute("tabIndex");
              this.element.removeEventListener("keydown", this);
            }
            this.isActive = false;
            this.emitEvent("deactivate");
          };
          proto.destroy = function() {
            this.deactivate();
            window2.removeEventListener("resize", this);
            this.allOff();
            this.emitEvent("destroy");
            if (jQuery && this.$element) {
              jQuery.removeData(this.element, "flickity");
            }
            delete this.element.flickityGUID;
            delete instances[this.guid];
          };
          Object.assign(proto, animatePrototype);
          Flickity2.data = function(elem) {
            elem = utils.getQueryElement(elem);
            if (elem) return instances[elem.flickityGUID];
          };
          utils.htmlInit(Flickity2, "flickity");
          let { jQueryBridget } = window2;
          if (jQuery && jQueryBridget) {
            jQueryBridget("flickity", Flickity2, jQuery);
          }
          Flickity2.setJQuery = function(jq) {
            jQuery = jq;
          };
          Flickity2.Cell = Cell;
          Flickity2.Slide = Slide;
          return Flickity2;
        }
      );
    }
  });

  // node_modules/unidragger/node_modules/ev-emitter/ev-emitter.js
  var require_ev_emitter2 = __commonJS({
    "node_modules/unidragger/node_modules/ev-emitter/ev-emitter.js"(exports, module) {
      (function(global, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory();
        } else {
          global.EvEmitter = factory();
        }
      })(typeof window != "undefined" ? window : exports, function() {
        function EvEmitter() {
        }
        let proto = EvEmitter.prototype;
        proto.on = function(eventName, listener) {
          if (!eventName || !listener) return this;
          let events = this._events = this._events || {};
          let listeners = events[eventName] = events[eventName] || [];
          if (!listeners.includes(listener)) {
            listeners.push(listener);
          }
          return this;
        };
        proto.once = function(eventName, listener) {
          if (!eventName || !listener) return this;
          this.on(eventName, listener);
          let onceEvents = this._onceEvents = this._onceEvents || {};
          let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
          onceListeners[listener] = true;
          return this;
        };
        proto.off = function(eventName, listener) {
          let listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) return this;
          let index = listeners.indexOf(listener);
          if (index != -1) {
            listeners.splice(index, 1);
          }
          return this;
        };
        proto.emitEvent = function(eventName, args) {
          let listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) return this;
          listeners = listeners.slice(0);
          args = args || [];
          let onceListeners = this._onceEvents && this._onceEvents[eventName];
          for (let listener of listeners) {
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
              this.off(eventName, listener);
              delete onceListeners[listener];
            }
            listener.apply(this, args);
          }
          return this;
        };
        proto.allOff = function() {
          delete this._events;
          delete this._onceEvents;
          return this;
        };
        return EvEmitter;
      });
    }
  });

  // node_modules/unidragger/unidragger.js
  var require_unidragger = __commonJS({
    "node_modules/unidragger/unidragger.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(
            window2,
            require_ev_emitter2()
          );
        } else {
          window2.Unidragger = factory(
            window2,
            window2.EvEmitter
          );
        }
      })(typeof window != "undefined" ? window : exports, function factory(window2, EvEmitter) {
        function Unidragger() {
        }
        let proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
        proto.handleEvent = function(event) {
          let method = "on" + event.type;
          if (this[method]) {
            this[method](event);
          }
        };
        let startEvent, activeEvents;
        if ("ontouchstart" in window2) {
          startEvent = "touchstart";
          activeEvents = ["touchmove", "touchend", "touchcancel"];
        } else if (window2.PointerEvent) {
          startEvent = "pointerdown";
          activeEvents = ["pointermove", "pointerup", "pointercancel"];
        } else {
          startEvent = "mousedown";
          activeEvents = ["mousemove", "mouseup"];
        }
        proto.touchActionValue = "none";
        proto.bindHandles = function() {
          this._bindHandles("addEventListener", this.touchActionValue);
        };
        proto.unbindHandles = function() {
          this._bindHandles("removeEventListener", "");
        };
        proto._bindHandles = function(bindMethod, touchAction) {
          this.handles.forEach((handle) => {
            handle[bindMethod](startEvent, this);
            handle[bindMethod]("click", this);
            if (window2.PointerEvent) handle.style.touchAction = touchAction;
          });
        };
        proto.bindActivePointerEvents = function() {
          activeEvents.forEach((eventName) => {
            window2.addEventListener(eventName, this);
          });
        };
        proto.unbindActivePointerEvents = function() {
          activeEvents.forEach((eventName) => {
            window2.removeEventListener(eventName, this);
          });
        };
        proto.withPointer = function(methodName, event) {
          if (event.pointerId === this.pointerIdentifier) {
            this[methodName](event, event);
          }
        };
        proto.withTouch = function(methodName, event) {
          let touch;
          for (let changedTouch of event.changedTouches) {
            if (changedTouch.identifier === this.pointerIdentifier) {
              touch = changedTouch;
            }
          }
          if (touch) this[methodName](event, touch);
        };
        proto.onmousedown = function(event) {
          this.pointerDown(event, event);
        };
        proto.ontouchstart = function(event) {
          this.pointerDown(event, event.changedTouches[0]);
        };
        proto.onpointerdown = function(event) {
          this.pointerDown(event, event);
        };
        const cursorNodes = ["TEXTAREA", "INPUT", "SELECT", "OPTION"];
        const clickTypes = ["radio", "checkbox", "button", "submit", "image", "file"];
        proto.pointerDown = function(event, pointer) {
          let isCursorNode = cursorNodes.includes(event.target.nodeName);
          let isClickType = clickTypes.includes(event.target.type);
          let isOkayElement = !isCursorNode || isClickType;
          let isOkay = !this.isPointerDown && !event.button && isOkayElement;
          if (!isOkay) return;
          this.isPointerDown = true;
          this.pointerIdentifier = pointer.pointerId !== void 0 ? (
            // pointerId for pointer events, touch.indentifier for touch events
            pointer.pointerId
          ) : pointer.identifier;
          this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
          };
          this.bindActivePointerEvents();
          this.emitEvent("pointerDown", [event, pointer]);
        };
        proto.onmousemove = function(event) {
          this.pointerMove(event, event);
        };
        proto.onpointermove = function(event) {
          this.withPointer("pointerMove", event);
        };
        proto.ontouchmove = function(event) {
          this.withTouch("pointerMove", event);
        };
        proto.pointerMove = function(event, pointer) {
          let moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
          };
          this.emitEvent("pointerMove", [event, pointer, moveVector]);
          let isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
          if (isDragStarting) this.dragStart(event, pointer);
          if (this.isDragging) this.dragMove(event, pointer, moveVector);
        };
        proto.hasDragStarted = function(moveVector) {
          return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
        };
        proto.dragStart = function(event, pointer) {
          this.isDragging = true;
          this.isPreventingClicks = true;
          this.emitEvent("dragStart", [event, pointer]);
        };
        proto.dragMove = function(event, pointer, moveVector) {
          this.emitEvent("dragMove", [event, pointer, moveVector]);
        };
        proto.onmouseup = function(event) {
          this.pointerUp(event, event);
        };
        proto.onpointerup = function(event) {
          this.withPointer("pointerUp", event);
        };
        proto.ontouchend = function(event) {
          this.withTouch("pointerUp", event);
        };
        proto.pointerUp = function(event, pointer) {
          this.pointerDone();
          this.emitEvent("pointerUp", [event, pointer]);
          if (this.isDragging) {
            this.dragEnd(event, pointer);
          } else {
            this.staticClick(event, pointer);
          }
        };
        proto.dragEnd = function(event, pointer) {
          this.isDragging = false;
          setTimeout(() => delete this.isPreventingClicks);
          this.emitEvent("dragEnd", [event, pointer]);
        };
        proto.pointerDone = function() {
          this.isPointerDown = false;
          delete this.pointerIdentifier;
          this.unbindActivePointerEvents();
          this.emitEvent("pointerDone");
        };
        proto.onpointercancel = function(event) {
          this.withPointer("pointerCancel", event);
        };
        proto.ontouchcancel = function(event) {
          this.withTouch("pointerCancel", event);
        };
        proto.pointerCancel = function(event, pointer) {
          this.pointerDone();
          this.emitEvent("pointerCancel", [event, pointer]);
        };
        proto.onclick = function(event) {
          if (this.isPreventingClicks) event.preventDefault();
        };
        proto.staticClick = function(event, pointer) {
          let isMouseup = event.type === "mouseup";
          if (isMouseup && this.isIgnoringMouseUp) return;
          this.emitEvent("staticClick", [event, pointer]);
          if (isMouseup) {
            this.isIgnoringMouseUp = true;
            setTimeout(() => {
              delete this.isIgnoringMouseUp;
            }, 400);
          }
        };
        return Unidragger;
      });
    }
  });

  // node_modules/flickity/js/drag.js
  var require_drag = __commonJS({
    "node_modules/flickity/js/drag.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(
            window2,
            require_core(),
            require_unidragger(),
            require_utils()
          );
        } else {
          window2.Flickity = factory(
            window2,
            window2.Flickity,
            window2.Unidragger,
            window2.fizzyUIUtils
          );
        }
      })(
        typeof window != "undefined" ? window : exports,
        function factory(window2, Flickity2, Unidragger, utils) {
          Object.assign(Flickity2.defaults, {
            draggable: ">1",
            dragThreshold: 3
          });
          let proto = Flickity2.prototype;
          Object.assign(proto, Unidragger.prototype);
          proto.touchActionValue = "";
          Flickity2.create.drag = function() {
            this.on("activate", this.onActivateDrag);
            this.on("uiChange", this._uiChangeDrag);
            this.on("deactivate", this.onDeactivateDrag);
            this.on("cellChange", this.updateDraggable);
            this.on("pointerDown", this.handlePointerDown);
            this.on("pointerUp", this.handlePointerUp);
            this.on("pointerDown", this.handlePointerDone);
            this.on("dragStart", this.handleDragStart);
            this.on("dragMove", this.handleDragMove);
            this.on("dragEnd", this.handleDragEnd);
            this.on("staticClick", this.handleStaticClick);
          };
          proto.onActivateDrag = function() {
            this.handles = [this.viewport];
            this.bindHandles();
            this.updateDraggable();
          };
          proto.onDeactivateDrag = function() {
            this.unbindHandles();
            this.element.classList.remove("is-draggable");
          };
          proto.updateDraggable = function() {
            if (this.options.draggable === ">1") {
              this.isDraggable = this.slides.length > 1;
            } else {
              this.isDraggable = this.options.draggable;
            }
            this.element.classList.toggle("is-draggable", this.isDraggable);
          };
          proto._uiChangeDrag = function() {
            delete this.isFreeScrolling;
          };
          proto.handlePointerDown = function(event) {
            if (!this.isDraggable) {
              this.bindActivePointerEvents(event);
              return;
            }
            let isTouchStart = event.type === "touchstart";
            let isTouchPointer = event.pointerType === "touch";
            let isFocusNode = event.target.matches("input, textarea, select");
            if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
            if (!isFocusNode) this.focus();
            if (document.activeElement !== this.element) document.activeElement.blur();
            this.dragX = this.x;
            this.viewport.classList.add("is-pointer-down");
            this.pointerDownScroll = getScrollPosition();
            window2.addEventListener("scroll", this);
            this.bindActivePointerEvents(event);
          };
          proto.hasDragStarted = function(moveVector) {
            return Math.abs(moveVector.x) > this.options.dragThreshold;
          };
          proto.handlePointerUp = function() {
            delete this.isTouchScrolling;
            this.viewport.classList.remove("is-pointer-down");
          };
          proto.handlePointerDone = function() {
            window2.removeEventListener("scroll", this);
            delete this.pointerDownScroll;
          };
          proto.handleDragStart = function() {
            if (!this.isDraggable) return;
            this.dragStartPosition = this.x;
            this.startAnimation();
            window2.removeEventListener("scroll", this);
          };
          proto.handleDragMove = function(event, pointer, moveVector) {
            if (!this.isDraggable) return;
            event.preventDefault();
            this.previousDragX = this.dragX;
            let direction = this.options.rightToLeft ? -1 : 1;
            if (this.isWrapping) moveVector.x %= this.slideableWidth;
            let dragX = this.dragStartPosition + moveVector.x * direction;
            if (!this.isWrapping) {
              let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
              dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
              let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
              dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
            }
            this.dragX = dragX;
            this.dragMoveTime = /* @__PURE__ */ new Date();
          };
          proto.handleDragEnd = function() {
            if (!this.isDraggable) return;
            let { freeScroll } = this.options;
            if (freeScroll) this.isFreeScrolling = true;
            let index = this.dragEndRestingSelect();
            if (freeScroll && !this.isWrapping) {
              let restingX = this.getRestingPosition();
              this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
            } else if (!freeScroll && index === this.selectedIndex) {
              index += this.dragEndBoostSelect();
            }
            delete this.previousDragX;
            this.isDragSelect = this.isWrapping;
            this.select(index);
            delete this.isDragSelect;
          };
          proto.dragEndRestingSelect = function() {
            let restingX = this.getRestingPosition();
            let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
            let positiveResting = this._getClosestResting(restingX, distance, 1);
            let negativeResting = this._getClosestResting(restingX, distance, -1);
            return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
          };
          proto._getClosestResting = function(restingX, distance, increment) {
            let index = this.selectedIndex;
            let minDistance = Infinity;
            let condition = this.options.contain && !this.isWrapping ? (
              // if containing, keep going if distance is equal to minDistance
              (dist, minDist) => dist <= minDist
            ) : (dist, minDist) => dist < minDist;
            while (condition(distance, minDistance)) {
              index += increment;
              minDistance = distance;
              distance = this.getSlideDistance(-restingX, index);
              if (distance === null) break;
              distance = Math.abs(distance);
            }
            return {
              distance: minDistance,
              // selected was previous index
              index: index - increment
            };
          };
          proto.getSlideDistance = function(x, index) {
            let len = this.slides.length;
            let isWrapAround = this.options.wrapAround && len > 1;
            let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
            let slide = this.slides[slideIndex];
            if (!slide) return null;
            let wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
            return x - (slide.target + wrap);
          };
          proto.dragEndBoostSelect = function() {
            if (this.previousDragX === void 0 || !this.dragMoveTime || // or if drag was held for 100 ms
            /* @__PURE__ */ new Date() - this.dragMoveTime > 100) {
              return 0;
            }
            let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
            let delta = this.previousDragX - this.dragX;
            if (distance > 0 && delta > 0) {
              return 1;
            } else if (distance < 0 && delta < 0) {
              return -1;
            }
            return 0;
          };
          proto.onscroll = function() {
            let scroll = getScrollPosition();
            let scrollMoveX = this.pointerDownScroll.x - scroll.x;
            let scrollMoveY = this.pointerDownScroll.y - scroll.y;
            if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
              this.pointerDone();
            }
          };
          function getScrollPosition() {
            return {
              x: window2.pageXOffset,
              y: window2.pageYOffset
            };
          }
          return Flickity2;
        }
      );
    }
  });

  // node_modules/flickity/js/prev-next-button.js
  var require_prev_next_button = __commonJS({
    "node_modules/flickity/js/prev-next-button.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(require_core());
        } else {
          factory(window2.Flickity);
        }
      })(typeof window != "undefined" ? window : exports, function factory(Flickity2) {
        const svgURI = "http://www.w3.org/2000/svg";
        function PrevNextButton(increment, direction, arrowShape) {
          this.increment = increment;
          this.direction = direction;
          this.isPrevious = increment === "previous";
          this.isLeft = direction === "left";
          this._create(arrowShape);
        }
        PrevNextButton.prototype._create = function(arrowShape) {
          let element = this.element = document.createElement("button");
          element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
          let label = this.isPrevious ? "Previous" : "Next";
          element.setAttribute("type", "button");
          element.setAttribute("aria-label", label);
          this.disable();
          let svg = this.createSVG(label, arrowShape);
          element.append(svg);
        };
        PrevNextButton.prototype.createSVG = function(label, arrowShape) {
          let svg = document.createElementNS(svgURI, "svg");
          svg.setAttribute("class", "flickity-button-icon");
          svg.setAttribute("viewBox", "0 0 100 100");
          let title = document.createElementNS(svgURI, "title");
          title.append(label);
          let path = document.createElementNS(svgURI, "path");
          let pathMovements = getArrowMovements(arrowShape);
          path.setAttribute("d", pathMovements);
          path.setAttribute("class", "arrow");
          if (!this.isLeft) {
            path.setAttribute("transform", "translate(100, 100) rotate(180)");
          }
          svg.append(title, path);
          return svg;
        };
        function getArrowMovements(shape) {
          if (typeof shape == "string") return shape;
          let { x0, x1, x2, x3, y1, y2 } = shape;
          return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
        }
        PrevNextButton.prototype.enable = function() {
          this.element.removeAttribute("disabled");
        };
        PrevNextButton.prototype.disable = function() {
          this.element.setAttribute("disabled", true);
        };
        Object.assign(Flickity2.defaults, {
          prevNextButtons: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
          }
        });
        Flickity2.create.prevNextButtons = function() {
          if (!this.options.prevNextButtons) return;
          let { rightToLeft, arrowShape } = this.options;
          let prevDirection = rightToLeft ? "right" : "left";
          let nextDirection = rightToLeft ? "left" : "right";
          this.prevButton = new PrevNextButton("previous", prevDirection, arrowShape);
          this.nextButton = new PrevNextButton("next", nextDirection, arrowShape);
          this.focusableElems.push(this.prevButton.element);
          this.focusableElems.push(this.nextButton.element);
          this.handlePrevButtonClick = () => {
            this.uiChange();
            this.previous();
          };
          this.handleNextButtonClick = () => {
            this.uiChange();
            this.next();
          };
          this.on("activate", this.activatePrevNextButtons);
          this.on("select", this.updatePrevNextButtons);
        };
        let proto = Flickity2.prototype;
        proto.updatePrevNextButtons = function() {
          let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
          this.updatePrevNextButton(this.prevButton, 0);
          this.updatePrevNextButton(this.nextButton, lastIndex);
        };
        proto.updatePrevNextButton = function(button, disabledIndex) {
          if (this.isWrapping && this.slides.length > 1) {
            button.enable();
            return;
          }
          let isEnabled = this.selectedIndex !== disabledIndex;
          button[isEnabled ? "enable" : "disable"]();
          let isDisabledFocused = !isEnabled && document.activeElement === button.element;
          if (isDisabledFocused) this.focus();
        };
        proto.activatePrevNextButtons = function() {
          this.prevButton.element.addEventListener("click", this.handlePrevButtonClick);
          this.nextButton.element.addEventListener("click", this.handleNextButtonClick);
          this.element.append(this.prevButton.element, this.nextButton.element);
          this.on("deactivate", this.deactivatePrevNextButtons);
        };
        proto.deactivatePrevNextButtons = function() {
          this.prevButton.element.remove();
          this.nextButton.element.remove();
          this.prevButton.element.removeEventListener("click", this.handlePrevButtonClick);
          this.nextButton.element.removeEventListener("click", this.handleNextButtonClick);
          this.off("deactivate", this.deactivatePrevNextButtons);
        };
        Flickity2.PrevNextButton = PrevNextButton;
        return Flickity2;
      });
    }
  });

  // node_modules/flickity/js/page-dots.js
  var require_page_dots = __commonJS({
    "node_modules/flickity/js/page-dots.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(
            require_core(),
            require_utils()
          );
        } else {
          factory(
            window2.Flickity,
            window2.fizzyUIUtils
          );
        }
      })(typeof window != "undefined" ? window : exports, function factory(Flickity2, utils) {
        function PageDots() {
          this.holder = document.createElement("div");
          this.holder.className = "flickity-page-dots";
          this.dots = [];
        }
        PageDots.prototype.setDots = function(slidesLength) {
          let delta = slidesLength - this.dots.length;
          if (delta > 0) {
            this.addDots(delta);
          } else if (delta < 0) {
            this.removeDots(-delta);
          }
        };
        PageDots.prototype.addDots = function(count) {
          let newDots = new Array(count).fill().map((item, i) => {
            let dot = document.createElement("button");
            dot.setAttribute("type", "button");
            let num = i + 1 + this.dots.length;
            dot.className = "flickity-page-dot";
            dot.textContent = `View slide ${num}`;
            return dot;
          });
          this.holder.append(...newDots);
          this.dots = this.dots.concat(newDots);
        };
        PageDots.prototype.removeDots = function(count) {
          let removeDots = this.dots.splice(this.dots.length - count, count);
          removeDots.forEach((dot) => dot.remove());
        };
        PageDots.prototype.updateSelected = function(index) {
          if (this.selectedDot) {
            this.selectedDot.classList.remove("is-selected");
            this.selectedDot.removeAttribute("aria-current");
          }
          if (!this.dots.length) return;
          this.selectedDot = this.dots[index];
          this.selectedDot.classList.add("is-selected");
          this.selectedDot.setAttribute("aria-current", "step");
        };
        Flickity2.PageDots = PageDots;
        Object.assign(Flickity2.defaults, {
          pageDots: true
        });
        Flickity2.create.pageDots = function() {
          if (!this.options.pageDots) return;
          this.pageDots = new PageDots();
          this.handlePageDotsClick = this.onPageDotsClick.bind(this);
          this.on("activate", this.activatePageDots);
          this.on("select", this.updateSelectedPageDots);
          this.on("cellChange", this.updatePageDots);
          this.on("resize", this.updatePageDots);
          this.on("deactivate", this.deactivatePageDots);
        };
        let proto = Flickity2.prototype;
        proto.activatePageDots = function() {
          this.pageDots.setDots(this.slides.length);
          this.focusableElems.push(...this.pageDots.dots);
          this.pageDots.holder.addEventListener("click", this.handlePageDotsClick);
          this.element.append(this.pageDots.holder);
        };
        proto.onPageDotsClick = function(event) {
          let index = this.pageDots.dots.indexOf(event.target);
          if (index === -1) return;
          this.uiChange();
          this.select(index);
        };
        proto.updateSelectedPageDots = function() {
          this.pageDots.updateSelected(this.selectedIndex);
        };
        proto.updatePageDots = function() {
          this.pageDots.dots.forEach((dot) => {
            utils.removeFrom(this.focusableElems, dot);
          });
          this.pageDots.setDots(this.slides.length);
          this.focusableElems.push(...this.pageDots.dots);
        };
        proto.deactivatePageDots = function() {
          this.pageDots.holder.remove();
          this.pageDots.holder.removeEventListener("click", this.handlePageDotsClick);
        };
        Flickity2.PageDots = PageDots;
        return Flickity2;
      });
    }
  });

  // node_modules/flickity/js/player.js
  var require_player = __commonJS({
    "node_modules/flickity/js/player.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(require_core());
        } else {
          factory(window2.Flickity);
        }
      })(typeof window != "undefined" ? window : exports, function factory(Flickity2) {
        function Player(autoPlay, onTick) {
          this.autoPlay = autoPlay;
          this.onTick = onTick;
          this.state = "stopped";
          this.onVisibilityChange = this.visibilityChange.bind(this);
          this.onVisibilityPlay = this.visibilityPlay.bind(this);
        }
        Player.prototype.play = function() {
          if (this.state === "playing") return;
          let isPageHidden = document.hidden;
          if (isPageHidden) {
            document.addEventListener("visibilitychange", this.onVisibilityPlay);
            return;
          }
          this.state = "playing";
          document.addEventListener("visibilitychange", this.onVisibilityChange);
          this.tick();
        };
        Player.prototype.tick = function() {
          if (this.state !== "playing") return;
          let time = typeof this.autoPlay == "number" ? this.autoPlay : 3e3;
          this.clear();
          this.timeout = setTimeout(() => {
            this.onTick();
            this.tick();
          }, time);
        };
        Player.prototype.stop = function() {
          this.state = "stopped";
          this.clear();
          document.removeEventListener("visibilitychange", this.onVisibilityChange);
        };
        Player.prototype.clear = function() {
          clearTimeout(this.timeout);
        };
        Player.prototype.pause = function() {
          if (this.state === "playing") {
            this.state = "paused";
            this.clear();
          }
        };
        Player.prototype.unpause = function() {
          if (this.state === "paused") this.play();
        };
        Player.prototype.visibilityChange = function() {
          let isPageHidden = document.hidden;
          this[isPageHidden ? "pause" : "unpause"]();
        };
        Player.prototype.visibilityPlay = function() {
          this.play();
          document.removeEventListener("visibilitychange", this.onVisibilityPlay);
        };
        Object.assign(Flickity2.defaults, {
          pauseAutoPlayOnHover: true
        });
        Flickity2.create.player = function() {
          this.player = new Player(this.options.autoPlay, () => {
            this.next(true);
          });
          this.on("activate", this.activatePlayer);
          this.on("uiChange", this.stopPlayer);
          this.on("pointerDown", this.stopPlayer);
          this.on("deactivate", this.deactivatePlayer);
        };
        let proto = Flickity2.prototype;
        proto.activatePlayer = function() {
          if (!this.options.autoPlay) return;
          this.player.play();
          this.element.addEventListener("mouseenter", this);
        };
        proto.playPlayer = function() {
          this.player.play();
        };
        proto.stopPlayer = function() {
          this.player.stop();
        };
        proto.pausePlayer = function() {
          this.player.pause();
        };
        proto.unpausePlayer = function() {
          this.player.unpause();
        };
        proto.deactivatePlayer = function() {
          this.player.stop();
          this.element.removeEventListener("mouseenter", this);
        };
        proto.onmouseenter = function() {
          if (!this.options.pauseAutoPlayOnHover) return;
          this.player.pause();
          this.element.addEventListener("mouseleave", this);
        };
        proto.onmouseleave = function() {
          this.player.unpause();
          this.element.removeEventListener("mouseleave", this);
        };
        Flickity2.Player = Player;
        return Flickity2;
      });
    }
  });

  // node_modules/flickity/js/add-remove-cell.js
  var require_add_remove_cell = __commonJS({
    "node_modules/flickity/js/add-remove-cell.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(
            require_core(),
            require_utils()
          );
        } else {
          factory(
            window2.Flickity,
            window2.fizzyUIUtils
          );
        }
      })(typeof window != "undefined" ? window : exports, function factory(Flickity2, utils) {
        function getCellsFragment(cells) {
          let fragment = document.createDocumentFragment();
          cells.forEach((cell) => fragment.appendChild(cell.element));
          return fragment;
        }
        let proto = Flickity2.prototype;
        proto.insert = function(elems, index) {
          let cells = this._makeCells(elems);
          if (!cells || !cells.length) return;
          let len = this.cells.length;
          index = index === void 0 ? len : index;
          let fragment = getCellsFragment(cells);
          let isAppend = index === len;
          if (isAppend) {
            this.slider.appendChild(fragment);
          } else {
            let insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
          }
          if (index === 0) {
            this.cells = cells.concat(this.cells);
          } else if (isAppend) {
            this.cells = this.cells.concat(cells);
          } else {
            let endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
          }
          this._sizeCells(cells);
          this.cellChange(index);
          this.positionSliderAtSelected();
        };
        proto.append = function(elems) {
          this.insert(elems, this.cells.length);
        };
        proto.prepend = function(elems) {
          this.insert(elems, 0);
        };
        proto.remove = function(elems) {
          let cells = this.getCells(elems);
          if (!cells || !cells.length) return;
          let minCellIndex = this.cells.length - 1;
          cells.forEach((cell) => {
            cell.remove();
            let index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
          });
          this.cellChange(minCellIndex);
          this.positionSliderAtSelected();
        };
        proto.cellSizeChange = function(elem) {
          let cell = this.getCell(elem);
          if (!cell) return;
          cell.getSize();
          let index = this.cells.indexOf(cell);
          this.cellChange(index);
        };
        proto.cellChange = function(changedCellIndex) {
          let prevSelectedElem = this.selectedElement;
          this._positionCells(changedCellIndex);
          this._updateWrapShiftCells();
          this.setGallerySize();
          let cell = this.getCell(prevSelectedElem);
          if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
          this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
          this.emitEvent("cellChange", [changedCellIndex]);
          this.select(this.selectedIndex);
        };
        return Flickity2;
      });
    }
  });

  // node_modules/flickity/js/lazyload.js
  var require_lazyload = __commonJS({
    "node_modules/flickity/js/lazyload.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(
            require_core(),
            require_utils()
          );
        } else {
          factory(
            window2.Flickity,
            window2.fizzyUIUtils
          );
        }
      })(typeof window != "undefined" ? window : exports, function factory(Flickity2, utils) {
        const lazyAttr = "data-flickity-lazyload";
        const lazySrcAttr = `${lazyAttr}-src`;
        const lazySrcsetAttr = `${lazyAttr}-srcset`;
        const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;
        Flickity2.create.lazyLoad = function() {
          this.on("select", this.lazyLoad);
          this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
        };
        let proto = Flickity2.prototype;
        proto.lazyLoad = function() {
          let { lazyLoad } = this.options;
          if (!lazyLoad) return;
          let adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
          this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach((img) => new LazyLoader(img, this.handleLazyLoadComplete));
        };
        function getCellLazyImages(cellElem) {
          if (cellElem.matches("img")) {
            let cellAttr = cellElem.getAttribute(lazyAttr);
            let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
            let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
            if (cellAttr || cellSrcAttr || cellSrcsetAttr) {
              return cellElem;
            }
          }
          return [...cellElem.querySelectorAll(imgSelector)];
        }
        proto.onLazyLoadComplete = function(img, event) {
          let cell = this.getParentCell(img);
          let cellElem = cell && cell.element;
          this.cellSizeChange(cellElem);
          this.dispatchEvent("lazyLoad", event, cellElem);
        };
        function LazyLoader(img, onComplete) {
          this.img = img;
          this.onComplete = onComplete;
          this.load();
        }
        LazyLoader.prototype.handleEvent = utils.handleEvent;
        LazyLoader.prototype.load = function() {
          this.img.addEventListener("load", this);
          this.img.addEventListener("error", this);
          let src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
          let srcset = this.img.getAttribute(lazySrcsetAttr);
          this.img.src = src;
          if (srcset) this.img.setAttribute("srcset", srcset);
          this.img.removeAttribute(lazyAttr);
          this.img.removeAttribute(lazySrcAttr);
          this.img.removeAttribute(lazySrcsetAttr);
        };
        LazyLoader.prototype.onload = function(event) {
          this.complete(event, "flickity-lazyloaded");
        };
        LazyLoader.prototype.onerror = function(event) {
          this.complete(event, "flickity-lazyerror");
        };
        LazyLoader.prototype.complete = function(event, className) {
          this.img.removeEventListener("load", this);
          this.img.removeEventListener("error", this);
          let mediaElem = this.img.parentNode.matches("picture") ? this.img.parentNode : this.img;
          mediaElem.classList.add(className);
          this.onComplete(this.img, event);
        };
        Flickity2.LazyLoader = LazyLoader;
        return Flickity2;
      });
    }
  });

  // node_modules/flickity/node_modules/imagesloaded/imagesloaded.js
  var require_imagesloaded = __commonJS({
    "node_modules/flickity/node_modules/imagesloaded/imagesloaded.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(window2, require_ev_emitter());
        } else {
          window2.imagesLoaded = factory(window2, window2.EvEmitter);
        }
      })(
        typeof window !== "undefined" ? window : exports,
        function factory(window2, EvEmitter) {
          let $ = window2.jQuery;
          let console2 = window2.console;
          function makeArray(obj) {
            if (Array.isArray(obj)) return obj;
            let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
            if (isArrayLike) return [...obj];
            return [obj];
          }
          function ImagesLoaded(elem, options, onAlways) {
            if (!(this instanceof ImagesLoaded)) {
              return new ImagesLoaded(elem, options, onAlways);
            }
            let queryElem = elem;
            if (typeof elem == "string") {
              queryElem = document.querySelectorAll(elem);
            }
            if (!queryElem) {
              console2.error(`Bad element for imagesLoaded ${queryElem || elem}`);
              return;
            }
            this.elements = makeArray(queryElem);
            this.options = {};
            if (typeof options == "function") {
              onAlways = options;
            } else {
              Object.assign(this.options, options);
            }
            if (onAlways) this.on("always", onAlways);
            this.getImages();
            if ($) this.jqDeferred = new $.Deferred();
            setTimeout(this.check.bind(this));
          }
          ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
          ImagesLoaded.prototype.getImages = function() {
            this.images = [];
            this.elements.forEach(this.addElementImages, this);
          };
          const elementNodeTypes = [1, 9, 11];
          ImagesLoaded.prototype.addElementImages = function(elem) {
            if (elem.nodeName === "IMG") {
              this.addImage(elem);
            }
            if (this.options.background === true) {
              this.addElementBackgroundImages(elem);
            }
            let { nodeType } = elem;
            if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
            let childImgs = elem.querySelectorAll("img");
            for (let img of childImgs) {
              this.addImage(img);
            }
            if (typeof this.options.background == "string") {
              let children = elem.querySelectorAll(this.options.background);
              for (let child of children) {
                this.addElementBackgroundImages(child);
              }
            }
          };
          const reURL = /url\((['"])?(.*?)\1\)/gi;
          ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
            let style = getComputedStyle(elem);
            if (!style) return;
            let matches = reURL.exec(style.backgroundImage);
            while (matches !== null) {
              let url = matches && matches[2];
              if (url) {
                this.addBackground(url, elem);
              }
              matches = reURL.exec(style.backgroundImage);
            }
          };
          ImagesLoaded.prototype.addImage = function(img) {
            let loadingImage = new LoadingImage(img);
            this.images.push(loadingImage);
          };
          ImagesLoaded.prototype.addBackground = function(url, elem) {
            let background = new Background(url, elem);
            this.images.push(background);
          };
          ImagesLoaded.prototype.check = function() {
            this.progressedCount = 0;
            this.hasAnyBroken = false;
            if (!this.images.length) {
              this.complete();
              return;
            }
            let onProgress = (image, elem, message) => {
              setTimeout(() => {
                this.progress(image, elem, message);
              });
            };
            this.images.forEach(function(loadingImage) {
              loadingImage.once("progress", onProgress);
              loadingImage.check();
            });
          };
          ImagesLoaded.prototype.progress = function(image, elem, message) {
            this.progressedCount++;
            this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
            this.emitEvent("progress", [this, image, elem]);
            if (this.jqDeferred && this.jqDeferred.notify) {
              this.jqDeferred.notify(this, image);
            }
            if (this.progressedCount === this.images.length) {
              this.complete();
            }
            if (this.options.debug && console2) {
              console2.log(`progress: ${message}`, image, elem);
            }
          };
          ImagesLoaded.prototype.complete = function() {
            let eventName = this.hasAnyBroken ? "fail" : "done";
            this.isComplete = true;
            this.emitEvent(eventName, [this]);
            this.emitEvent("always", [this]);
            if (this.jqDeferred) {
              let jqMethod = this.hasAnyBroken ? "reject" : "resolve";
              this.jqDeferred[jqMethod](this);
            }
          };
          function LoadingImage(img) {
            this.img = img;
          }
          LoadingImage.prototype = Object.create(EvEmitter.prototype);
          LoadingImage.prototype.check = function() {
            let isComplete = this.getIsImageComplete();
            if (isComplete) {
              this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
              return;
            }
            this.proxyImage = new Image();
            if (this.img.crossOrigin) {
              this.proxyImage.crossOrigin = this.img.crossOrigin;
            }
            this.proxyImage.addEventListener("load", this);
            this.proxyImage.addEventListener("error", this);
            this.img.addEventListener("load", this);
            this.img.addEventListener("error", this);
            this.proxyImage.src = this.img.currentSrc || this.img.src;
          };
          LoadingImage.prototype.getIsImageComplete = function() {
            return this.img.complete && this.img.naturalWidth;
          };
          LoadingImage.prototype.confirm = function(isLoaded, message) {
            this.isLoaded = isLoaded;
            let { parentNode } = this.img;
            let elem = parentNode.nodeName === "PICTURE" ? parentNode : this.img;
            this.emitEvent("progress", [this, elem, message]);
          };
          LoadingImage.prototype.handleEvent = function(event) {
            let method = "on" + event.type;
            if (this[method]) {
              this[method](event);
            }
          };
          LoadingImage.prototype.onload = function() {
            this.confirm(true, "onload");
            this.unbindEvents();
          };
          LoadingImage.prototype.onerror = function() {
            this.confirm(false, "onerror");
            this.unbindEvents();
          };
          LoadingImage.prototype.unbindEvents = function() {
            this.proxyImage.removeEventListener("load", this);
            this.proxyImage.removeEventListener("error", this);
            this.img.removeEventListener("load", this);
            this.img.removeEventListener("error", this);
          };
          function Background(url, element) {
            this.url = url;
            this.element = element;
            this.img = new Image();
          }
          Background.prototype = Object.create(LoadingImage.prototype);
          Background.prototype.check = function() {
            this.img.addEventListener("load", this);
            this.img.addEventListener("error", this);
            this.img.src = this.url;
            let isComplete = this.getIsImageComplete();
            if (isComplete) {
              this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
              this.unbindEvents();
            }
          };
          Background.prototype.unbindEvents = function() {
            this.img.removeEventListener("load", this);
            this.img.removeEventListener("error", this);
          };
          Background.prototype.confirm = function(isLoaded, message) {
            this.isLoaded = isLoaded;
            this.emitEvent("progress", [this, this.element, message]);
          };
          ImagesLoaded.makeJQueryPlugin = function(jQuery) {
            jQuery = jQuery || window2.jQuery;
            if (!jQuery) return;
            $ = jQuery;
            $.fn.imagesLoaded = function(options, onAlways) {
              let instance = new ImagesLoaded(this, options, onAlways);
              return instance.jqDeferred.promise($(this));
            };
          };
          ImagesLoaded.makeJQueryPlugin();
          return ImagesLoaded;
        }
      );
    }
  });

  // node_modules/flickity/js/imagesloaded.js
  var require_imagesloaded2 = __commonJS({
    "node_modules/flickity/js/imagesloaded.js"(exports, module) {
      (function(window2, factory) {
        if (typeof module == "object" && module.exports) {
          module.exports = factory(
            require_core(),
            require_imagesloaded()
          );
        } else {
          factory(
            window2.Flickity,
            window2.imagesLoaded
          );
        }
      })(
        typeof window != "undefined" ? window : exports,
        function factory(Flickity2, imagesLoaded) {
          Flickity2.create.imagesLoaded = function() {
            this.on("activate", this.imagesLoaded);
          };
          Flickity2.prototype.imagesLoaded = function() {
            if (!this.options.imagesLoaded) return;
            let onImagesLoadedProgress = (instance, image) => {
              let cell = this.getParentCell(image.img);
              this.cellSizeChange(cell && cell.element);
              if (!this.options.freeScroll) this.positionSliderAtSelected();
            };
            imagesLoaded(this.slider).on("progress", onImagesLoadedProgress);
          };
          return Flickity2;
        }
      );
    }
  });

  // node_modules/flickity/js/index.js
  var require_js = __commonJS({
    "node_modules/flickity/js/index.js"(exports, module) {
      if (typeof module == "object" && module.exports) {
        const Flickity2 = require_core();
        require_drag();
        require_prev_next_button();
        require_page_dots();
        require_player();
        require_add_remove_cell();
        require_lazyload();
        require_imagesloaded2();
        module.exports = Flickity2;
      }
    }
  });

  // src/scripts/components/custom-tabs.js
  var CustomTabs = class {
    constructor(container) {
      this.container = container;
      this.tabList = this.container.querySelector(".js-tablist");
      this.tabLinks = this.container.querySelectorAll(".js-tablist__link");
      this.tabPanels = this.container.querySelectorAll(".js-tabcontent");
      this.init();
    }
    init() {
      if (!this.tabList || !this.tabLinks.length || !this.tabPanels.length) {
        console.warn("CustomTabs: Required elements not found", {
          tabList: !!this.tabList,
          tabLinks: this.tabLinks.length,
          tabPanels: this.tabPanels.length
        });
        return;
      }
      this.setupAccessibility();
      this.bindEvents();
    }
    setupAccessibility() {
      this.tabList.setAttribute("role", "tablist");
      let preselectedTab = null;
      this.tabLinks.forEach((link) => {
        const ariaSelected = link.getAttribute("aria-selected");
        if (ariaSelected === "true") {
          preselectedTab = link;
        }
      });
      if (!preselectedTab && this.tabLinks.length > 0) {
        preselectedTab = this.tabLinks[0];
      }
      this.tabLinks.forEach((link, index) => {
        const panel = this.tabPanels[index];
        const tabId = `tab-${this.container.id || "custom"}-${index}`;
        const panelId = `panel-${this.container.id || "custom"}-${index}`;
        const isSelected = link === preselectedTab;
        link.setAttribute("role", "tab");
        link.setAttribute("id", tabId);
        link.setAttribute("aria-selected", isSelected);
        link.setAttribute("aria-controls", panelId);
        link.setAttribute("tabindex", isSelected ? "0" : "-1");
        if (panel) {
          panel.setAttribute("role", "tabpanel");
          panel.setAttribute("id", panelId);
          panel.setAttribute("aria-labelledby", tabId);
          panel.setAttribute("aria-hidden", !isSelected);
          if (!isSelected) {
            panel.setAttribute("tabindex", "-1");
          }
        }
      });
    }
    bindEvents() {
      this.tabLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          this.activateTab(link);
        });
        link.addEventListener("keydown", (event) => {
          this.handleKeydown(event, link);
        });
      });
    }
    handleKeydown(event, currentTab) {
      const tabIndex = Array.from(this.tabLinks).indexOf(currentTab);
      let targetTab;
      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          targetTab = this.tabLinks[tabIndex - 1] || this.tabLinks[this.tabLinks.length - 1];
          this.activateTab(targetTab);
          break;
        case "ArrowRight":
          event.preventDefault();
          targetTab = this.tabLinks[tabIndex + 1] || this.tabLinks[0];
          this.activateTab(targetTab);
          break;
        case "Home":
          event.preventDefault();
          this.activateTab(this.tabLinks[0]);
          break;
        case "End":
          event.preventDefault();
          this.activateTab(this.tabLinks[this.tabLinks.length - 1]);
          break;
      }
    }
    activateTab(selectedTab) {
      const selectedIndex = Array.from(this.tabLinks).indexOf(selectedTab);
      const selectedPanel = this.tabPanels[selectedIndex];
      if (!selectedPanel) {
        console.warn("CustomTabs: Panel not found for tab", selectedTab);
        return;
      }
      this.tabLinks.forEach((link, index) => {
        const isSelected = index === selectedIndex;
        link.setAttribute("aria-selected", isSelected);
        link.setAttribute("tabindex", isSelected ? "0" : "-1");
      });
      this.tabPanels.forEach((panel, index) => {
        const isSelected = index === selectedIndex;
        panel.setAttribute("aria-hidden", !isSelected);
        if (isSelected) {
          panel.removeAttribute("tabindex");
        } else {
          panel.setAttribute("tabindex", "-1");
        }
      });
      selectedTab.focus();
    }
    // Public method to activate tab by index
    activateTabByIndex(index) {
      const tab = this.tabLinks[index];
      if (tab) {
        this.activateTab(tab);
      }
    }
    // Public method to activate tab by ID
    activateTabById(tabId) {
      const tab = this.container.querySelector(`#${tabId}`);
      if (tab) {
        this.activateTab(tab);
      }
    }
  };
  function initCustomTabs() {
    const tabContainers = document.querySelectorAll(".js-tabs");
    tabContainers.forEach((container) => {
      new CustomTabs(container);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCustomTabs);
  } else {
    initCustomTabs();
  }

  // src/scripts/sections/cart-drawer-recommendations.js
  var import_flickity = __toESM(require_js(), 1);

  // src/scripts/components/tagalys-init.js
  var TAGALYS_QA_HOST = "superette-development.myshopify.com";
  var TAGALYS_QA_QUERY_PARAM = "twp_tagalys_qa";
  var isTagalysQaRequest = (location = window.location) => location.hostname === TAGALYS_QA_HOST && new URLSearchParams(location.search).get(TAGALYS_QA_QUERY_PARAM) === "1";
  var isTagalysConfigValid = ({ sdkUrl, serverUrl, clientCode, apiKey, storeId }) => sdkUrl && serverUrl && clientCode && apiKey && storeId;
  var isTagalysEnabled = ({ enable = false }) => enable;
  var setTagalysConfiguration = ({ enable, serverUrl, clientCode, apiKey, storeId }) => {
    var _a4, _b3, _c, _d;
    if (!enable || !serverUrl || !clientCode || !apiKey || !storeId) return;
    const language = (_a4 = window.theme.locale.isoCode) != null ? _a4 : "en";
    const country = (_b3 = window.theme.localization.country) != null ? _b3 : "NZ";
    window.Tagalys.setConfiguration({
      api: {
        serverUrl,
        credentials: {
          clientCode,
          apiKey
        },
        storeId
      },
      locale: `${language}-${country}`,
      currency: {
        displayFormatter: "{{currencyLabel}}{{value}}",
        code: (_c = window.theme.localization.currency) != null ? _c : "NZD",
        label: (_d = window.theme.localization.currencySymbol) != null ? _d : "$",
        fractionalDigits: 2,
        forceFractionalDigits: true
      },
      analyticsStorageConsentProvided() {
        return true;
      },
      track: true
    });
  };
  var setPlatformConfigurationForTagalys = ({ enable, storefrontApiAccessToken }) => {
    var _a4, _b3;
    if (!enable) return;
    const qaRequest = isTagalysQaRequest();
    const storefrontAccessToken = qaRequest ? null : storefrontApiAccessToken;
    const productMetafields = [
      {
        namespace: "card",
        key: "badge"
      },
      {
        namespace: "card",
        key: "message"
      }
    ];
    window.Tagalys.setPlatformConfiguration({
      platform: "Shopify",
      countryCode: (_a4 = window.theme.localization.country) != null ? _a4 : "NZ",
      baseCountryCode: (_b3 = window.theme.localization.baseCountry) != null ? _b3 : "NZ",
      useStorefrontAPIForSecondaryMarkets: Boolean(storefrontAccessToken),
      waitForStorefrontAPI: Boolean(storefrontAccessToken),
      storefrontAPI: {
        accessToken: storefrontAccessToken,
        myShopifyDomain: window.Shopify.shop
      },
      metafields: {
        products: productMetafields
      }
    });
  };
  var onTagalysReady = (callback) => {
    const checkTagalys = setInterval(() => {
      if (!window.Tagalys || !window.tagalysReady) {
        window.console.warn("TWP | onTagalysReady | Tagalys is not ready");
        return;
      }
      clearInterval(checkTagalys);
      if (typeof callback === "function") {
        callback();
      }
    }, 150);
  };
  var initTagalys = () => {
    const tagalysConfig = window.theme.tagalys;
    if (!tagalysConfig || !isTagalysConfigValid(tagalysConfig) || !isTagalysEnabled(tagalysConfig)) {
      return;
    }
    const checkTagalys = setInterval(() => {
      if (!window.Tagalys) {
        window.console.error("TWP | tagalysInit | Tagalys has not loaded");
        return;
      }
      clearInterval(checkTagalys);
      setTagalysConfiguration(window.theme.tagalys);
      setPlatformConfigurationForTagalys(window.theme.tagalys);
      window.tagalysReady = true;
      document.dispatchEvent(new Event("tagalys:ready"));
    }, 150);
  };

  // src/scripts/utils/tagalys.js
  var constructLocalisedProductLink = (product) => {
    const marketRoot = window.theme.locale.rootUrl === "/" ? "" : window.theme.locale.rootUrl;
    return `${window.location.origin}${marketRoot}/products/${product.handle}`;
  };
  var decodeHtmlEntities = (text) => {
    if (!text) return "";
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  };

  // src/scripts/utils/shopify-images.js
  var imageUrl = (url, width, height, crop) => {
    if (!url || !(width || height)) return null;
    if (width && typeof width !== "number") return null;
    if (height && typeof height !== "number") return null;
    if (crop && typeof crop !== "string") return null;
    try {
      const urlObj = new URL(url, window.location.origin);
      const params = urlObj.searchParams;
      const currentWidth = params.get("width");
      const currentHeight = params.get("height");
      const currentCrop = params.get("crop");
      if (!height && currentHeight) params.delete("height");
      if (!width && currentWidth) params.delete("width");
      if (!crop && currentCrop) params.delete("crop");
      if (width) params.set("width", width);
      if (height) params.set("height", height);
      if (crop) params.set("crop", crop);
      return urlObj.href;
    } catch (e) {
      return null;
    }
  };

  // src/scripts/components/responsive-image.js
  var responsiveImage = (image, imageAlt, maxWidth, lazyload = true, sizes = "") => {
    const widths = [160, 320, 480, 640, 800, 960, 1120, 1280, 1440, 1600, 1920, 2240, 2560];
    let srcset = "";
    widths.forEach((width, index) => {
      if (width > maxWidth) return;
      const src = imageUrl(image.src, width);
      if (index > 0) {
        srcset += ", ";
      }
      srcset += `${src} ${width}w`;
    });
    return `
    <img
      class="component-image__image"
      src="${imageUrl(image.src, 480)}"
      srcset="${srcset}"
      loading="${lazyload ? "lazy" : "eager"}"
      sizes="${sizes}"
      width="${image.width}"
      height="${image.height}"
      alt="${imageAlt}"
    />`;
  };
  var responsive_image_default = responsiveImage;

  // src/scripts/components/product-card-template/product-card-media.js
  var renderProductCardMedia = (product, productLink) => {
    var _a4, _b3, _c;
    const imgAspectRatio = "2-3";
    const imgMaxWidth = "1120";
    const imgSizes = "(min-width: 61.875rem) 26.5vw, (min-width: 48rem) 35vw, 90vw";
    const imgDefaultAlt = product.title;
    const showSecondaryImages = (_b3 = (_a4 = window.theme) == null ? void 0 : _a4.productCard) == null ? void 0 : _b3.showSecondaryImages;
    const productImages = product.images;
    const featuredImage = productImages[0];
    const featuredImageAlt = (_c = featuredImage == null ? void 0 : featuredImage.alt) != null ? _c : imgDefaultAlt;
    const featuredImageMarkup = productImages.length > 1 ? `${responsive_image_default(featuredImage, featuredImageAlt, imgMaxWidth, true, imgSizes, imgAspectRatio)}
    ${responsive_image_default(productImages[1], featuredImageAlt, imgMaxWidth, true, imgSizes, imgAspectRatio)}` : `
    ${responsive_image_default(featuredImage, featuredImageAlt, imgMaxWidth, true, imgSizes, imgAspectRatio)}`;
    let sliderMarkup = "";
    if (showSecondaryImages && product.images.length > 1) {
      let otherImagesMarkup = "";
      product.images.forEach((image, index) => {
        var _a5;
        if (index === 0) return;
        const imageAlt = (_a5 = image.alt) != null ? _a5 : imgDefaultAlt;
        otherImagesMarkup += `<div class="product-card__slide"><a href=${productLink}>${responsive_image_default(
          image,
          imageAlt,
          imgMaxWidth,
          true,
          imgSizes,
          imgAspectRatio
        )}</a></div>`;
      });
      sliderMarkup = `<div class="product-card__slider" data-slider>
      <div class="product-card__slide">${featuredImageMarkup}</div>
      ${otherImagesMarkup}
    </div>`;
    }
    if (sliderMarkup) {
      return sliderMarkup;
    }
    return featuredImageMarkup;
  };
  var product_card_media_default = renderProductCardMedia;

  // src/scripts/components/product-card-template/product-card-render.js
  var checkComingSoonEnabled = (product) => {
    var _a4, _b3, _c;
    const hasComingSoonTag = (_a4 = product.tags) == null ? void 0 : _a4.some((tag) => {
      var _a5, _b4;
      return tag.toLowerCase() === ((_b4 = (_a5 = window.theme) == null ? void 0 : _a5.comingSoon) == null ? void 0 : _b4.tag);
    });
    return ((_c = (_b3 = window.theme) == null ? void 0 : _b3.comingSoon) == null ? void 0 : _c.enable) && hasComingSoonTag;
  };
  var checkNotifyMeEnabled = (product) => {
    var _a4, _b3, _c;
    const hasNotifyMeTag = (_a4 = product.tags) == null ? void 0 : _a4.some((tag) => {
      var _a5, _b4;
      return tag.toLowerCase() === ((_b4 = (_a5 = window.theme) == null ? void 0 : _a5.notifyMe) == null ? void 0 : _b4.tag);
    });
    return ((_c = (_b3 = window.theme) == null ? void 0 : _b3.notifyMe) == null ? void 0 : _c.enable) && hasNotifyMeTag;
  };
  var getSizeOption = (product) => {
    var _a4;
    return (_a4 = product.options_with_values) == null ? void 0 : _a4.find((opt) => opt.name === "Size");
  };
  var renderQuickAddDesktop = (product, { suppressNotifyMe = false } = {}) => {
    var _a4, _b3, _c;
    const sizeOption = getSizeOption(product);
    const isComingSoon = checkComingSoonEnabled(product);
    const isNotifyMe = checkNotifyMeEnabled(product);
    const oneSizeLabel = ((_c = (_b3 = (_a4 = window.theme) == null ? void 0 : _a4.strings) == null ? void 0 : _b3.product) == null ? void 0 : _c.oneSize) || "One Size";
    if (!sizeOption) {
      const variant = product.variants[0];
      const isSoldOut = !variant.available;
      const isVariantNotifyMe = !suppressNotifyMe && (isComingSoon || isSoldOut && isNotifyMe);
      return `
      <button
        class="quick-add-inline-desktop__size-btn ${isSoldOut || isComingSoon ? "quick-add-inline-desktop__size-btn--sold-out" : ""}"
        data-variant-id="${variant.id}"
        data-size="${oneSizeLabel}"
        data-product-id="${product.id}"
        type="button"
        ${isSoldOut && !isVariantNotifyMe ? 'disabled aria-disabled="true"' : ""}
        ${isVariantNotifyMe ? `data-notify-me-trigger data-variant-id-notify="${variant.id}"` : ""}
        aria-label="${isVariantNotifyMe ? `Notify me when ${oneSizeLabel} is back in stock` : `Add ${oneSizeLabel} to cart`}"
      >
        <span class="quick-add-inline-desktop__size-text">${isVariantNotifyMe ? "" : oneSizeLabel}</span>
        ${isVariantNotifyMe ? `
          <span class="quick-add-inline-desktop__notify-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <rect x="3.92857" y="4.42857" width="9.14286" height="7.14286" stroke="#B8B9BA" stroke-width="0.857143"/>
              <path d="M3.75 5.42859C4.15 5.42859 7.16667 7.42859 8.5 8.28573L13.25 5.42859" stroke="#B8B9BA" stroke-width="0.857143"/>
            </svg>
          </span>
        ` : '<span class="quick-add-inline-desktop__success-icon" aria-hidden="true">\u2713</span>'}
      </button>
    `;
    }
    return sizeOption.values.map((size) => {
      const variant = product.variants.find((v) => v.option1 === size || v.option2 === size || v.option3 === size);
      if (!variant) return "";
      const isSoldOut = !variant.available;
      const isVariantNotifyMe = !suppressNotifyMe && (isComingSoon || isSoldOut && isNotifyMe);
      return `
      <button
        class="quick-add-inline-desktop__size-btn ${isSoldOut || isComingSoon ? "quick-add-inline-desktop__size-btn--sold-out" : ""}"
        data-variant-id="${variant.id}"
        data-size="${size}"
        data-product-id="${product.id}"
        type="button"
        ${isSoldOut && !isVariantNotifyMe ? 'disabled aria-disabled="true"' : ""}
        ${isVariantNotifyMe ? `data-notify-me-trigger data-variant-id-notify="${variant.id}"` : ""}
        aria-label="${isVariantNotifyMe ? `Notify me when size ${size} is back in stock` : `Add size ${size} to cart`}"
      >
        <span class="quick-add-inline-desktop__size-text">${size}</span>
        ${isVariantNotifyMe ? `
          <span class="quick-add-inline-desktop__notify-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <rect x="3.92857" y="4.42857" width="9.14286" height="7.14286" stroke="#B8B9BA" stroke-width="0.857143"/>
              <path d="M3.75 5.42859C4.15 5.42859 7.16667 7.42859 8.5 8.28573L13.25 5.42859" stroke="#B8B9BA" stroke-width="0.857143"/>
            </svg>
          </span>
        ` : '<span class="quick-add-inline-desktop__success-icon" aria-hidden="true">\u2713</span>'}
      </button>
    `;
    }).join("");
  };
  var renderQuickAddMobile = (product, helpers) => {
    var _a4, _b3, _c, _d;
    const sizeOption = getSizeOption(product);
    const isComingSoon = checkComingSoonEnabled(product);
    const isNotifyMe = checkNotifyMeEnabled(product);
    const oneSizeLabel = ((_c = (_b3 = (_a4 = window.theme) == null ? void 0 : _a4.strings) == null ? void 0 : _b3.product) == null ? void 0 : _c.oneSize) || "One Size";
    const productData = {
      id: product.id,
      title: product.title,
      vendor: product.vendor,
      price: helpers.formatCurrency(product.price),
      compareAtPrice: product.compare_at_price ? helpers.formatCurrency(product.compare_at_price) : null,
      handle: product.handle,
      aspectRatio: 2 / 3,
      // Fixed aspect ratio as per your requirement
      images: ((_d = product.images) == null ? void 0 : _d.slice(0, 5).map((img) => ({
        url: img.src,
        srcset: `${img.src}?w=250 250w, ${img.src}?w=500 500w, ${img.src}?w=750 750w, ${img.src}?w=1000 1000w`,
        alt: img.alt || "",
        width: img.width,
        height: img.height
      }))) || [],
      sizes: !sizeOption ? [
        {
          value: oneSizeLabel,
          variantId: product.variants[0].id,
          available: product.variants[0].available
        }
      ] : sizeOption.values.map((size) => {
        const variant = product.variants.find(
          (v) => v.option1 === size || v.option2 === size || v.option3 === size
        );
        return variant ? {
          value: size,
          variantId: variant.id,
          available: variant.available
        } : null;
      }).filter(Boolean),
      variants: product.variants.map((v) => ({
        id: v.id,
        title: v.title,
        available: v.available
      })),
      isComingSoon,
      isNotifyMe
    };
    return `
    <button
      class="quick-add-inline-mobile__trigger"
      aria-label="Quick add ${product.title}"
      data-quick-add-trigger
      data-product-id="${product.id}"
      data-product-json='${JSON.stringify(productData).replace(/'/g, "&#39;")}'
      type="button"
    >
      <svg class="icon icon--plus" viewBox="0 0 24 24" width="24" height="24">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6 5H11.4V11.4H5V12.6H11.4V19H12.6V12.6H19V11.4H12.6V5Z" fill="currentColor"/>
      </svg>
    </button>
  `;
  };
  var renderQuickAddInline = (product, helpers, { suppressNotifyMe = false } = {}) => {
    var _a4, _b3;
    if (!((_b3 = (_a4 = window.theme) == null ? void 0 : _a4.quickAdd) == null ? void 0 : _b3.enable)) return "";
    if (!product.variants || product.variants.length === 0) return "";
    const sizeOption = getSizeOption(product);
    const variantCount = sizeOption ? sizeOption.values.length : 1;
    let hasLongLabels = false;
    let hasExtraLongLabels = false;
    let hasSuperLongLabels = false;
    if (sizeOption) {
      sizeOption.values.forEach((value) => {
        if (value.length >= 7) {
          hasSuperLongLabels = true;
          hasExtraLongLabels = true;
          hasLongLabels = true;
        } else if (value.length >= 6) {
          hasExtraLongLabels = true;
          hasLongLabels = true;
        } else if (value.length >= 4) {
          hasLongLabels = true;
        }
      });
    }
    let sizeClass = "";
    if (variantCount === 1) {
      sizeClass = " quick-add-inline-desktop__sizes--one-size";
    } else if (hasSuperLongLabels) {
      sizeClass = " quick-add-inline-desktop__sizes--two-columns";
    } else if (variantCount <= 3) {
      sizeClass = " quick-add-inline-desktop__sizes--flex";
    } else if (variantCount === 4 && hasExtraLongLabels) {
      sizeClass = " quick-add-inline-desktop__sizes--three-columns";
    } else if (variantCount === 4) {
      sizeClass = " quick-add-inline-desktop__sizes--flex";
    } else if (hasLongLabels && variantCount === 5) {
      sizeClass = " quick-add-inline-desktop__sizes--three-columns";
    } else if (hasLongLabels && variantCount > 5) {
      sizeClass = " quick-add-inline-desktop__sizes--four-columns";
    } else if (variantCount === 5) {
      sizeClass = " quick-add-inline-desktop__sizes--flex";
    }
    return `
    <quick-add-inline
      class="quick-add-inline"
      data-product-id="${product.id}"
      data-section-id="tagalys-${product.id}"
    >
      <div class="quick-add-inline__desktop small-hide">
        <div class="quick-add-inline-desktop">
          <div class="quick-add-inline-desktop__sizes${sizeClass}">
            ${renderQuickAddDesktop(product, { suppressNotifyMe })}
          </div>
        </div>
      </div>
      <div class="quick-add-inline__mobile medium-up-hide">
        ${renderQuickAddMobile(product, helpers)}
      </div>
    </quick-add-inline>
  `;
  };
  var renderCardBadge = (tags) => {
    var _a4;
    if (!(tags == null ? void 0 : tags.length)) return "";
    const badgeTags = tags.filter((tag) => tag.includes("label:"));
    if (badgeTags.length === 0) return "";
    return `
    <div class="card__badge ${(_a4 = window.theme) == null ? void 0 : _a4.badgePosition}">
      ${badgeTags.map((tag) => {
      const badgeText = tag.replace("label:", "");
      return `<span class="badge">${badgeText}</span>`;
    }).join("")}
    </div>
  `;
  };
  var renderWishlistButton = (product) => {
    var _a4, _b3;
    if (!((_b3 = (_a4 = window.theme) == null ? void 0 : _a4.wishlist) == null ? void 0 : _b3.twpEnable)) return "";
    const wishlistProduct = product;
    wishlistProduct.featured_image = product.images[0].src;
    return `
    <div class="osc-css wrapper-button-collection">
      <div
        class="button-collection-wishlist button-${product.id}"
        data-product-id="${product.id}"
        data-has-only-variant="${product.has_only_default_variant}"
        data-product-title="${product.title}"
      >
        <span class="button-icon"></span>
        <span class="button-text"></span>
      </div>
    </div>
    <script type="application/json" id="ProductJson-${product.id}">
      ${JSON.stringify(product)}
    <\/script>
    <script type="application/json" id="OptionJson-${product.id}">
      ${JSON.stringify(product.options_with_values)}
    <\/script>
  `;
  };
  var renderCardMessage = (metafields) => {
    var _a4, _b3;
    if (!((_b3 = (_a4 = metafields == null ? void 0 : metafields.card) == null ? void 0 : _a4.message) == null ? void 0 : _b3.value)) return "";
    return `<div class="card__message caption">${metafields.card.message.value}</div>`;
  };
  var renderVendor = (vendor) => {
    if (!vendor) return "";
    return `
    <span class="visually-hidden">Vendor</span>
    <div class="caption-with-letter-spacing">${vendor}</div>
  `;
  };
  var renderPrice = (product, helpers, productPrice, productCompareAtPrice) => {
    var _a4, _b3, _c, _d, _e, _f;
    const isOnSale = helpers.isProductOnSale(productCompareAtPrice, productPrice);
    if (product.price_varies) {
      return `
      <span>
        ${(((_c = (_b3 = (_a4 = window.theme) == null ? void 0 : _a4.strings) == null ? void 0 : _b3.product) == null ? void 0 : _c.priceFrom) || "From {{ price }}").replace(
        "{{ price }}",
        helpers.formatCurrency(product.price_min || productPrice)
      )}
      </span>
    `;
    }
    const compareAtPriceHtml = isOnSale ? `
    <span class="visually-hidden">${((_f = (_e = (_d = window.theme) == null ? void 0 : _d.strings) == null ? void 0 : _e.product) == null ? void 0 : _f.regularPrice) || "Regular price"}</span>
    <s data-compare-price>${helpers.formatCurrency(productCompareAtPrice)}</s>
  ` : "";
    return `
    ${compareAtPriceHtml}
    <span data-product-price ${isOnSale ? 'class="product-card__sale-price"' : ""}>
      ${helpers.formatCurrency(productPrice)}
    </span>
  `;
  };
  var renderProductCard = (product, helpers) => {
    const templateOptions = helpers.getTemplateOptions("product");
    const productLink = templateOptions.productPageUrl(product);
    const productPrice = helpers.getPrice ? helpers.getPrice(product) : product.price;
    const productCompareAtPrice = helpers.getCompareAtPrice ? helpers.getCompareAtPrice(product) : product.compare_at_price;
    const isOnSale = helpers.isProductOnSale(product.compare_at_price, product.price);
    return `
    <div class="card-wrapper product-card-wrapper underline-links-hover product-card-wrapper-TWP">
      ${renderWishlistButton(product)}
      <div class="card card--standard card--media" style="--ratio-percent: 128.47826086956522%">
        <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 128.47826086956522%">
          <a href=${productLink} class="card__content full-unstyled-link">
            <div class="card__media">
              <div class="media media--transparent ${product.images.length > 1 ? "media--hover-effect" : ""}">
                ${product_card_media_default(product, productLink)}
                <span class="visually-hidden">${product.title}</span>
              </div>
            </div>
            ${renderCardBadge(product.tags)}
          </a>
          ${renderQuickAddInline(product, helpers)}
        </div>
        <div class="card__content">
          <div class="card__information">
            ${renderVendor(product.vendor)}
            <h3 class="card__heading">
              <a class="full-unstyled-link" href=${productLink}>${product.title}</a>
            </h3>
            <div class="card-information">
              <span class="caption-large light"></span>
              <div class="price ${isOnSale ? "price--on-sale" : ""}">
                <div class="price__container">
                  ${renderPrice(product, helpers, productPrice, productCompareAtPrice)}
                </div>
              </div>
              ${renderCardMessage(product.metafields)}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  };
  var product_card_render_default = renderProductCard;

  // src/scripts/components/tagalys-mini-cart-templates.js
  var renderMiniCard = (product, productLink, helpers) => {
    var _a4;
    const image = (_a4 = product.images) == null ? void 0 : _a4[0];
    const imgSrc = image ? imageUrl(image.src, 300) : null;
    const price = helpers.formatCurrency(product.price);
    const compareAtPrice = product.compare_at_price > product.price ? helpers.formatCurrency(product.compare_at_price) : null;
    return `
    <div class="cart-drawer-mini-card">
      <div class="cart-drawer-mini-card__media">
        <a href="${productLink}" class="cart-drawer-mini-card__media-link" tabindex="-1" aria-hidden="true">
          ${imgSrc ? `<img
                  src="${imgSrc}"
                  alt="${image.alt || product.title}"
                  loading="lazy"
                  width="150"
                  height="200"
                >` : ""}
        </a>
        ${renderQuickAddInline(product, helpers, { suppressNotifyMe: true })}
      </div>
      <a href="${productLink}" class="cart-drawer-mini-card__info">
        <p class="cart-drawer-mini-card__vendor caption-with-letter-spacing">${product.vendor || ""}</p>
        <p class="cart-drawer-mini-card__title">${product.title}</p>
        <p class="cart-drawer-mini-card__price">
          ${compareAtPrice ? `<s class="cart-drawer-mini-card__price--compare">${compareAtPrice}</s>` : ""}
          <span class="cart-drawer-mini-card__price-current">${price}</span>
        </p>
      </a>
    </div>
  `;
  };
  var miniCartWidgetTemplates = (limit) => {
    return {
      widget: {
        options: {
          limit,
          displayFormat: "grid",
          includeTagalysCSS: false
        },
        render: (html, args) => {
          const props = args.props;
          const helpers = props.helpers;
          const products = helpers.getProducts();
          if (props.loading === false) {
            if (products.length === 0) return null;
            return html`<${args.templates.productList} />`;
          }
        }
      },
      productList: {
        render: (html, args) => html`<${args.templates.products} />`
      },
      products: {
        render: (html, args) => {
          const products = args.props.helpers.getProducts();
          return html`
          ${products.map((product, index) => html`<${args.templates.product} key=${index} product=${product} />`)}
        `;
        }
      },
      product: {
        options: {
          productPageUrl(product) {
            return constructLocalisedProductLink(product);
          }
        },
        render: (html, args) => {
          const product = args.props.product;
          const helpers = args.props.helpers;
          const productLink = helpers.getTemplateOptions("product").productPageUrl(product);
          return html`
          <div
            class="cart-drawer__rec-slide"
            dangerouslySetInnerHTML=${{ __html: renderMiniCard(product, productLink, helpers) }}
          />
        `;
        }
      }
    };
  };

  // src/scripts/sections/cart-drawer-recommendations.js
  var TAGALYS_READY_POLL_MS = 150;
  var TAGALYS_RENDER_SETTLE_MS = 150;
  var TAGALYS_WIDGET_WATCHDOG_MS = 6e3;
  var selectors = {
    cartDrawer: "cart-drawer",
    recommendations: "[data-cart-recommendations]",
    recTrack: "[data-rec-track]",
    tagalysWidget: '[data-tagalys-widget="mini-cart-recommendations"]',
    prevBtn: "[data-rec-prev]",
    nextBtn: "[data-rec-next]"
  };
  var tagalysInstanceDatasetKey = "tagalysInstanceId";
  var tagalysInstanceAttribute = "data-tagalys-instance-id";
  var nextTagalysInstanceId = 0;
  var buildTagalysMiniCartChain = (widgetElem) => {
    const pairs = [
      [widgetElem.dataset.tagalysW1, widgetElem.dataset.tagalysH1],
      [widgetElem.dataset.tagalysW2, widgetElem.dataset.tagalysH2],
      [widgetElem.dataset.tagalysW3, widgetElem.dataset.tagalysH3]
    ];
    return pairs.filter(([id]) => id && String(id).trim()).map(([id, heading]) => ({
      id: String(id).trim(),
      heading: heading ? String(heading) : ""
    }));
  };
  var getTagalysProductId = (widgetElem, location = window.location) => {
    var _a4, _b3, _c;
    const productId = (_a4 = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _a4.productId;
    if (!isTagalysQaRequest(location)) return productId;
    const qaProductId = (_c = (_b3 = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _b3.tagalysQaProductId) == null ? void 0 : _c.trim();
    return /^[1-9]\d*$/.test(qaProductId != null ? qaProductId : "") ? qaProductId : productId;
  };
  var getTagalysWidgetSelector = (widgetElem) => {
    const instanceId = `cart-drawer-recommendations-${++nextTagalysInstanceId}`;
    widgetElem.dataset[tagalysInstanceDatasetKey] = instanceId;
    return `[${tagalysInstanceAttribute}="${instanceId}"]`;
  };
  var setCartRecHeading = (container, text) => {
    const headingEl = container == null ? void 0 : container.querySelector("[data-cart-rec-heading]");
    if (!headingEl) return;
    const label = text || "";
    headingEl.textContent = label;
    headingEl.hidden = !label;
  };
  var setTagalysLoadingState = (container, isLoading) => {
    if (!container) return;
    container.setAttribute("aria-busy", String(isLoading));
    const loadingElement = container.querySelector("[data-tagalys-loading]");
    if (loadingElement) loadingElement.toggleAttribute("hidden", !isLoading);
  };
  var carouselInstances = /* @__PURE__ */ new WeakMap();
  var initCarousel = (container) => {
    if (!container || carouselInstances.has(container)) return carouselInstances.get(container);
    const track = container.querySelector(selectors.recTrack);
    const prevBtn = container.querySelector(selectors.prevBtn);
    const nextBtn = container.querySelector(selectors.nextBtn);
    if (!track || !prevBtn || !nextBtn) return;
    const isCartDrawerMobile = window.matchMedia("(max-width: 749px)").matches;
    const flkty = new import_flickity.default(track, {
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      cellSelector: ".cart-drawer__rec-slide",
      // Softer on small screens: higher drag threshold (fewer accidental drags), gentler snap physics.
      selectedAttraction: isCartDrawerMobile ? 0.045 : 0.12,
      friction: isCartDrawerMobile ? 0.48 : 0.65,
      dragThreshold: isCartDrawerMobile ? 14 : 5
    });
    flkty.hasDragStarted = function cartDrawerHasDragStarted(moveVector) {
      const absX = Math.abs(moveVector.x);
      const absY = Math.abs(moveVector.y);
      if (absY > absX) return false;
      return absX > this.options.dragThreshold;
    };
    carouselInstances.set(container, flkty);
    if (flkty.cells.length <= 2) {
      prevBtn.style.display = "none";
      nextBtn.style.display = "none";
      return;
    }
    const updateArrowStates = () => {
      prevBtn.disabled = flkty.selectedIndex === 0;
      nextBtn.disabled = flkty.selectedIndex >= flkty.cells.length - 1;
    };
    updateArrowStates();
    flkty.on("select", updateArrowStates);
    prevBtn.addEventListener("click", () => flkty.previous());
    nextBtn.addEventListener("click", () => flkty.next());
    return flkty;
  };
  var destroyCarousel = (container) => {
    const flkty = carouselInstances.get(container);
    if (!flkty) return;
    flkty.destroy();
    carouselInstances.delete(container);
  };
  var waitForTagalysReady = (callback, isCurrent) => {
    let pollId;
    let stopped = false;
    const stop = () => {
      if (stopped) return;
      stopped = true;
      if (pollId) clearInterval(pollId);
    };
    const check = () => {
      if (stopped) return;
      if (!isCurrent()) {
        stop();
        return;
      }
      if (window.Tagalys && window.tagalysReady) {
        stop();
        callback();
      }
    };
    check();
    if (!stopped) pollId = setInterval(check, TAGALYS_READY_POLL_MS);
    return stop;
  };
  var activeLifecycles = /* @__PURE__ */ new Set();
  var lifecycleByContainer = /* @__PURE__ */ new WeakMap();
  var initTagalysMiniCart = (widgetElem) => {
    var _a4, _b3, _c;
    const chain = buildTagalysMiniCartChain(widgetElem);
    const productId = getTagalysProductId(widgetElem);
    if (productId && productId !== ((_a4 = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _a4.productId)) {
      widgetElem.dataset.tagalysProductIdSource = "qa-override";
    }
    const limit = Number((_c = (_b3 = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _b3.limit) != null ? _c : 4);
    const container = widgetElem.closest(selectors.recommendations);
    const cartDrawer = container == null ? void 0 : container.closest(selectors.cartDrawer);
    if (!chain.length || !productId || !container) {
      window.console.error("TWP | cartDrawerRecommendations | widget chain or productId is missing");
      setTagalysLoadingState(container, false);
      container == null ? void 0 : container.setAttribute("hidden", "");
      return;
    }
    const lifecycle = {
      active: true,
      container,
      cartDrawer,
      currentWidgetElem: widgetElem,
      generation: 0,
      attempt: null,
      isConnected() {
        var _a5, _b4;
        return this.active && ((_a5 = this.container) == null ? void 0 : _a5.isConnected) && ((_b4 = this.currentWidgetElem) == null ? void 0 : _b4.isConnected) && (!this.cartDrawer || this.cartDrawer.contains(this.container)) && this.container.contains(this.currentWidgetElem);
      },
      cancel() {
        if (!this.active) return;
        this.active = false;
        this.generation += 1;
        cleanupAttempt();
        destroyCarousel(this.container);
        activeLifecycles.delete(this);
        if (lifecycleByContainer.get(this.container) === this) lifecycleByContainer.delete(this.container);
      }
    };
    const cleanupAttempt = () => {
      var _a5, _b4, _c2;
      const attempt = lifecycle.attempt;
      if (!attempt) return;
      if (attempt.watchdogId !== null) clearTimeout(attempt.watchdogId);
      if (attempt.renderSettleTimerId !== null) clearTimeout(attempt.renderSettleTimerId);
      (_a5 = attempt.frameIds) == null ? void 0 : _a5.forEach((frameId) => cancelAnimationFrame(frameId));
      attempt.frameIds = [];
      attempt.renderSettleTimerId = null;
      attempt.renderSettleScheduled = false;
      (_b4 = attempt.readyCleanup) == null ? void 0 : _b4.call(attempt);
      (_c2 = attempt.slideObserver) == null ? void 0 : _c2.disconnect();
      lifecycle.attempt = null;
    };
    const isCurrentAttempt = (generation) => lifecycle.active && lifecycle.generation === generation && lifecycle.isConnected();
    const complete = () => {
      if (!lifecycle.active) return;
      lifecycle.active = false;
      cleanupAttempt();
      activeLifecycles.delete(lifecycle);
      if (lifecycleByContainer.get(container) === lifecycle) lifecycleByContainer.delete(container);
    };
    const replaceAttemptNode = () => {
      const nextWidgetElem = lifecycle.currentWidgetElem.cloneNode(false);
      lifecycle.currentWidgetElem.replaceWith(nextWidgetElem);
      lifecycle.currentWidgetElem = nextWidgetElem;
    };
    const tryWidget = (index) => {
      if (!lifecycle.active || !lifecycle.isConnected()) return;
      cleanupAttempt();
      if (index >= chain.length) {
        setTagalysLoadingState(container, false);
        container.setAttribute("hidden", "");
        complete();
        return;
      }
      if (index > 0) replaceAttemptNode();
      setCartRecHeading(container, chain[index].heading);
      setTagalysLoadingState(container, true);
      const { id: recommendationId } = chain[index];
      const attemptGeneration = ++lifecycle.generation;
      const attempt = {
        generation: attemptGeneration,
        watchdogId: null,
        renderSettleTimerId: null,
        renderSettleScheduled: false,
        readyCleanup: null,
        slideObserver: null,
        frameIds: [],
        finished: false
      };
      lifecycle.attempt = attempt;
      const countSlides = () => lifecycle.currentWidgetElem.querySelectorAll(".cart-drawer__rec-slide").length;
      const queueAttemptFrame = (callback) => {
        let frameId;
        frameId = requestAnimationFrame(() => {
          attempt.frameIds = attempt.frameIds.filter((queuedFrameId) => queuedFrameId !== frameId);
          callback();
        });
        attempt.frameIds.push(frameId);
      };
      const cancelRenderSettle = () => {
        if (attempt.renderSettleTimerId !== null) clearTimeout(attempt.renderSettleTimerId);
        attempt.renderSettleTimerId = null;
        attempt.renderSettleScheduled = false;
        attempt.frameIds.forEach((frameId) => cancelAnimationFrame(frameId));
        attempt.frameIds = [];
      };
      const initialiseCarousel = () => {
        if (!isCurrentAttempt(attemptGeneration) || attempt.finished || countSlides() === 0) return;
        cancelRenderSettle();
        attempt.finished = true;
        queueAttemptFrame(() => {
          queueAttemptFrame(() => {
            if (!isCurrentAttempt(attemptGeneration)) return;
            if (countSlides() === 0) {
              attempt.finished = false;
              scheduleRenderSettle();
              return;
            }
            cleanupAttempt();
            setTagalysLoadingState(container, false);
            initCarousel(container);
          });
        });
      };
      const finishWhenSlidesExist = () => {
        if (!isCurrentAttempt(attemptGeneration) || attempt.finished || countSlides() === 0) return;
        initialiseCarousel();
      };
      const scheduleRenderSettle = () => {
        if (!isCurrentAttempt(attemptGeneration) || attempt.finished || attempt.renderSettleScheduled) return;
        attempt.renderSettleScheduled = true;
        queueAttemptFrame(() => {
          queueAttemptFrame(() => {
            if (!isCurrentAttempt(attemptGeneration) || attempt.finished) return;
            attempt.renderSettleTimerId = setTimeout(() => {
              attempt.renderSettleTimerId = null;
              attempt.renderSettleScheduled = false;
              if (!isCurrentAttempt(attemptGeneration) || attempt.finished) return;
              if (countSlides() === 0) tryWidget(index + 1);
              else finishWhenSlidesExist();
            }, TAGALYS_RENDER_SETTLE_MS);
          });
        });
      };
      attempt.slideObserver = new MutationObserver(finishWhenSlidesExist);
      attempt.slideObserver.observe(lifecycle.currentWidgetElem, { childList: true, subtree: true });
      attempt.watchdogId = setTimeout(() => {
        if (!isCurrentAttempt(attemptGeneration) || attempt.finished) return;
        tryWidget(index + 1);
      }, TAGALYS_WIDGET_WATCHDOG_MS);
      attempt.readyCleanup = waitForTagalysReady(
        () => {
          var _a5, _b4;
          if (!isCurrentAttempt(attemptGeneration)) return;
          const recommendations = (_b4 = (_a5 = window.Tagalys) == null ? void 0 : _a5.UIWidgets) == null ? void 0 : _b4.Recommendations;
          if (!recommendations || typeof recommendations.init !== "function") {
            tryWidget(index + 1);
            return;
          }
          try {
            recommendations.init(getTagalysWidgetSelector(lifecycle.currentWidgetElem), {
              recommendationId,
              productId,
              templates: miniCartWidgetTemplates(limit),
              callbacks: {
                afterInitialRender: scheduleRenderSettle
              }
            });
            finishWhenSlidesExist();
          } catch (error) {
            window.console.error("TWP | cartDrawerRecommendations | widget init failed", error);
            tryWidget(index + 1);
          }
        },
        () => isCurrentAttempt(attemptGeneration)
      );
    };
    container.removeAttribute("hidden");
    lifecycleByContainer.set(container, lifecycle);
    activeLifecycles.add(lifecycle);
    tryWidget(0);
  };
  var initRecommendations = (container) => {
    const existingLifecycle = lifecycleByContainer.get(container);
    if (existingLifecycle) {
      if (existingLifecycle.isConnected()) return;
      existingLifecycle.cancel();
    }
    const tagalysWidget = container.querySelector(selectors.tagalysWidget);
    if (tagalysWidget) {
      initTagalysMiniCart(tagalysWidget);
      return;
    }
    const lifecycle = {
      active: true,
      container,
      cartDrawer: container.closest(selectors.cartDrawer),
      isConnected() {
        return this.active && this.container.isConnected && (!this.cartDrawer || this.cartDrawer.contains(this.container));
      },
      cancel() {
        if (!this.active) return;
        this.active = false;
        destroyCarousel(this.container);
        activeLifecycles.delete(this);
        if (lifecycleByContainer.get(this.container) === this) lifecycleByContainer.delete(this.container);
      }
    };
    lifecycleByContainer.set(container, lifecycle);
    activeLifecycles.add(lifecycle);
    initCarousel(container);
  };
  var cleanupDisconnectedLifecycles = (cartDrawer) => {
    [...activeLifecycles].forEach((lifecycle) => {
      if (lifecycle.cartDrawer === cartDrawer && !lifecycle.isConnected()) lifecycle.cancel();
    });
  };
  var drawerCleanups = /* @__PURE__ */ new WeakMap();
  var initCartDrawerRecommendations = () => {
    const cartDrawer = document.querySelector(selectors.cartDrawer);
    if (!cartDrawer) return () => {
    };
    const existingCleanup = drawerCleanups.get(cartDrawer);
    if (existingCleanup) return existingCleanup;
    let mutationTimer;
    const handleMutation = () => {
      cleanupDisconnectedLifecycles(cartDrawer);
      const recommendations = cartDrawer.querySelector(selectors.recommendations);
      if (recommendations) initRecommendations(recommendations);
    };
    const scheduleMutation = () => {
      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(() => {
        mutationTimer = null;
        handleMutation();
      }, 50);
    };
    const observer = new MutationObserver(scheduleMutation);
    observer.observe(cartDrawer, { childList: true, subtree: true });
    const existing = cartDrawer.querySelector(selectors.recommendations);
    if (existing) initRecommendations(existing);
    const cleanup = () => {
      clearTimeout(mutationTimer);
      observer.disconnect();
      [...activeLifecycles].forEach((lifecycle) => {
        if (lifecycle.cartDrawer === cartDrawer) lifecycle.cancel();
      });
      if (drawerCleanups.get(cartDrawer) === cleanup) drawerCleanups.delete(cartDrawer);
    };
    drawerCleanups.set(cartDrawer, cleanup);
    return cleanup;
  };

  // src/scripts/sections/header.js
  var syncLastClickedMenuToPageContext = (section) => {
    var _a4, _b3;
    if (sessionStorage.getItem("lastClickedMenuId")) return;
    const genderContext = (_b3 = (_a4 = window.theme) == null ? void 0 : _a4.search) == null ? void 0 : _b3.currentGenderContext;
    const titlePrefix = { womens: "women", mens: "men" }[genderContext];
    if (!titlePrefix) return;
    const match = Array.from(section.querySelectorAll("[data-header-menu-id]")).find(
      (el) => {
        var _a5, _b4;
        return (_b4 = (_a5 = el.querySelector("summary")) == null ? void 0 : _a5.textContent) == null ? void 0 : _b4.trim().toLowerCase().startsWith(titlePrefix);
      }
    );
    if (match) sessionStorage.setItem("lastClickedMenuId", match.getAttribute("data-header-menu-id"));
  };
  var initCustomHeaderMenu = (section) => {
    syncLastClickedMenuToPageContext(section);
    class CustomHeaderMenu extends HTMLElement {
      constructor() {
        var _a4, _b3, _c, _d;
        super();
        this.header = section;
        this.detailsElem = this.querySelector("details");
        this.summaryElem = (_a4 = this.detailsElem) == null ? void 0 : _a4.querySelector("summary");
        this.megaMenu = (_b3 = this.summaryElem) == null ? void 0 : _b3.nextElementSibling;
        this.megaMenuList = (_c = this.megaMenu) == null ? void 0 : _c.querySelector("[data-mega-menu-level-2-list]");
        this.level2Links = (_d = this.megaMenuList) == null ? void 0 : _d.querySelectorAll(".header__menu-item--level-2");
        this.megaMenuBarHeight = getComputedStyle(this.header).getPropertyValue("--megamenu-level-2-bar-height");
      }
      connectedCallback() {
        this.initLevel1Listeners();
        this.initLevel2Listeners();
        this.openOnPageLoad();
      }
      initLevel1Listeners() {
        this.summaryElem.addEventListener("click", (event) => {
          var _a4;
          event.preventDefault();
          const menuId = this.detailsElem.getAttribute("data-header-menu-id");
          if (menuId) sessionStorage.setItem("lastClickedMenuId", menuId);
          const openedDetails = this.header.querySelector("custom-header-menu .open");
          if (!this.detailsElem.classList.contains("open")) {
            this.summaryElem.setAttribute("aria-expanded", true);
            this.detailsElem.setAttribute("open", true);
            requestAnimationFrame(() => {
              this.detailsElem.classList.add("open");
            });
          }
          if (openedDetails && openedDetails !== this.detailsElem) {
            openedDetails.classList.remove("open");
            (_a4 = openedDetails.querySelector("summary")) == null ? void 0 : _a4.setAttribute("aria-expanded", false);
            requestAnimationFrame(() => {
              openedDetails.removeAttribute("open");
            });
          }
          requestAnimationFrame(() => {
            var _a5;
            (_a5 = this.level2Links[0]) == null ? void 0 : _a5.dispatchEvent(new MouseEvent("mouseenter"));
          });
          if (section.classList.contains("section-header--scrolling-down")) {
            section.scrollController.triggerDirection("up");
          }
        });
      }
      initLevel2Listeners() {
        var _a4, _b3;
        (_a4 = this.level2Links) == null ? void 0 : _a4.forEach((level2Link) => {
          level2Link.addEventListener("mouseenter", () => {
            var _a5;
            const level2Menu = level2Link.nextElementSibling;
            const height = level2Menu ? `${level2Menu.scrollHeight + 48}px` : this.megaMenuBarHeight;
            this.closeExpandedLevel2Menu();
            (_a5 = level2Link.closest("li")) == null ? void 0 : _a5.classList.add("is-expanded");
            if (this.megaMenuList) {
              this.megaMenuList.style.height = height;
            }
          });
        });
        (_b3 = this.megaMenuList) == null ? void 0 : _b3.addEventListener("mouseleave", () => {
          this.megaMenuList.style.height = `${this.megaMenuBarHeight}`;
          this.closeExpandedLevel2Menu();
        });
      }
      closeExpandedLevel2Menu() {
        var _a4;
        const level2Expanded = (_a4 = this.megaMenuList) == null ? void 0 : _a4.querySelector(".is-expanded");
        level2Expanded == null ? void 0 : level2Expanded.classList.remove("is-expanded");
      }
      openOnPageLoad() {
        if (!this.detailsElem || !this.summaryElem) return;
        let savedMenuID = sessionStorage.getItem("lastClickedMenuId");
        if (!savedMenuID) {
          const firstDetailsEl = this.header.querySelector("[data-header-menu-id]");
          savedMenuID = firstDetailsEl == null ? void 0 : firstDetailsEl.getAttribute("data-header-menu-id");
        }
        this.detailsID = this.detailsElem.getAttribute("data-header-menu-id");
        if (savedMenuID === this.detailsID) {
          this.detailsElem.setAttribute("open", true);
          this.detailsElem.classList.add("open");
          this.summaryElem.setAttribute("aria-expanded", "true");
        }
      }
    }
    if (!customElements.get("custom-header-menu")) {
      customElements.define("custom-header-menu", CustomHeaderMenu);
    }
  };
  var onDesktopScrollDirectionChange = (callback) => {
    let lastScrollTop = 0;
    let currentDirection = null;
    let ticking = false;
    const threshold = 20;
    const updateScrollDirection = (direction) => {
      if (direction !== currentDirection) {
        currentDirection = direction;
        callback(direction);
      }
    };
    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            const scrollTop = window.scrollY;
            const scrollDifference = Math.abs(scrollTop - lastScrollTop);
            if (scrollDifference > threshold) {
              const direction = scrollTop > lastScrollTop ? "down" : "up";
              updateScrollDirection(direction);
              lastScrollTop = scrollTop;
            }
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
    return {
      triggerDirection: (direction) => {
        updateScrollDirection(direction);
        lastScrollTop = window.scrollY;
      }
    };
  };
  var initCustomHeader = (section) => {
    initCustomHeaderMenu(section);
    const setupNavLinkTracking = () => {
      const navSelector = window.matchMedia("(max-width: 989px)").matches ? "[data-header-drawer-nav]" : "[data-header-nav]";
      const nav = section.querySelector(navSelector);
      const navLinks = nav == null ? void 0 : nav.querySelectorAll("a");
      navLinks == null ? void 0 : navLinks.forEach((link) => {
        link.addEventListener("click", () => {
          var _a4, _b3, _c;
          const controlledId = link.getAttribute("aria-controls") || ((_b3 = (_a4 = link.getAttribute("href")) == null ? void 0 : _a4.match(/^#(.+)$/)) == null ? void 0 : _b3[1]);
          const controlledPanel = controlledId ? section.querySelector(`[id="${controlledId}"]`) : null;
          const parent = (_c = link.closest("[data-header-menu-id]")) != null ? _c : controlledPanel == null ? void 0 : controlledPanel.closest("[data-header-menu-id]");
          if (!parent) return;
          const parentID = parent.getAttribute("data-header-menu-id");
          sessionStorage.setItem("lastClickedMenuId", parentID);
        });
      });
    };
    setupNavLinkTracking();
    const isMobileQuery = window.matchMedia("(max-width: 989px)");
    if (!isMobileQuery.matches) {
      const scrollController = onDesktopScrollDirectionChange((direction) => {
        section.classList.remove("section-header--scrolling-up", "section-header--scrolling-down");
        section.classList.add(`section-header--scrolling-${direction}`);
      });
      section.scrollController = scrollController;
    }
    let mobileNavInitialized = false;
    const openSavedMobilePanel = () => {
      const savedMenuID = sessionStorage.getItem("lastClickedMenuId");
      if (!savedMenuID) return;
      const panel = section.querySelector(`[data-header-menu-id="${savedMenuID}"]`);
      if (!panel) return;
      const panelID = panel.id;
      const tabLink = section.querySelector(`[aria-controls="${panelID}"]`);
      tabLink == null ? void 0 : tabLink.click();
    };
    const initMobileNavAccordions = () => {
      const nav = section.querySelector("[data-header-drawer-nav]");
      const navAccordions = nav == null ? void 0 : nav.querySelectorAll("details");
      const closeNavAccordion = (details, summaryElement, panelElement) => {
        if (!details || !summaryElement || !panelElement) return;
        details.classList.remove("open");
        panelElement.addEventListener("transitionend", function handler(event) {
          if (event.propertyName === "grid-template-rows") {
            details.removeAttribute("open");
            summaryElement.setAttribute("aria-expanded", false);
            panelElement.removeEventListener("transitionend", handler);
          }
        });
      };
      navAccordions == null ? void 0 : navAccordions.forEach((details) => {
        const summaryElement = details.querySelector("summary");
        const panelElement = summaryElement == null ? void 0 : summaryElement.nextElementSibling;
        if (!summaryElement || !panelElement) return;
        summaryElement.addEventListener("click", (event) => {
          var _a4;
          event.preventDefault();
          const isOpen = details.classList.contains("open");
          const openedDetails = (_a4 = summaryElement.closest("[data-menu-drawer-menu]")) == null ? void 0 : _a4.querySelector("details.open");
          if (openedDetails && openedDetails !== details) {
            const openedSummaryElement = openedDetails.querySelector("summary");
            const openedPanelElement = openedSummaryElement == null ? void 0 : openedSummaryElement.nextElementSibling;
            closeNavAccordion(openedDetails, openedSummaryElement, openedPanelElement);
          }
          if (!isOpen) {
            details.setAttribute("open", true);
            summaryElement.setAttribute("aria-expanded", true);
            requestAnimationFrame(() => {
              details.classList.add("open");
              if (openedDetails) {
                setTimeout(() => {
                  const rect = details.getBoundingClientRect();
                  if (rect.top >= 0 && rect.top <= window.innerHeight) return;
                  details.scrollIntoView({
                    behavior: "smooth"
                  });
                }, 350);
              }
            });
          } else {
            closeNavAccordion(details, summaryElement, panelElement);
          }
        });
      });
    };
    if (isMobileQuery.matches) {
      openSavedMobilePanel();
      initMobileNavAccordions();
      mobileNavInitialized = true;
    }
    isMobileQuery.addEventListener("change", (event) => {
      if (!event.matches || mobileNavInitialized) return;
      setupNavLinkTracking();
      openSavedMobilePanel();
      initMobileNavAccordions();
    });
  };
  var header_default = initCustomHeader;

  // src/scripts/components/tagalys-widget-templates.js
  var tagalysWidgetTemplates = (limit, widgetElem) => {
    var _a4, _b3, _c, _d, _e, _f;
    const sectionId = (_a4 = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _a4.sectionId;
    const sectionTitle = (_b3 = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _b3.title;
    const headingSize = (_d = (_c = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _c.headingSize) != null ? _d : "h5";
    const buttonLabel = (_e = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _e.buttonLabel;
    const buttonUrl = (_f = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _f.buttonUrl;
    return {
      widget: {
        options: {
          limit,
          displayFormat: "grid",
          includeTagalysCSS: false
        },
        render: (html, args) => {
          const props = args.props;
          const helpers = props.helpers;
          const products = helpers.getProducts();
          if (props.loading === false) {
            if (products.length === 0) {
              return null;
            }
            return html`
            <${args.templates.title} />
            <${args.templates.productList} />
            <${args.templates.button} />
          `;
          }
        }
      },
      title: {
        render: (html) => {
          if (sectionTitle) {
            return html`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${headingSize}">${sectionTitle}</h2>
            </div>
          `;
          }
          return html``;
        }
      },
      productList: {
        render: (html, args) => html`
        <slider-component class="slider-component-full-width">
          <${args.templates.products} />
          <${args.templates.carouselActions} />
        </slider-component>
      `
      },
      products: {
        render: (html, args) => {
          const props = args.props;
          const products = props.helpers.getProducts();
          return html`<ul
          id="Slider-${sectionId}"
          class="grid product-grid contains-card contains-card--product contains-card--standard grid--4-col-desktop grid--2-col-tablet-down slider slider--desktop slider--tablet grid--peek"
        >
          ${products.map(
            (product, index) => html`<li class="grid__item slider__slide scroll-trigger animate--slide-in">
                <${args.templates.product} key=${index} product=${product} />
              </li>`
          )}
        </ul> `;
        }
      },
      product: {
        options: {
          // Generate the product page URL using the product object
          productPageUrl(product) {
            return constructLocalisedProductLink(product);
          }
        },
        render: (html, args) => {
          const props = args.props;
          const product = props.product;
          const helpers = props.helpers;
          return html`<div
          class="tagalys-section__slide"
          id="Slide-${product.id}"
          dangerouslySetInnerHTML=${{
            __html: product_card_render_default(product, helpers)
          }}
        />`;
        }
      },
      carouselActions: {
        render: (html) => {
          var _a5, _b4, _c2, _d2, _e2, _f2;
          return html`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(_c2 = (_b4 = (_a5 = window.theme) == null ? void 0 : _a5.strings) == null ? void 0 : _b4.accessibility) == null ? void 0 : _c2.previousSlide}"
            aria-controls="Slider-${sectionId}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(_f2 = (_e2 = (_d2 = window.theme) == null ? void 0 : _d2.strings) == null ? void 0 : _e2.accessibility) == null ? void 0 : _f2.nextSlide}"
            aria-controls="Slider-${sectionId}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `;
        }
      },
      button: {
        render: (html) => {
          if (buttonLabel && buttonUrl) {
            return html`
            <div class="product-recommendations__button">
              <a href="${buttonUrl}" class="button button--secondary">${buttonLabel}</a>
            </div>
          `;
          }
          return html``;
        }
      }
    };
  };
  var tagalys_widget_templates_default = tagalysWidgetTemplates;

  // src/scripts/components/tagalys-recommendations.js
  var widgetInstanceAttribute = "data-tagalys-recommendation-instance-id";
  var widgetInstanceDatasetKey = "tagalysRecommendationInstanceId";
  var nextWidgetInstanceId = 0;
  var initialisedWidgets = /* @__PURE__ */ new WeakSet();
  var pendingWidgets = /* @__PURE__ */ new WeakSet();
  var isConnected = (widgetElem) => (widgetElem == null ? void 0 : widgetElem.isConnected) || document.documentElement.contains(widgetElem);
  var getTagalysWidgetSelector2 = (widgetElem) => {
    const instanceId = widgetElem.dataset[widgetInstanceDatasetKey] || `product-recommendations-${++nextWidgetInstanceId}`;
    widgetElem.dataset[widgetInstanceDatasetKey] = instanceId;
    return `[${widgetInstanceAttribute}="${instanceId}"]`;
  };
  var tagalysRecommendations = (widgetElem) => {
    var _a4, _b3, _c, _d, _e, _f;
    if (!isConnected(widgetElem) || initialisedWidgets.has(widgetElem)) return;
    const recommendationId = (_a4 = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _a4.recommendationId;
    const productId = (_b3 = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _b3.productId;
    const widgetLimit = (_d = (_c = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _c.limit) != null ? _d : 8;
    if (!recommendationId || !productId) {
      window.console.error("TWP | tagalysSimilarProducts | recommendationId or productId is missing");
      return;
    }
    const recommendations = (_f = (_e = window.Tagalys) == null ? void 0 : _e.UIWidgets) == null ? void 0 : _f.Recommendations;
    if (!recommendations || typeof recommendations.init !== "function") return;
    initialisedWidgets.add(widgetElem);
    try {
      recommendations.init(getTagalysWidgetSelector2(widgetElem), {
        recommendationId,
        productId,
        templates: tagalys_widget_templates_default(widgetLimit, widgetElem),
        callbacks: {
          afterInitialRender: () => {
            const sliderComponent = widgetElem.querySelector("slider-component");
            sliderComponent == null ? void 0 : sliderComponent.reinitialiseSlider();
          }
        }
      });
    } catch (error) {
      initialisedWidgets.delete(widgetElem);
      window.console.error("TWP | tagalysRecommendations | widget init failed", error);
    }
  };
  var initTagalysRecommendations = (widgetElem) => {
    if (!widgetElem || initialisedWidgets.has(widgetElem) || pendingWidgets.has(widgetElem)) return;
    pendingWidgets.add(widgetElem);
    onTagalysReady(() => {
      pendingWidgets.delete(widgetElem);
      tagalysRecommendations(widgetElem);
    });
  };

  // src/scripts/sections/product-recommendations.js
  var sectionType = "product-recommendations-recently";
  var selectors2 = {
    tagalysWidget: '[data-tagalys-widget="recommendations"]'
  };
  var productRecommendations = (section) => {
    var _a4;
    const containers = (_a4 = section == null ? void 0 : section.querySelectorAll(`[data-section-type="${sectionType}"]`)) != null ? _a4 : [];
    containers.forEach((container) => {
      container.querySelectorAll(selectors2.tagalysWidget).forEach(initTagalysRecommendations);
    });
  };

  // src/scripts/components/tagalys-search-suggestions.js
  var selectors3 = {
    searchInput: "[data-TWP-search-input]",
    featuredProductsWidget: '[data-tagalys-widget="featured-products-suggestions"]'
  };
  var PRODUCT_FETCH_LIMIT = 24;
  var MAX_VISIBLE_PRODUCTS = 6;
  var COLLECTION_FETCH_LIMIT = 15;
  var MAX_VISIBLE_COLLECTIONS = 5;
  var AUTOCOMPLETE_SECTION_ID = "gender_and_type_searches";
  var AUTOCOMPLETE_LIMIT = 4;
  var isAutocompleteEnabled = () => {
    var _a4, _b3;
    return ((_b3 = (_a4 = window.theme) == null ? void 0 : _a4.search) == null ? void 0 : _b3.autocompleteEnabled) !== false;
  };
  var getProductGenders = (product) => {
    var _a4;
    return ((_a4 = product.tags) != null ? _a4 : []).filter((tag) => tag.toLowerCase().startsWith("gender:")).map((tag) => {
      var _a5;
      return (_a5 = tag.split(":")[1]) == null ? void 0 : _a5.trim().toLowerCase();
    }).filter((value) => value === "womens" || value === "mens");
  };
  var GENDER_METAOBJECT_GIDS = {
    womens: "gid://shopify/Metaobject/197195727099",
    mens: "gid://shopify/Metaobject/197195825403"
  };
  var getGenderFilterValue = () => {
    const gid = GENDER_METAOBJECT_GIDS[selectedGender];
    return gid ? `p.m.custom.sup_product_collection_gender-${gid}` : "";
  };
  var GENDER_FILTER_PARAM = "filter.p.m.custom.sup_product_collection_gender";
  var GENDER_BY_GID = Object.fromEntries(Object.entries(GENDER_METAOBJECT_GIDS).map(([gender, gid]) => [gid, gender]));
  var getGenderFromUrlFilter = () => {
    var _a4;
    const gid = new URLSearchParams(window.location.search).get(GENDER_FILTER_PARAM);
    return (_a4 = GENDER_BY_GID[gid]) != null ? _a4 : null;
  };
  var getGenderSearchUrlParam = () => {
    const value = getGenderFilterValue();
    return value ? `&f=${encodeURIComponent(value)}` : "";
  };
  var lastSearchTerm = "";
  var tagalysHelpers = null;
  var applyGenderScopeToRequest = (params) => {
    var _a4;
    const gid = GENDER_METAOBJECT_GIDS[selectedGender];
    if (!gid) return params;
    return __spreadProps(__spreadValues({}, params), {
      request: __spreadProps(__spreadValues({}, params.request), {
        products: __spreadProps(__spreadValues({}, (_a4 = params.request) == null ? void 0 : _a4.products), {
          scope: { "p.m.custom.sup_product_collection_gender": [gid] }
        })
      })
    });
  };
  var renderProductsList = (html, args) => {
    const props = args.props;
    const products = props.helpers.getProducts();
    return html`<div>
    <ul class="TWP-predictive-search__results-list--products predictive-search__results-list--grid list-unstyled">
      ${products.map((product) => {
      return html`
          <li class="predictive-search__list-item" data-product-gender="${getProductGenders(product).join(" ")}">
            <${args.templates.product} key=${product.id} product=${product} />
          </li>
        `;
    })}
    </ul>
  </div>`;
  };
  var getAutocompleteSuggestions = (helpers) => {
    var _a4;
    if (!isAutocompleteEnabled()) return [];
    const section = helpers.getTextSuggestions().find((suggestion) => suggestion.section_id === AUTOCOMPLETE_SECTION_ID);
    return ((_a4 = section == null ? void 0 : section.items) != null ? _a4 : []).slice(0, AUTOCOMPLETE_LIMIT);
  };
  var renderTermSuggestions = (html, { items, searchTerm, searchPageUrl }) => {
    if (!items.length) return null;
    return html`
    <div class="predictive-search__term-suggestions">
      ${items.map((item) => {
      const matchIndex = item.displayString.toLowerCase().indexOf(searchTerm.toLowerCase());
      const href = `${searchPageUrl.split("?")[0]}?q=${encodeURIComponent(item.displayString)}`;
      const hasMatch = matchIndex >= 0 && searchTerm.length > 0;
      const before = hasMatch ? item.displayString.slice(0, matchIndex) : item.displayString;
      const match = hasMatch ? item.displayString.slice(matchIndex, matchIndex + searchTerm.length) : "";
      const after = hasMatch ? item.displayString.slice(matchIndex + searchTerm.length) : "";
      return html`
          <a href=${href} class="predictive-search__term-suggestion">
            <svg
              class="predictive-search__term-suggestion-icon"
              width="13"
              height="12"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.22708 8.42894C7.38771 9.15155 6.29528 9.58837 5.10082 9.58837C2.45307 9.58837 0.306641 7.44194 0.306641 4.79418C0.306641 2.14643 2.45307 0 5.10082 0C7.74858 0 9.89501 2.14643 9.89501 4.79418C9.89501 5.98864 9.45819 7.08107 8.73558 7.92044L12.3066 11.4915L11.7981 12L8.22708 8.42894ZM9.17588 4.79418C9.17588 7.04477 7.35142 8.86924 5.10082 8.86924C2.85023 8.86924 1.02577 7.04477 1.02577 4.79418C1.02577 2.54359 2.85023 0.719127 5.10082 0.719127C7.35142 0.719127 9.17588 2.54359 9.17588 4.79418Z"
                fill="currentColor"
              />
            </svg>
            <span>${before}<strong>${match}</strong>${after}</span>
          </a>
        `;
    })}
    </div>
  `;
  };
  var VALID_GENDERS = ["mens", "womens", "all"];
  var NAV_MENU_STORAGE_KEY = "lastClickedMenuId";
  var getGenderFromMenuId = (menuId) => {
    var _a4, _b3;
    if (!menuId) return null;
    const matches = document.querySelectorAll(`[data-header-menu-id="${menuId}"]`);
    for (const el of matches) {
      const title = (_b3 = (_a4 = el.querySelector("summary")) == null ? void 0 : _a4.textContent) == null ? void 0 : _b3.trim().toLowerCase();
      if (!title) continue;
      if (title.startsWith("women")) return "womens";
      if (title.startsWith("men")) return "mens";
      if (title.startsWith("home")) return "all";
    }
    return null;
  };
  var _a, _b;
  var opensOnAll = ((_b = (_a = window.theme) == null ? void 0 : _a.search) == null ? void 0 : _b.defaultGenderScope) !== "section";
  var getSectionGender = () => {
    var _a4;
    return (_a4 = getGenderFromUrlFilter()) != null ? _a4 : getGenderFromMenuId(sessionStorage.getItem(NAV_MENU_STORAGE_KEY));
  };
  var _a2, _b2;
  var initialGenderContext = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.search) == null ? void 0 : _b2.currentGenderContext;
  var _a3;
  var selectedGender = opensOnAll ? "all" : (_a3 = getSectionGender()) != null ? _a3 : VALID_GENDERS.includes(initialGenderContext) ? initialGenderContext : "all";
  var genderTabsSelectors = {
    searchPlaceholderLabel: "[data-search-placeholder-label]",
    genderTab: ".predictive-search__gender-tab"
  };
  var syncNavToGender = (gender) => {
    var _a4;
    if (gender === "all") return;
    const menu = Array.from(document.querySelectorAll("custom-header-menu")).find((el) => {
      var _a5, _b3;
      const title = (_b3 = (_a5 = el.querySelector("summary")) == null ? void 0 : _a5.textContent) == null ? void 0 : _b3.trim().toLowerCase();
      return title == null ? void 0 : title.startsWith(gender === "womens" ? "women" : "men");
    });
    if (!menu) return;
    const menuId = (_a4 = menu.querySelector("[data-header-menu-id]")) == null ? void 0 : _a4.getAttribute("data-header-menu-id");
    if (menuId) sessionStorage.setItem(NAV_MENU_STORAGE_KEY, menuId);
    document.querySelectorAll("custom-header-menu details").forEach((details) => {
      var _a5;
      const isTarget = details === menu.querySelector("details");
      details.classList.toggle("open", isTarget);
      details.toggleAttribute("open", isTarget);
      (_a5 = details.querySelector("summary")) == null ? void 0 : _a5.setAttribute("aria-expanded", String(isTarget));
    });
  };
  var placeholderStringByGender = () => {
    var _a4, _b3, _c, _d, _e, _f, _g, _h, _i;
    return {
      mens: (_c = (_b3 = (_a4 = window.theme) == null ? void 0 : _a4.strings) == null ? void 0 : _b3.search) == null ? void 0 : _c.searchMens,
      womens: (_f = (_e = (_d = window.theme) == null ? void 0 : _d.strings) == null ? void 0 : _e.search) == null ? void 0 : _f.searchWomens,
      all: (_i = (_h = (_g = window.theme) == null ? void 0 : _g.strings) == null ? void 0 : _h.search) == null ? void 0 : _i.search
    };
  };
  var COLLECTION_GENDER_SECTION_ID = "collection-gender-twp";
  var COLLECTION_GENDER_STORAGE_KEY = "twpCollectionGenders";
  var collectionGenderPending = /* @__PURE__ */ new Map();
  var readCollectionGenderCache = () => {
    var _a4;
    try {
      return (_a4 = JSON.parse(sessionStorage.getItem(COLLECTION_GENDER_STORAGE_KEY))) != null ? _a4 : {};
    } catch (e) {
      return {};
    }
  };
  var collectionGenderCache = readCollectionGenderCache();
  var writeCollectionGenderCache = () => {
    try {
      const resolved = Object.fromEntries(Object.entries(collectionGenderCache).filter(([, genders]) => genders !== null));
      sessionStorage.setItem(COLLECTION_GENDER_STORAGE_KEY, JSON.stringify(resolved));
    } catch (e) {
    }
  };
  var getCollectionHandle = (link) => {
    var _a4, _b3;
    try {
      return (_b3 = (_a4 = new URL(link, window.location.origin).pathname.match(/\/collections\/([^/?#]+)/)) == null ? void 0 : _a4[1]) != null ? _b3 : null;
    } catch (e) {
      return null;
    }
  };
  var fetchCollectionGenders = (handle) => {
    if (collectionGenderPending.has(handle)) return collectionGenderPending.get(handle);
    const rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : "";
    const request = fetch(`${rootUrl}/collections/${handle}?section_id=${COLLECTION_GENDER_SECTION_ID}`).then((response) => response.ok ? response.text() : Promise.reject(response.status)).then((text) => {
      const json = new DOMParser().parseFromString(text, "text/html").querySelector("[data-collection-gender]");
      const values = json ? JSON.parse(json.textContent) : [];
      collectionGenderCache[handle] = (Array.isArray(values) ? values : [values]).map((value) => String(value).trim().toLowerCase()).filter((value) => value === "womens" || value === "mens");
      writeCollectionGenderCache();
    }).catch(() => {
      var _a4;
      collectionGenderCache[handle] = (_a4 = collectionGenderCache[handle]) != null ? _a4 : null;
    }).finally(() => {
      collectionGenderPending.delete(handle);
      applyCollectionVisibility();
    });
    collectionGenderPending.set(handle, request);
    return request;
  };
  var applyCollectionVisibility = () => {
    document.querySelectorAll("[data-collection-suggestions]").forEach((group) => {
      const pills = Array.from(group.querySelectorAll("[data-collection-handle]"));
      let shownCount = 0;
      let isPending = false;
      pills.forEach((pill) => {
        var _a4;
        const handle = pill.dataset.collectionHandle;
        let matches = selectedGender === "all";
        if (!matches && handle) {
          if (!(handle in collectionGenderCache)) {
            isPending = true;
            fetchCollectionGenders(handle);
          } else {
            matches = ((_a4 = collectionGenderCache[handle]) != null ? _a4 : []).includes(selectedGender);
          }
        }
        const isShown = matches && shownCount < MAX_VISIBLE_COLLECTIONS;
        pill.style.display = isShown ? "" : "none";
        if (isShown) shownCount += 1;
      });
      group.style.display = !isPending && shownCount > 0 ? "" : "none";
    });
  };
  var applyProductVisibility = () => {
    let shownCount = 0;
    document.querySelectorAll(".predictive-search__list-item").forEach((item) => {
      const itemGenders = item.dataset.productGender.split(" ").filter(Boolean);
      const matches = selectedGender === "all" || itemGenders.length === 0 || itemGenders.includes(selectedGender);
      const withinCap = matches && shownCount < MAX_VISIBLE_PRODUCTS;
      item.style.display = withinCap ? "" : "none";
      if (withinCap) shownCount += 1;
    });
  };
  var setSelectedGender = (gender) => {
    var _a4;
    selectedGender = gender;
    applyProductVisibility();
    applyCollectionVisibility();
    syncNavToGender(gender);
    document.querySelectorAll(genderTabsSelectors.genderTab).forEach((tab) => {
      const isActive = tab.dataset.gender === gender;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", String(isActive));
    });
    const label = document.querySelector(genderTabsSelectors.searchPlaceholderLabel);
    if (label) {
      label.textContent = (_a4 = placeholderStringByGender()[gender]) != null ? _a4 : "";
    }
    document.querySelectorAll("[data-search-gender-filter]").forEach((input) => {
      input.value = getGenderFilterValue();
    });
    if (lastSearchTerm && (tagalysHelpers == null ? void 0 : tagalysHelpers.updateQuery)) {
      tagalysHelpers.updateQuery(lastSearchTerm);
    }
  };
  var renderGenderTabs = (html, { compact = false } = {}) => {
    var _a4, _b3, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    const genders = [
      { key: "womens", label: (_c = (_b3 = (_a4 = window.theme) == null ? void 0 : _a4.strings) == null ? void 0 : _b3.search) == null ? void 0 : _c.womens },
      { key: "mens", label: (_f = (_e = (_d = window.theme) == null ? void 0 : _d.strings) == null ? void 0 : _e.search) == null ? void 0 : _f.mens },
      { key: "all", label: (_i = (_h = (_g = window.theme) == null ? void 0 : _g.strings) == null ? void 0 : _h.search) == null ? void 0 : _i.all }
    ];
    return html`
    <div
      class="predictive-search__gender-tabs${compact ? " predictive-search__gender-tabs--compact" : ""}"
      role="tablist"
      aria-label="${(_l = (_k = (_j = window.theme) == null ? void 0 : _j.strings) == null ? void 0 : _k.search) == null ? void 0 : _l.genderFilter}"
    >
      ${genders.map(
      (gender) => html`
          <button
            type="button"
            class="predictive-search__gender-tab${selectedGender === gender.key ? " is-active" : ""}"
            data-gender="${gender.key}"
            role="tab"
            aria-selected="${selectedGender === gender.key}"
          >
            ${gender.label}
          </button>
        `
    )}
    </div>
  `;
  };
  var renderResponsiveImage = (html, image, altFallback) => {
    var _a4;
    return html`<img
  class="predictive-search__image"
  src="${image.src}&width=340"
  srcset="
    ${image.src}&width=160   160w,
    ${image.src}&width=360   360w,
    ${image.src}&width=533   533w,
    ${image.src}&width=720   720w,
    ${image.src}&width=940   940w,
    ${image.src}&width=1066 1066w,
    ${image.src}&width=2132 2132w
  "
  sizes="(min-width: 768px) 25vw, 30vw"
  width="${image.width}"
  height="${image.height}"
  alt="${(_a4 = image.alt) != null ? _a4 : altFallback}"
/>`;
  };
  var renderProductImages = (html, product) => {
    var _a4;
    const images = ((_a4 = product.images) == null ? void 0 : _a4.length) ? product.images : product.featured_image ? [product.featured_image] : [];
    if (images.length === 0) return null;
    if (images.length === 1) {
      return renderResponsiveImage(html, images[0], product.title);
    }
    return html`
    <div class="predictive-search__image-slider" data-slider>
      ${images.map((image) => html`<div class="predictive-search__image-slide">
        ${renderResponsiveImage(html, image, product.title)}
      </div>`)}
    </div>
  `;
  };
  var renderProduct = (html, args) => {
    var _a4, _b3, _c, _d, _e, _f, _g, _h;
    const props = args.props;
    const product = props.product;
    const helpers = props.helpers;
    const productOptions = helpers.getTemplateOptions("product");
    const productUrl = productOptions.productPageUrl(product);
    const badgeTags = product.tags ? (_a4 = product.tags) == null ? void 0 : _a4.filter((tag) => tag.includes("label:")) : [];
    return html`
    <a
      href=${productUrl}
      class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text product-card-wrapper-TWP"
    >
      ${renderProductImages(html, product)}

      <div class="predictive-search__item-content">
        <span class="visually-hidden">${(_d = (_c = (_b3 = window.theme) == null ? void 0 : _b3.strings) == null ? void 0 : _c.accessibility) == null ? void 0 : _d.vendor}</span>
        <div class="predictive-search__item-vendor caption-with-letter-spacing">${product.vendor}</div>

        <p class="predictive-search__item-heading paragraph--small">${product.title}</p>

        ${helpers.isProductOnSale(product.compare_at_price, product.price) ? html`
              <p class="price price--on-sale">
                <div class="price__sale">
                  <span class="visually-hidden">${(_f = (_e = window.theme) == null ? void 0 : _e.strings) == null ? void 0 : _f.regularPriceLabel}</span>
                  <s class="price-item price-item--regular">
                    ${helpers.formatCurrency(product.compare_at_price)}
                  </s>
                  <span class="visually-hidden">${(_h = (_g = window.theme) == null ? void 0 : _g.strings) == null ? void 0 : _h.salePriceLabel}</span>
                  <span class="price-item price-item--sale price-item--last">
                    ${helpers.formatCurrency(product.price)}
                  </span>
                </div>
              </p>
            ` : html`
              <p class="price">
                <div class="price__regular">
                  <span class="price-item price-item--regular">${helpers.formatCurrency(product.price)}</span>
                </div>
              </p>
            `}
      </div>

      ${badgeTags.length > 0 ? html`
            <div class="card__badge">
              ${badgeTags.map((tag) => {
      const badgeText = tag.replace("label:", "");
      return html`<span class="badge">${badgeText}</span>`;
    })}
            </div>
          ` : ""}
    </a>
  `;
  };
  var updateResultsMaxHeight = () => {
    var _a4, _b3;
    const headerSection = document.querySelector(".section-header");
    const resultsContainer = document.querySelector(".tagalys-search-suggestions");
    if (!headerSection || !resultsContainer) return;
    const viewportHeight = (_b3 = (_a4 = window.visualViewport) == null ? void 0 : _a4.height) != null ? _b3 : window.innerHeight;
    const resultsMaxHeight = viewportHeight - headerSection.getBoundingClientRect().bottom;
    resultsContainer.style.maxHeight = `${resultsMaxHeight}px`;
  };
  var initTagalysSearchSuggestions = () => {
    onTagalysReady(() => {
      var _a4, _b3, _c, _d;
      const searchInput = document.querySelector(selectors3.searchInput);
      if (!searchInput) return;
      setSelectedGender(selectedGender);
      (_a4 = window.visualViewport) == null ? void 0 : _a4.addEventListener("resize", updateResultsMaxHeight);
      const searchSummary = document.querySelector(".header__search summary");
      searchSummary == null ? void 0 : searchSummary.addEventListener("click", () => {
        var _a5;
        if ((_a5 = searchSummary.closest("details")) == null ? void 0 : _a5.open) return;
        if (opensOnAll) {
          if (selectedGender !== "all") setSelectedGender("all");
          return;
        }
        const navGender = getSectionGender();
        if (!navGender) return;
        setSelectedGender(navGender);
      });
      document.addEventListener("click", (event) => {
        const tab = event.target.closest(genderTabsSelectors.genderTab);
        if (!tab) return;
        setSelectedGender(tab.dataset.gender);
      });
      new MutationObserver(() => {
        applyProductVisibility();
        applyCollectionVisibility();
      }).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["data-collection-scope"]
      });
      const rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : "";
      document.addEventListener(
        "keydown",
        (event) => {
          if (event.key !== "Enter" || !event.target.matches(selectors3.searchInput)) return;
          const genderParam = getGenderSearchUrlParam();
          if (!genderParam) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.href = `${rootUrl}${window.theme.routes.search}?q=${encodeURIComponent(event.target.value)}${genderParam}`;
        },
        true
      );
      (_d = (_c = (_b3 = window.Tagalys) == null ? void 0 : _b3.UIWidgets) == null ? void 0 : _c.SearchSuggestions) == null ? void 0 : _d.init(selectors3.searchInput, {
        searchResultsURL: `${rootUrl}${window.theme.routes.search}`,
        templates: {
          widget: {
            options: {
              includeTagalysCSS: false,
              request: __spreadValues({
                products: {
                  limit: PRODUCT_FETCH_LIMIT
                },
                collections: {
                  limit: COLLECTION_FETCH_LIMIT
                },
                pages: {
                  limit: 3
                }
              }, isAutocompleteEnabled() && {
                [AUTOCOMPLETE_SECTION_ID]: {
                  limit: AUTOCOMPLETE_LIMIT
                }
              }),
              inheritAlignmentElementWidth: false,
              position(inputDOMNode, widgetDOMNode) {
                const searchForm = inputDOMNode.parentElement;
                const widgetParent = widgetDOMNode.parentElement;
                searchForm.after(widgetParent);
                return false;
              }
            }
          },
          hint: {
            render(html) {
              return html``;
            }
          },
          clickSuggestions: {
            render(html, args) {
              var _a5, _b4, _c2;
              return html`
              <div class="predictive-search__main predictive-search__main--full-width">
                ${renderGenderTabs(html)}
                <h2 class="predictive-search__results-heading">
                  ${(_c2 = (_b4 = (_a5 = window.theme) == null ? void 0 : _a5.strings) == null ? void 0 : _b4.search) == null ? void 0 : _c2.recentlyViewed}
                </h2>
                <${args.templates.featuredProductsSuggestions} />
              </div>
            `;
            }
          },
          featuredProductsSuggestions: {
            render(html) {
              return html`<div
              className="featured-products-suggestions featured_products-wrapper"
              data-tagalys-widget="featured-products-suggestions"
            ></div>`;
            },
            callbacks: {
              afterInitialRender: () => {
                var _a5, _b4;
                const widgetId = (_b4 = (_a5 = window.theme) == null ? void 0 : _a5.tagalys) == null ? void 0 : _b4.featuredProductsWidget.id;
                if (!widgetId) return;
                window.Tagalys.UIWidgets.SmartWidget.init(selectors3.featuredProductsWidget, {
                  widgetId,
                  templates: {
                    widget: {
                      options: {
                        limit: PRODUCT_FETCH_LIMIT,
                        displayFormat: "grid",
                        includeTagalysCSS: false
                      },
                      render: (html, args) => {
                        const props = args.props;
                        const helpers = props.helpers;
                        const products = helpers.getProducts();
                        if (props.loading === false) {
                          if (products.length === 0) {
                            return null;
                          }
                          return html` <${args.templates.products} /> `;
                        }
                      }
                    },
                    products: {
                      render: (html, args) => {
                        return renderProductsList(html, args);
                      }
                    },
                    product: {
                      render(html, args) {
                        return renderProduct(html, args);
                      }
                    }
                  }
                });
              }
            }
          },
          typeSuggestions: {
            render(html, args) {
              var _a5, _b4, _c2, _d2, _e, _f, _g, _h, _i, _j;
              const props = args.props;
              const helpers = props.helpers;
              const response = helpers.getAPIResponse();
              const responseTotal = (_b4 = (_a5 = response == null ? void 0 : response.metadata) == null ? void 0 : _a5.products) == null ? void 0 : _b4.total;
              const searchTerm = props.helpers.getEnteredSearchQuery();
              const searchPageUrl = `${rootUrl}${window.theme.routes.search}?q=${encodeURIComponent(searchTerm)}${getGenderSearchUrlParam()}`;
              const termSuggestions = getAutocompleteSuggestions(helpers);
              lastSearchTerm = searchTerm;
              tagalysHelpers = helpers;
              return html`
              ${termSuggestions.length ? html`
                    ${renderTermSuggestions(html, { items: termSuggestions, searchTerm, searchPageUrl })}
                    <hr class="predictive-search__term-suggestions-divider" />
                  ` : null}

              <div class="predictive-search__overlay-layout">
                <div class="predictive-search__sidebar">
                  ${helpers.hasTextSearchSuggestions() ? html` <${args.templates.textSuggestions} /> ` : null}
                </div>

                <div class="predictive-search__main">
                  ${renderGenderTabs(html, { compact: true })}
                  <${args.templates.products} />

                  ${responseTotal ? html`
                        <a
                          href=${searchPageUrl}
                          class="predictive-search__item predictive-search__item--term animate-arrow"
                        >
                          <span data-predictive-search-search-for-text>
                            ${responseTotal === 1 ? (_f = (_e = (_d2 = (_c2 = window.theme) == null ? void 0 : _c2.strings) == null ? void 0 : _d2.search) == null ? void 0 : _e.viewAllWithCount.one) == null ? void 0 : _f.replace("{{ count }}", responseTotal) : (_j = (_i = (_h = (_g = window.theme) == null ? void 0 : _g.strings) == null ? void 0 : _h.search) == null ? void 0 : _i.viewAllWithCount.other) == null ? void 0 : _j.replace(
                "{{ count }}",
                responseTotal
              )}
                          </span>
                        </a>
                      ` : null}
                </div>
              </div>
            `;
            }
          },
          textSuggestions: {
            render(html, args) {
              const props = args.props;
              const helpers = props.helpers;
              const textSuggestions = helpers.getTextSuggestions().filter((suggestion) => suggestion.section_id !== AUTOCOMPLETE_SECTION_ID);
              return html`
              ${textSuggestions.map((suggestion) => {
                var _a5;
                const isPages = suggestion.section_id === "pages";
                const isCollections = suggestion.section_id === "collections";
                const pillClass = isPages ? "predictive-search__pill predictive-search__pill--secondary" : "predictive-search__pill";
                return html`
                  <div
                    data-collection-suggestions=${isCollections ? "" : void 0}
                    data-collection-scope=${isCollections ? selectedGender : void 0}
                    style=${isCollections && selectedGender !== "all" ? "display: none" : void 0}
                  >
                    <h2 class="predictive-search__heading">
                      ${suggestion.section_title}
                    </h2>
                    <div class="predictive-search__pill-group">
                      ${(_a5 = suggestion.items) == null ? void 0 : _a5.map(
                  (item, index) => {
                    var _a6;
                    return html`<a
                            href=${item.link}
                            class="${pillClass}"
                            tabindex="-1"
                            data-collection-handle=${isCollections ? (_a6 = getCollectionHandle(item.link)) != null ? _a6 : "" : void 0}
                            style=${isCollections && selectedGender === "all" && index >= MAX_VISIBLE_COLLECTIONS ? "display: none" : void 0}
                            >${item.displayString}</a
                          >`;
                  }
                )}
                    </div>
                  </div>
                `;
              })}
            `;
            }
          },
          products: {
            render(html, args) {
              return renderProductsList(html, args);
            }
          },
          product: {
            render(html, args) {
              return renderProduct(html, args);
            }
          }
        },
        callbacks: {
          afterInitialRender: updateResultsMaxHeight,
          beforeAPICall: applyGenderScopeToRequest
        }
      });
    });
  };

  // src/scripts/components/tagalys-search-results.js
  var selectors4 = {
    widget: '[data-tagalys-widget="search-results"]',
    drawer: "[data-filters-drawer]",
    facetsVertical: "[data-facets-vertical]"
  };
  var tagalysSearchResults = (container) => {
    var _a4, _b3, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea, _Fa, _Ga, _Ha;
    const widgetElem = container.querySelector(selectors4.widget);
    if (!widgetElem) return;
    const isDesktop = window.matchMedia("(min-width: 990px)").matches;
    const itemsPerPage = (_a4 = widgetElem.dataset.limit) != null ? _a4 : 24;
    const noResultsWidgetId = (_b3 = widgetElem.dataset) == null ? void 0 : _b3.noResultsWidget;
    const noResultsWidgetLimit = (_c = widgetElem.dataset.noResultsWidgetLimit) != null ? _c : 4;
    const filtersType = (_d = widgetElem.dataset.filtersType) != null ? _d : "horizontal";
    const showVerticalFilters = widgetElem.dataset.showVerticalFilters === "true";
    const searchFilterLabel = (_e = widgetElem.dataset.searchFilterLabel) == null ? void 0 : _e.toLowerCase();
    const showFilterResultsCount = widgetElem.dataset.showFilterResultsCount === "true";
    const defaultExpandedFilters = (_f = widgetElem.dataset.defaultExpandedFilters) != null ? _f : "";
    const showMoreNumber = isDesktop ? 10 : 5;
    (_Ha = (_h = (_g = window.Tagalys) == null ? void 0 : _g.UIWidgets) == null ? void 0 : _h.SearchResults) == null ? void 0 : _Ha.init(selectors4.widget, {
      templates: {
        widget: {
          options: {
            limit: itemsPerPage,
            includeTagalysCSS: false
          },
          labels: {
            searchResults: {
              heading: {
                standard: (_j = (_i = window.theme) == null ? void 0 : _i.strings.search) == null ? void 0 : _j.titleWithCount,
                corrected: (_l = (_k = window.theme) == null ? void 0 : _k.strings.search) == null ? void 0 : _l.titleCorrected,
                partialMatches: (_n = (_m = window.theme) == null ? void 0 : _m.strings.search) == null ? void 0 : _n.titlePartialMatches,
                noResults: (_p = (_o = window.theme) == null ? void 0 : _o.strings.search) == null ? void 0 : _p.noResults
              }
            },
            filters: {
              heading: (_u = (_t = (_s = (_r = (_q = window.theme) == null ? void 0 : _q.strings) == null ? void 0 : _r.search) == null ? void 0 : _s.filters) == null ? void 0 : _t.heading) != null ? _u : "Filter",
              selected: (_z = (_y = (_x = (_w = (_v = window.theme) == null ? void 0 : _v.strings) == null ? void 0 : _w.search) == null ? void 0 : _x.filters) == null ? void 0 : _y.selected) != null ? _z : "{{ count }} selected",
              maxPrice: (_E = (_D = (_C = (_B = (_A = window.theme) == null ? void 0 : _A.strings) == null ? void 0 : _B.search) == null ? void 0 : _C.filters) == null ? void 0 : _D.maxPrice) != null ? _E : "The highest price is {{ price }}",
              from: (_J = (_I = (_H = (_G = (_F = window.theme) == null ? void 0 : _F.strings) == null ? void 0 : _G.search) == null ? void 0 : _H.filters) == null ? void 0 : _I.from) != null ? _J : "From",
              to: (_O = (_N = (_M = (_L = (_K = window.theme) == null ? void 0 : _K.strings) == null ? void 0 : _L.search) == null ? void 0 : _M.filters) == null ? void 0 : _N.to) != null ? _O : "To",
              reset: (_T = (_S = (_R = (_Q = (_P = window.theme) == null ? void 0 : _P.strings) == null ? void 0 : _Q.search) == null ? void 0 : _R.filters) == null ? void 0 : _S.reset) != null ? _T : "Reset",
              clear: (_Y = (_X = (_W = (_V = (_U = window.theme) == null ? void 0 : _U.strings) == null ? void 0 : _V.search) == null ? void 0 : _W.filters) == null ? void 0 : _X.clear) != null ? _Y : "Clear",
              clearFilter: (_ba = (_aa = (_$ = (__ = (_Z = window.theme) == null ? void 0 : _Z.strings) == null ? void 0 : __.search) == null ? void 0 : _$.filters) == null ? void 0 : _aa.clearFilter) != null ? _ba : "Remove",
              clearAll: (_ga = (_fa = (_ea = (_da = (_ca = window.theme) == null ? void 0 : _ca.strings) == null ? void 0 : _da.search) == null ? void 0 : _ea.filters) == null ? void 0 : _fa.clearAll) != null ? _ga : "Remove all",
              apply: (_la = (_ka = (_ja = (_ia = (_ha = window.theme) == null ? void 0 : _ha.strings) == null ? void 0 : _ia.search) == null ? void 0 : _ja.filters) == null ? void 0 : _ka.apply) != null ? _la : "Apply",
              label: (_qa = (_pa = (_oa = (_na = (_ma = window.theme) == null ? void 0 : _ma.strings) == null ? void 0 : _na.search) == null ? void 0 : _oa.filters) == null ? void 0 : _pa.label) != null ? _qa : "Filter",
              buttonLabel: (_va = (_ua = (_ta = (_sa = (_ra = window.theme) == null ? void 0 : _ra.strings) == null ? void 0 : _sa.search) == null ? void 0 : _ta.filters) == null ? void 0 : _ua.buttonLabel) != null ? _va : "Filter"
            },
            sortOptions: {
              label: (_ya = (_xa = (_wa = window.theme) == null ? void 0 : _wa.strings) == null ? void 0 : _xa.search) == null ? void 0 : _ya.sortBy
            },
            resultsWithCount: {
              one: (_Ca = (_Ba = (_Aa = (_za = window.theme) == null ? void 0 : _za.strings) == null ? void 0 : _Aa.search) == null ? void 0 : _Ba.resultsWithCount) == null ? void 0 : _Ca.one,
              other: (_Ga = (_Fa = (_Ea = (_Da = window.theme) == null ? void 0 : _Da.strings) == null ? void 0 : _Ea.search) == null ? void 0 : _Fa.resultsWithCount) == null ? void 0 : _Ga.other
            }
          },
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            if (helpers.isInitialLoading()) {
              return html` <${args.templates.loader} /> `;
            }
            if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
              return html` <${args.templates.noResults} /> `;
            }
            if (filtersType === "vertical") {
              return html`
              <${args.templates.header} />

              <${args.templates.filtersVerticalCount} />

              <div class="facets-vertical">
                <${args.templates.filtersVertical} />

                <div class="product-grid-container" id="ProductGridContainer">
                  <div class="active-facets-TWP active-facets active-facets-desktop">
                    <${args.templates.appliedFilters} />
                  </div>
                  <div class="template-search__results collection TWP-collection" id="product-grid">
                    <${args.templates.products} />
                    <${args.templates.productListFooter} />
                  </div>
                </div>
              </div>
            `;
            }
            return html`
            <${args.templates.header} />
            <${args.templates.productListHeader} />
            <div class="product-grid-container" id="ProductGridContainer">
              <div class="template-search__results collection" id="product-grid">
                <${args.templates.products} />
                <${args.templates.productListFooter} />
              </div>
            </div>
          `;
          }
        },
        loader: {
          render(html) {
            return html`
            <div class="loading__spinner">
              <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path" />
              </svg>
            </div>
          `;
          }
        },
        header: {
          render(html, args) {
            return html`
            <div class="template-search__header page-width scroll-trigger animate--fade-in">
              <${args.templates.heading} />
            </div>
          `;
          }
        },
        heading: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const getHeadingBasedOnAPIResponse = () => {
              var _a5, _b4, _c2, _d2;
              let headingText;
              if (!helpers.getQuery()) {
                headingText = (_d2 = (_c2 = (_b4 = (_a5 = window.theme) == null ? void 0 : _a5.strings) == null ? void 0 : _b4.search) == null ? void 0 : _c2.search) != null ? _d2 : "Search";
              } else if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
                headingText = labels.searchResults.heading.noResults.replace("{{ terms }}", helpers.getQuery());
              } else if (helpers.isPartialResults()) {
                headingText = labels.searchResults.heading.partialMatches.replace("{{searchTerm}}", helpers.getQuery());
              } else if (helpers.isSpellingCorrectedQuery()) {
                headingText = labels.searchResults.heading.corrected.replace("{{originalSearchTerm}}", helpers.getOriginalQuery()).replace("{{resultsCount}}", helpers.getTotalProductsCount()).replace("{{correctedSearchTerm}}", helpers.getQuery());
              } else {
                headingText = labels.searchResults.heading.standard.replace("{{resultsCount}}", helpers.getTotalProductsCount()).replace("{{searchTerm}}", helpers.getQuery());
              }
              return decodeHtmlEntities(headingText);
            };
            return html`<h1 class="h5 center">${getHeadingBasedOnAPIResponse()}</h1>`;
          }
        },
        productListHeader: {
          render(html, args) {
            return html`
            <div id="main-search-filters" class="facets-wrapper facets-wrapper-TWP page-width">
              <div class="TWP-facets-container--horizontal facets-container scroll-trigger animate--fade-in">
                <!---------- DESKTOP FILTERS ---------->
                <div class="facets small-hide">
                  <div class="facets__form">
                    <${args.templates.filters} type="desktop" />
                    <${args.templates.sortOptions} type="dropdown" />
                    <div class="product-count light" role="status">
                      <h2 class="product-count__text text-body">
                        <${args.templates.resultsCountLabel} />
                      </h2>
                    </div>
                  </div>
                </div>

                <!---------- MOBILE FILTERS ---------->
                <${args.templates.mobileFiltersContainer} />
              </div>
              <div class="active-facets-TWP active-facets active-facets-mobile medium-hide large-up-hide">
                <${args.templates.appliedFilters} />
              </div>
            </div>
          `;
          }
        },
        mobileFiltersContainer: {
          render(html, args) {
            const labels = args.labels;
            return html`
            <menu-drawer
              class="mobile-facets__wrapper medium-hide large-up-hide"
              data-breakpoint="mobile"
              data-filters-drawer
            >
              <details class="mobile-facets__disclosure disclosure-has-popup">
                <summary class="mobile-facets__open-wrapper focus-offset">
                  <span class="mobile-facets__open">
                    <${args.templates.icon} type="filters" />

                    <span
                      class="mobile-facets__open-label button-label medium-hide large-up-hide caption--strong"
                      dangerouslySetInnerHTML=${{
              __html: labels.filters.label
            }}
                    >
                    </span>
                    <span class="mobile-facets__open-label button-label small-hide">${labels.filters.buttonLabel}</span>
                  </span>
                  <span tabindex="0" class="mobile-facets__close">
                    <span class="svg-wrapper">
                      <${args.templates.icon} type="close" />
                    </span>
                  </span>
                </summary>
                <div class="facet-filters-form">
                  <div class="mobile-facets">
                    <div class="mobile-facets__inner gradient">
                      <div class="mobile-facets__header">
                        <div class="mobile-facets__header-inner">
                          <h2 class="mobile-facets__heading medium-hide large-up-hide caption--strong">
                            <${args.templates.icon} type="filters" />
                            <span dangerouslySetInnerHTML=${{ __html: labels.filters.label }}></span>
                          </h2>
                          <h2 class="mobile-facets__heading small-hide">${labels.filters.buttonLabel}</h2>
                          <p class="mobile-facets__count"><${args.templates.resultsCountLabel} /></p>
                        </div>
                      </div>

                      <${args.templates.filters} type="mobile" />
                    </div>
                  </div>
                </div>
              </details>
            </menu-drawer>
          `;
          },
          callbacks: {
            afterInitialRender: () => {
              const menuDrawer = widgetElem.querySelector(selectors4.drawer);
              menuDrawer == null ? void 0 : menuDrawer.setAttribute("data-initialized", "");
            }
          }
        },
        filtersVerticalCount: {
          render(html, args) {
            var _a5, _b4, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
            return html`
            <div class="facets facets-vertical-count small-hide">
              <div class="facets-vertical-form">
                <div class="product-count-vertical" role="status">
                  <h2 class="product-count__text">
                    <${args.templates.resultsCountLabel} />
                  </h2>
                </div>
                <facets-vertical-open>
                  <button
                    class="facets-vertical-open__btn btn-none"
                    type="button"
                    aria-expanded="${showVerticalFilters ? "true" : "false"}"
                    data-facets-vertical-open
                  >
                    <${args.templates.icon} type="filters" />

                    <span class="facets-vertical-open__label facets-vertical-open__label--show caption--strong">
                      ${(_e2 = (_d2 = (_c2 = (_b4 = (_a5 = window.theme) == null ? void 0 : _a5.strings) == null ? void 0 : _b4.search) == null ? void 0 : _c2.filters) == null ? void 0 : _d2.filterButtonShow) != null ? _e2 : "Filter"}
                    </span>

                    <span class="facets-vertical-open__label facets-vertical-open__label--hide caption--strong">
                      ${(_j2 = (_i2 = (_h2 = (_g2 = (_f2 = window.theme) == null ? void 0 : _f2.strings) == null ? void 0 : _g2.search) == null ? void 0 : _h2.filters) == null ? void 0 : _i2.filterButtonHide) != null ? _j2 : "Filter"}
                    </span>
                  </button>
                </facets-vertical-open>
              </div>
            </div>
          `;
          }
        },
        filtersVertical: {
          render(html, args) {
            return html`
            <aside
              class="facets-wrapper facets-wrapper-TWP facets-wrapper-TWP--vertical${showVerticalFilters ? "" : " facets-wrapper-TWP--vertical-hidden"}"
              data-facets-vertical
            >
              <div class="facets small-hide">
                <div class="facets__form-vertical">
                  <${args.templates.filters} type="desktop" />
                </div>
              </div>

              <${args.templates.mobileFiltersContainer} />
            </aside>
          `;
          },
          callbacks: {
            afterInitialRender: () => {
              const facetsVertical = widgetElem.querySelector(selectors4.facetsVertical);
              if (!facetsVertical) return;
              document.dispatchEvent(new CustomEvent("tagalys-search:vertical-filters-ready"));
            }
          }
        },
        filters: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const filters = helpers.getFilters();
            if (props.type === "mobile") {
              return html`
              <div id="FacetsWrapperMobile" class="mobile-facets__main has-submenu gradient">
                <${args.templates.sortOptions} type="list" device="mobile" />

                ${filters.map(
                (filter, index) => html`<${args.templates.filterMobile} filter=${filter} index=${index + 1} />`
              )}

                <div class="mobile-facets__footer">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${() => helpers.clearAllFilters()}
                    >
                      ${labels.filters.clearAll}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${(event) => {
                var _a5, _b4;
                (_b4 = (_a5 = event.target.closest(".mobile-facets__wrapper")) == null ? void 0 : _a5.querySelector("summary")) == null ? void 0 : _b4.click();
              }}
                  >
                    ${labels.filters.apply}
                  </button>
                </div>
              </div>
            `;
            }
            const hasAvailabilityFilter = filters.some((f) => f.id === "_derived_field_in_stock");
            const stubAvailabilityFilter = {
              id: "_derived_field_in_stock",
              name: "Available",
              type: "checkbox",
              items: [{ id: "true", name: "In Stock", count: 0, selected: false }]
            };
            return html`
            <div id="FacetsWrapperDesktop" class="facets__wrapper">
              <h2 class="facets__heading caption-large text-body" id="verticalTitle" tabindex="-1">
                ${labels.filters.heading}
              </h2>

              ${filtersType === "vertical" ? html` <${args.templates.sortOptions} type="list" device="desktop" />` : ""}
              ${!hasAvailabilityFilter ? html`<${args.templates.filter} filter=${stubAvailabilityFilter} index=${0} />` : ""}
              ${filters.map((filter, index) => html`<${args.templates.filter} filter=${filter} index=${index + 1} />`)}
            </div>
            ${filtersType !== "vertical" ? html`
                  <div class="active-facets-TWP active-facets active-facets-desktop">
                    <${args.templates.appliedFilters} />
                  </div>
                ` : ""}
          `;
          }
        },
        filterMobile: {
          render(html, args) {
            var _a5, _b4, _c2;
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const filter = props.filter;
            const index = props.index;
            let selectedFiltersLabel = "";
            if (filter.type === "range") {
              const maxPrice = helpers.labelFormatter(filter.display_format, filter.max, filter.currency);
              selectedFiltersLabel = labels.filters.maxPrice.replace("{{ price }}", maxPrice);
            }
            const isOpen = defaultExpandedFilters.includes(filter.name.toLowerCase());
            const hasShowMore = filtersType === "vertical" && ((_a5 = filter.items) == null ? void 0 : _a5.length) > showMoreNumber;
            return html`
            <details
              id="Details-Mobile-${filter.id}-search"
              class="mobile-facets__details${isOpen ? " menu-opening" : ""}"
              data-index="mobile-${index}"
              open=${isOpen}
            >
              <summary class="mobile-facets__summary focus-inset caption--strong">
                <div>
                  <span>${filter.name}</span>
                  <span class="mobile-facets__arrow">
                    <${args.templates.icon} type="chevron-down" />
                  </span>
                </div>
              </summary>

              <div
                id="FacetMobile-${index}-search"
                class="mobile-facets__submenu gradient parent-display"
                data-facets-container
              >
                ${filter.type === "range" ? html` <p class="mobile-facets__info">${selectedFiltersLabel}</p>
                      <${args.templates.rangeSliderFilterItem} filter=${filter} />` : html`
                      <div class="parent-wrap">
                        ${filtersType == "vertical" && filter.name.toLowerCase() === searchFilterLabel ? html` <${args.templates.filterSearch} filter=${filter} /> ` : ""}
                        <ul
                          class="facets-layout facets-layout-list facets-layout-list--text mobile-facets__list list-unstyled"
                          role="list"
                        >
                          ${(_b4 = filter.items) == null ? void 0 : _b4.map(
              (filterItem, index2) => html`<${args.templates.filterItemMobile}
                                filterItem=${filterItem}
                                index=${index2 + 1}
                                filterId=${filter.id}
                                hasShowMore=${hasShowMore}
                              />`
            )}
                        </ul>
                      </div>
                      ${filtersType === "vertical" && ((_c2 = filter.items) == null ? void 0 : _c2.length) > showMoreNumber ? html` <${args.templates.showMoreButton} filterId=${filter.id} /> ` : ""}
                    `}

                <div class="mobile-facets__footer gradient">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${() => helpers.clearFilter(filter.id)}
                    >
                      ${labels.filters.clear}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${(event) => {
              var _a6, _b5;
              (_b5 = (_a6 = event.target.closest(".mobile-facets__wrapper")) == null ? void 0 : _a6.querySelector("summary")) == null ? void 0 : _b5.click();
            }}
                  >
                    ${labels.filters.apply}
                  </button>
                </div>
              </div>
            </details>
          `;
          }
        },
        filter: {
          render(html, args) {
            var _a5, _b4, _c2;
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const filter = props.filter;
            const index = props.index;
            const selectedFiltersCount = (_a5 = filter.items) == null ? void 0 : _a5.filter((item) => item.selected).length;
            let selectedFiltersLabel = labels.filters.selected.replace("{{ count }}", selectedFiltersCount);
            if (filter.type === "range") {
              const maxPrice = helpers.labelFormatter(filter.display_format, filter.max, filter.currency);
              selectedFiltersLabel = labels.filters.maxPrice.replace("{{ price }}", maxPrice);
            }
            const isOpen = filtersType === "vertical" && defaultExpandedFilters.includes(filter.name.toLowerCase());
            if (filter.id == "_derived_field_in_stock") {
              const inStockFilter = (_b4 = filter.items) == null ? void 0 : _b4.find((item) => item.id === "true");
              const onFilterClick = (event) => {
                event.stopPropagation();
                if (inStockFilter.selected) {
                  helpers.clearFilter(filter.id, inStockFilter.id);
                } else {
                  helpers.applyFilter(filter.id, inStockFilter.id);
                }
              };
              if (inStockFilter) {
                const availabilityClass = inStockFilter.selected ? "availability-auto-applied" : "";
                return html`
                <div class="facets__summary facets__summary--availability ${availabilityClass} caption--strong">
                  <label class="facet-availablity__wrapper" onclick=${onFilterClick}>
                    <span>${inStockFilter.name}</span>

                    <div class="facet-availablity__switch">
                      <input
                        class="visually-hidden"
                        type="checkbox"
                        name="${filter.id}"
                        value="${inStockFilter.name}"
                        id="Filter-${filter.id}-${inStockFilter.value}"
                        checked=${inStockFilter.selected}
                      />
                      <span class="facet-availability__switch-slider"></span>
                    </div>
                  </label>
                </div>
              `;
              }
            }
            return html`
            <details
              id="Details-${filter.id}-search"
              class="${filtersType === "vertical" ? "facets__disclosure-vertical" : "facets__disclosure disclosure-has-popup"}"
              data-index="${index}"
              open=${isOpen}
            >
              <summary class="facets__summary caption--strong focus-offset">
                <div>
                  <span class="facets__summary-label">${filter.name}</span>
                  <${args.templates.icon} type="caret" />
                </div>
              </summary>

              <div
                id="Facet-${index}-search"
                class="parent-display ${filtersType === "vertical" ? "facets__display-vertical" : "facets__display"}"
                data-facets-container
              >
                ${filtersType !== "vertical" ? html`
                      <div class="facets__header">
                        <div>
                          <span class="facets__selected">${selectedFiltersLabel}</span>
                        </div>

                        <button
                          type="button"
                          class="facets__reset link underlined-link"
                          onClick=${() => helpers.clearFilter(filter.id)}
                        >
                          ${labels.filters.reset}
                        </button>
                      </div>
                    ` : ""}
                ${filtersType == "vertical" && filter.name.toLowerCase() === searchFilterLabel ? html`<${args.templates.filterSearch} filter=${filter} />` : ""}

                <${args.templates.filterItems} filter=${filter} />

                ${filtersType === "vertical" && ((_c2 = filter.items) == null ? void 0 : _c2.length) > showMoreNumber ? html` <${args.templates.showMoreButton} filterId=${filter.id} /> ` : ""}
              </div>
            </details>
          `;
          }
        },
        filterSearch: {
          render(html, args) {
            var _a5, _b4, _c2, _d2, _e2;
            const filter = args.props.filter;
            return html`
            <facets-search class="facets-search">
              <input
                class="facets-search__input caption--strong"
                type="text"
                name="${filter.param_name}-search"
                placeholder="Search"
                data-facets-search-input
              />
              <p class="facets-search__no-results hidden" data-facet-search-no-results>
                ${(_e2 = (_d2 = (_c2 = (_b4 = (_a5 = window.theme) == null ? void 0 : _a5.strings) == null ? void 0 : _b4.search) == null ? void 0 : _c2.filters) == null ? void 0 : _d2.noResults) != null ? _e2 : "No matching results"}
              </p>
            </facets-search>
          `;
          }
        },
        filterItems: {
          render(html, args) {
            var _a5, _b4;
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const hasShowMore = filtersType === "vertical" && ((_a5 = props.filter.items) == null ? void 0 : _a5.length) > showMoreNumber;
            let selectedFiltersLabel = "";
            if (props.filter.type === "range") {
              const maxPrice = helpers.labelFormatter(
                props.filter.display_format,
                props.filter.max,
                props.filter.currency
              );
              selectedFiltersLabel = labels.filters.maxPrice.replace("{{ price }}", maxPrice);
            }
            if (props.filter.type === "checkbox") {
              return html` <fieldset
              class="facets-wrap parent-wrap ${filtersType === "vertical" ? "facets-wrap-vertical" : ""}"
            >
              <legend class="visually-hidden">${props.filter.name}</legend>
              <ul
                class="facets-layout facets-layout-list facets-layout-list--text list-unstyled ${filtersType === "vertical" ? "facets__list--vertical" : "facets__list"}"
                role="list"
              >
                ${(_b4 = props.filter.items) == null ? void 0 : _b4.map(
                (filterItem, index) => html`<${args.templates.filterItem}
                      filterItem=${filterItem}
                      index=${index + 1}
                      filterId=${props.filter.id}
                      hasShowMore=${hasShowMore}
                    />`
              )}
              </ul>
            </fieldset>`;
            }
            if (props.filter.type === "range") {
              return html` ${filtersType === "vertical" ? html`<div class="facets__header-vertical">
                    <span class="facets__selected">${selectedFiltersLabel}</span>
                  </div>` : ""}
              <${args.templates.rangeSliderFilterItem} filter=${props.filter} />`;
            }
          }
        },
        filterItem: {
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const filterItem = props.filterItem;
            const inputId = `Filter-${props.filterId}-${props.index}`;
            const onFilterClick = (event) => {
              event.stopPropagation();
              const isNotComingSoon = window.location.pathname !== "/collections/womens-coming-soon";
              const isSizeFilter = props.filterId === "filter.v.m.custom.filtering_size" || props.filterId.toLowerCase().endsWith("size") && !props.filterId.includes("prize");
              const availabilityFilter = helpers.getFilters().find((f) => f.id === "_derived_field_in_stock");
              const enableAvailabilityFilter = () => {
                var _a5;
                if (availabilityFilter) {
                  const inStockItem = (_a5 = availabilityFilter.items) == null ? void 0 : _a5.find((item) => item.id === "true");
                  if (inStockItem && !inStockItem.selected) {
                    helpers.applyFilter("_derived_field_in_stock", "true");
                  }
                }
              };
              const clearAvailabilityFilter = () => {
                var _a5;
                if (availabilityFilter) {
                  const inStockItem = (_a5 = availabilityFilter.items) == null ? void 0 : _a5.find((item) => item.id === "true");
                  if (inStockItem && inStockItem.selected) {
                    helpers.clearFilter("_derived_field_in_stock", inStockItem.id);
                  }
                }
              };
              if (props.filterItem.selected) {
                helpers.clearFilter(props.filterId, props.filterItem.id);
                if (isSizeFilter && isNotComingSoon) {
                  const sizeFilters = helpers.getFilters().filter(
                    (f) => f.id === "filter.v.m.custom.filtering_size" || f.id.toLowerCase().endsWith("size") && !f.id.includes("prize")
                  );
                  const anySizeSelected = sizeFilters.some(
                    (filter) => filter.items && filter.items.some((item) => item.selected && item.id !== props.filterItem.id)
                  );
                  if (!anySizeSelected) {
                    clearAvailabilityFilter();
                  }
                }
              } else {
                helpers.applyFilter(props.filterId, props.filterItem.id);
                if (isSizeFilter && isNotComingSoon) {
                  enableAvailabilityFilter();
                }
              }
            };
            return html`<li
            class="list-menu__item facets__item${props.hasShowMore && props.index > showMoreNumber ? " show-more-item hidden" : ""}"
            data-facets-item
          >
            <label
              for=${inputId}
              class="facets__label facet-checkbox caption-with-letter-spacing"
              onclick=${onFilterClick}
            >
              <input
                type="checkbox"
                name=${props.filterId}
                value=${filterItem.name}
                id=${inputId}
                checked=${filterItem.selected}
              />

              <${args.templates.icon} type="square" />

              <div class="svg-wrapper">
                <${args.templates.icon} type="checkmark" />
              </div>

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label" data-facet-label>${filterItem.name}</span>
                ${showFilterResultsCount ? `(${filterItem.count})` : ""}
              </span>
            </label>
          </li>`;
          }
        },
        filterItemMobile: {
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const filterItem = props.filterItem;
            const inputId = `Filter-${props.filterId}-${props.index}`;
            const onFilterClick = (event) => {
              var _a5;
              event.stopPropagation();
              const isNotComingSoon = window.location.pathname !== "/collections/womens-coming-soon";
              const isSizeFilter = props.filterId === "filter.v.m.custom.filtering_size" || props.filterId.toLowerCase().endsWith("size") && !props.filterId.includes("prize");
              if (props.filterItem.selected) {
                helpers.clearFilter(props.filterId, props.filterItem.id);
              } else {
                helpers.applyFilter(props.filterId, props.filterItem.id);
                if (isSizeFilter && isNotComingSoon) {
                  const availabilityFilter = helpers.getFilters().find((f) => f.id === "_derived_field_in_stock");
                  if (availabilityFilter) {
                    const inStockItem = (_a5 = availabilityFilter.items) == null ? void 0 : _a5.find((item) => item.id === "true");
                    if (inStockItem && !inStockItem.selected) {
                      helpers.applyFilter("_derived_field_in_stock", "true");
                    }
                  }
                }
              }
            };
            return html`<li
            class="mobile-facets__item list-menu__item${props.hasShowMore && props.index > showMoreNumber ? " show-more-item hidden" : ""}"
            data-facets-item
          >
            <label
              for=${inputId}
              class="facets__label mobile-facets__label caption-with-letter-spacing"
              onclick=${onFilterClick}
            >
              <input
                class="mobile-facets__checkbox"
                type="checkbox"
                name=${props.filterId}
                value=${filterItem.name}
                id=${inputId}
                checked=${filterItem.selected}
              />

              <span class="mobile-facets__highlight"></span>

              <${args.templates.icon} type="square" />

              <${args.templates.icon} type="checkmark" />

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label" data-facet-label>${filterItem.name}</span>
                ${showFilterResultsCount ? `(${filterItem.count})` : ""}
              </span>
            </label>
          </li>`;
          }
        },
        rangeSliderFilterItem: {
          render(html, args) {
            var _a5, _b4, _c2, _d2;
            const props = args.props;
            const labels = args.labels;
            const inputId = `Filter-${props.filter.name}-`;
            return html`
            <div class="facets__price">
              <div class="hide" ref=${props.sliderRef} />
              <span class="field-currency caption--strong">${(_b4 = (_a5 = window.theme) == null ? void 0 : _a5.localization) == null ? void 0 : _b4.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${inputId}-GTE`}
                  class="field__input"
                  type="number"
                  value=${props.sliderInputValues[0]}
                  onblur=${props.onInputBlur}
                  onchange=${props.onMinChange}
                />
                <label class="field__label caption--strong" for=${`${inputId}-GTE`}>${labels.filters.from}</label>
              </div>
              <span class="field-currency caption--strong">${(_d2 = (_c2 = window.theme) == null ? void 0 : _c2.localization) == null ? void 0 : _d2.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${inputId}-LTE`}
                  class="field__input"
                  type="number"
                  value=${props.sliderInputValues[1]}
                  onblur=${props.onInputBlur}
                  onchange=${props.onMaxChange}
                />
                <label class="field__label caption--strong" for=${`${inputId}-LTE`}>${labels.filters.to}</label>
              </div>
            </div>
          `;
          }
        },
        appliedFilters: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const appliedFilters = helpers.getAppliedFilters(true);
            if (!appliedFilters.length) return "";
            return html`
            ${appliedFilters.map((filter) => {
              var _a5;
              if (filter.type === "range") {
                return html`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light btn-none"
                    onClick=${() => helpers.clearFilter(filter.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${helpers.labelFormatter(filter.display_format, filter.selected_min, filter.currency)} -
                      ${helpers.labelFormatter(filter.display_format, filter.selected_max, filter.currency)}
                      <span class="svg-wrapper">
                        <${args.templates.icon} type="close-small" />
                      </span>
                      <span class="visually-hidden">${labels.filters.clearFilter}</span>
                    </span>
                  </button>
                `;
              }
              return (_a5 = filter.items) == null ? void 0 : _a5.map((item) => {
                return html`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light btn-none"
                    onClick=${() => helpers.clearFilter(filter.id, item.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${item.name}
                      <span class="svg-wrapper">
                        <${args.templates.icon} type="close-small" />
                      </span>
                      <span class="visually-hidden">${labels.filters.clearFilter}</span>
                    </span>
                  </button>
                `;
              });
            })}

            <div class="active-facets__button-wrapper">
              <button
                type="button"
                class="active-facets__button active-facets__button-remove underlined-link btn-none"
                onClick=${() => helpers.clearAllFilters()}
              >
                <span class="active-facets__button-inner">
                  ${labels.filters.clearAll}
                  <span class="svg-wrapper">
                    <${args.templates.icon} type="close-small" />
                  </span>
                </span>
              </button>
            </div>
          `;
          }
        },
        sortOptions: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const sortOptions = helpers.getSortOptions();
            const appliedSortOption = helpers.getAppliedSortOption();
            const applySortOption = (event) => {
              if (event.target.type === "radio" && !event.target.checked) {
                return;
              }
              helpers.applySortOption(event.target.value);
            };
            const isOpen = defaultExpandedFilters.includes(labels.sortOptions.label.toLowerCase());
            if (props.type === "list") {
              return html`
              <details
                id="${props.device === "desktop" ? "Details-sortby-search" : "Details-Mobile-SortBy-search"}"
                class="${props.device === "desktop" ? "facets__disclosure-vertical" : "mobile-facets__details menu-opening"}"
                open=${isOpen}
              >
                <summary
                  class="${props.device === "desktop" ? "facets__summary" : "mobile-facets__summary"} focus-inset caption--strong"
                  aria-label="${labels.sortOptions.label} ${appliedSortOption.label}"
                >
                  <div>
                    <span class="facets__summary-label">${labels.sortOptions.label}</span>
                    ${props.device === "desktop" ? html` <${args.templates.icon} type="caret" /> ` : html`<span class="mobile-facets__arrow">
                          <${args.templates.icon} type="chevron-down" />
                        </span>`}
                  </div>
                </summary>

                <div class="${props.device === "desktop" ? "facets__display-vertical" : "mobile-facets__submenu"}">
                  <ul class="facets-layout facets-layout-list list-unstyled">
                    ${sortOptions.map(
                (sortOption) => html` <${args.templates.sortOptionListItem}
                          sortOption=${sortOption}
                          applySortOption=${applySortOption}
                          device=${props.device}
                        />`
              )}
                  </ul>
                </div>
              </details>
            `;
            }
            if (props.type === "dropdown") {
              return html`
              <div class="facet-filters sorting caption">
                <div class="facet-filters__field">
                  <h2 class="facet-filters__label caption-large text-body">
                    <label for="SortBy">${labels.sortOptions.label}</label>
                  </h2>
                  <div class="select">
                    <select
                      class="facet-filters__sort select__select caption-large"
                      id="SortBy"
                      name="sort_by"
                      value=${appliedSortOption.id}
                      onchange=${applySortOption}
                    >
                      ${sortOptions.map(
                (sortOption) => html` <option value=${sortOption.id}>${sortOption.label}</option>`
              )}
                    </select>

                    <span class="svg-wrapper">
                      <${args.templates.icon} type="chevron-down" />
                    </span>
                  </div>
                </div>
              </div>
            `;
            }
          }
        },
        sortOptionListItem: {
          render(html, args) {
            const props = args.props;
            const sortOption = props.sortOption;
            return html`
            <li class="list-menu__item facets__item">
              <label
                for=${`SortBy-${sortOption.id}-${props.device}`}
                class="facets__label facet-checkbox caption-with-letter-spacing"
              >
                <input
                  id=${`SortBy-${sortOption.id}-${props.device}`}
                  class="visually-hidden"
                  type="radio"
                  name="sort_by"
                  value=${sortOption.id}
                  ${sortOption.selected ? "checked" : ""}
                  onchange=${props.applySortOption}
                />
                <${args.templates.icon} type="square" />
                <div class="svg-wrapper">
                  <${args.templates.icon} type="checkmark" />
                </div>
                ${sortOption.label}
              </label>
            </li>
          `;
          }
        },
        resultsCountLabel: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const totalProductsCount = helpers.getTotalProductsCount();
            const resultsLabelTemplate = totalProductsCount === 1 ? labels.resultsWithCount.one : labels.resultsWithCount.other;
            const resultsLabel = resultsLabelTemplate == null ? void 0 : resultsLabelTemplate.replace("{{ count }}", totalProductsCount);
            return html`${resultsLabel}`;
          }
        },
        products: {
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const products = helpers.getProducts();
            return html`
            <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" role="list">
              ${products.map((product) => html`<${args.templates.product} key=${product.id} product=${product} />`)}
            </ul>
          `;
          }
        },
        product: {
          render(html, args) {
            const props = args.props;
            const product = props.product;
            const helpers = props.helpers;
            return html`<li
            class="grid__item scroll-trigger animate--slide-in"
            dangerouslySetInnerHTML=${{ __html: product_card_render_default(product, helpers) }}
          />`;
          }
        },
        productListFooter: {
          render(html, args) {
            return html` <${args.templates.pagination} /> `;
          }
        },
        pagination: {
          render(html, args) {
            return html`
            <div class="pagination-wrapper">
              <nav class="pagination" role="navigation" aria-label="Pagination">
                <${args.templates.paginationLinks} />
              </nav>
            </div>
          `;
          }
        },
        paginationLinks: {
          options: {
            showNumberedPageLinks: true,
            numberedPageLinksWindowSize: 3,
            showPreviousPageLink: true,
            showFirstPageLink: false,
            showNextPageLink: true,
            scrollTop: true
          },
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const pagesToDisplay = helpers.getPagesToDisplay(props.numberedPageLinksWindowSize);
            const hasPreviousPage = helpers.hasPreviousPage();
            const hasNextPage = helpers.hasNextPage();
            return html`
            <ul class="pagination__list list-unstyled" role="list">
              ${props.showPreviousPageLink && hasPreviousPage ? html` <li>
                    <button
                      type="button"
                      class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
                      aria-label="Previous page"
                      onclick=${helpers.goToPreviousPage}
                    >
                      <span class="svg-wrapper">
                        <${args.templates.icon} type="caret" />
                      </span>
                    </button>
                  </li>` : null}
              ${props.showNumberedPageLinks ? pagesToDisplay.map((pageDetail) => {
              const classes2 = ["pagination__item link"];
              const isEllipsis = pageDetail.jumpAfter;
              if (pageDetail.current) classes2.push("pagination__item--current");
              const className = classes2.join(" ");
              if (isEllipsis) {
                return html`
                        <li>
                          <span class="pagination__item tt">...</span>
                        </li>
                      `;
              }
              return html`
                      <li>
                        <button
                          type="button"
                          class=${`${className}`}
                          onclick=${() => {
                helpers.goToPage(pageDetail.page);
              }}
                        >
                          ${pageDetail.page}
                        </button>
                      </li>
                    `;
            }) : null}
              ${props.showNextPageLink && hasNextPage ? html`
                    <li>
                      <button
                        type="button"
                        class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                        aria-label="Next page"
                        onclick=${helpers.goToNextPage}
                      >
                        <span class="svg-wrapper">
                          <${args.templates.icon} type="caret" />
                        </span>
                      </button>
                    </li>
                  ` : null}
            </ul>
          `;
          }
        },
        showMoreButton: {
          render(html, args) {
            var _a5, _b4, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
            const props = args.props;
            return html`<show-more-button>
            <button
              class="button-show-more link underlined-link caption--strong"
              id="Show-More-${props.filterId}-tagalys-search"
              type="button"
            >
              <span class="label-show-more label-text">
                ${(_e2 = (_d2 = (_c2 = (_b4 = (_a5 = window.theme) == null ? void 0 : _a5.strings) == null ? void 0 : _b4.search) == null ? void 0 : _c2.filters) == null ? void 0 : _d2.showMore) != null ? _e2 : "Show More"}
              </span>
              <span class="label-show-less label-text hidden">
                ${(_j2 = (_i2 = (_h2 = (_g2 = (_f2 = window.theme) == null ? void 0 : _f2.strings) == null ? void 0 : _g2.search) == null ? void 0 : _h2.filters) == null ? void 0 : _i2.showLess) != null ? _j2 : "Show Less"}
              </span>
            </button>
          </show-more-button>`;
          }
        },
        noResults: {
          options: {
            widgets: [
              {
                widgetId: noResultsWidgetId,
                options: {
                  templates: tagalys_widget_templates_default(noResultsWidgetLimit, widgetElem),
                  callbacks: {
                    afterInitialRender: () => {
                      const sliderComponent = widgetElem.querySelector("slider-component");
                      sliderComponent == null ? void 0 : sliderComponent.reinitialiseSlider();
                    }
                  }
                }
              }
            ]
          },
          render(html, args) {
            return html`
            <${args.templates.header} />

            ${noResultsWidgetId ? html`
                  <div class="product-recommendations__wrapper">
                    <${args.templates.noResultsWidgets} />
                  </div>
                ` : ""}
          `;
          }
        },
        icon: {
          render(html, args) {
            const props = args.props;
            if (props.type === "filters") {
              return html`<svg
              class="icon icon-filters"
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              fill="none"
              viewBox="0 0 13 13"
            >
              <g fill="currentColor" clip-path="url(#a)">
                <path
                  fill-rule="evenodd"
                  d="M11.665.83H1.077v10.59h10.588V.83ZM.371.126v12h12v-12h-12Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M3.444 4.949h4.197a.824.824 0 1 0 0-.706H3.444v.706ZM4.268 8.83a.824.824 0 0 0 .744-.47h4.197v-.706H5.012a.824.824 0 1 0-.744 1.177Z"
                />
              </g>
              <defs>
                <clipPath id="a"><path fill="#fff" d="M0 .125h13v12H0z" /></clipPath>
              </defs>
            </svg>`;
            }
            if (props.type === "caret") {
              return html`<svg class="icon icon-caret" viewBox="0 0 10 6">
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                clip-rule="evenodd"
              />
            </svg> `;
            }
            if (props.type === "chevron-down") {
              return html`<svg
              class="icon icon-chevron-down"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M4 6L8 10L12 6" stroke="currentColor" />
            </svg> `;
            }
            if (props.type === "square") {
              return html`<svg width="16px" height="16px" viewBox="0 0 16 16">
              <rect width="16" height="16" fill="none" stroke="currentColor" />
            </svg>`;
            }
            if (props.type === "checkmark") {
              return html`<svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="icon icon-checkmark"
              viewBox="0 0 12 9"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
                clip-rule="evenodd"
              />
            </svg> `;
            }
            if (props.type === "close") {
              return html`<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
              <path
                fill="currentColor"
                d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
              />
            </svg>`;
            }
            if (props.type === "close-small") {
              return html`<svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="icon icon-close-small"
              viewBox="0 0 12 13"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"
              />
            </svg>`;
            }
          }
        }
      },
      callbacks: {
        onSuccessfulAPICall: (response) => {
          var _a5, _b4, _c2, _d2, _e2, _f2, _g2, _h2;
          const totalResults = response.total;
          const metaTitleTemplate = totalResults > 0 ? `${(_d2 = (_c2 = (_b4 = (_a5 = window.theme) == null ? void 0 : _a5.strings) == null ? void 0 : _b4.search) == null ? void 0 : _c2.metaTitle) == null ? void 0 : _d2.results} - ${window.shopName}` : `${(_h2 = (_g2 = (_f2 = (_e2 = window.theme) == null ? void 0 : _e2.strings) == null ? void 0 : _f2.search) == null ? void 0 : _g2.metaTitle) == null ? void 0 : _h2.noResults} - ${window.shopName}`;
          const metaTitle = metaTitleTemplate.replace("{{ count }}", totalResults).replace("{{ term }}", response.query);
          document.title = decodeHtmlEntities(metaTitle);
          return response;
        }
      }
    });
  };
  var initTagalysSearchResults = (container) => {
    onTagalysReady(() => {
      tagalysSearchResults(container);
    });
  };

  // src/scripts/components/facets-vertical-open.js
  var initFacetsVerticalOpenElement = () => {
    class FacetsVerticalOpen extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          facetsVertical: "[data-facets-vertical]"
        };
        this.classes = {
          facetsVerticalAreOpen: "facets-vertical-are-open",
          facetsHidden: "facets-wrapper-TWP--vertical-hidden"
        };
      }
      connectedCallback() {
        var _a4, _b3;
        this.button = this.querySelector("button");
        this.facetsVertical = (_a4 = this.closest(".shopify-section")) == null ? void 0 : _a4.querySelector(this.selectors.facetsVertical);
        if (this.facetsVertical) {
          this.setInitialState();
        } else {
          document.addEventListener(
            "tagalys-search:vertical-filters-ready",
            () => {
              var _a5;
              this.facetsVertical = (_a5 = this.closest(".shopify-section")) == null ? void 0 : _a5.querySelector(this.selectors.facetsVertical);
              if (this.facetsVertical) this.setInitialState();
            },
            { once: true }
          );
        }
        (_b3 = this.button) == null ? void 0 : _b3.addEventListener("click", (event) => {
          var _a5;
          event.preventDefault();
          this.isOpen = !((_a5 = this.facetsVertical) == null ? void 0 : _a5.classList.contains(this.classes.facetsHidden));
          this.toggleFacetsVerticalVisibility(!this.isOpen);
          sessionStorage.setItem("facetsVerticalOpen", !this.isOpen);
        });
      }
      setInitialState() {
        var _a4;
        this.isOpen = !((_a4 = this.facetsVertical) == null ? void 0 : _a4.classList.contains(this.classes.facetsHidden));
        this.facetsVerticalState = sessionStorage.getItem("facetsVerticalOpen") ? JSON.parse(sessionStorage.getItem("facetsVerticalOpen")) : this.isOpen;
        this.toggleFacetsVerticalVisibility(this.facetsVerticalState);
      }
      toggleFacetsVerticalVisibility(open) {
        var _a4, _b3;
        (_a4 = this.button) == null ? void 0 : _a4.setAttribute("aria-expanded", open);
        (_b3 = this.facetsVertical) == null ? void 0 : _b3.classList.toggle(this.classes.facetsHidden, !open);
        document.body.classList.toggle("facets-vertical-are-open", open);
      }
    }
    customElements.define("facets-vertical-open", FacetsVerticalOpen);
  };
  var facets_vertical_open_default = initFacetsVerticalOpenElement;

  // src/scripts/utils/debounce.js
  var debounce = (callback, delay = 250) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        timeoutId = null;
        callback(...args);
      }, delay);
    };
  };

  // src/scripts/components/facets-search.js
  var initFacetsSearch = () => {
    class FacetsSearch extends HTMLElement {
      constructor() {
        super();
        __publicField(this, "debouncedSearch", debounce(() => {
          var _a4, _b3;
          const searchValue = this.facetsSearchInput.value;
          if (this.listItems.length < 1) return;
          let resultsCount = 0;
          this.listItems.forEach((item) => {
            var _a5;
            const label = item.querySelector(this.selectors.facetLabel);
            const labelText = ((_a5 = label == null ? void 0 : label.textContent) == null ? void 0 : _a5.toLowerCase()) || "";
            if (searchValue === "" || labelText.includes(searchValue)) {
              item.classList.remove("hidden");
              resultsCount++;
            } else {
              item.classList.add("hidden");
            }
          });
          const noResults = (_a4 = this.facetsContainer) == null ? void 0 : _a4.querySelector(this.selectors.noSearchResults);
          noResults == null ? void 0 : noResults.classList.toggle("hidden", resultsCount > 0);
          const showMoreButton = (_b3 = this.facetsContainer) == null ? void 0 : _b3.querySelector(this.selectors.facetsShowMoreButton);
          showMoreButton == null ? void 0 : showMoreButton.classList.toggle("hidden", resultsCount <= this.showMoreNumber);
        }, 250));
        this.selectors = {
          facetsContainer: "[data-facets-container]",
          facetsItem: "[data-facets-item]",
          facetLabel: "[data-facet-label]",
          facetSearchInput: "[data-facets-search-input]",
          noSearchResults: "[data-facet-search-no-results]",
          facetsShowMoreButton: "show-more-button"
        };
        this.classes = {
          hidden: "hidden"
        };
      }
      connectedCallback() {
        var _a4, _b3, _c;
        this.facetsSearchInput = this.querySelector(this.selectors.facetSearchInput);
        this.facetsContainer = (_a4 = this.facetsSearchInput) == null ? void 0 : _a4.closest(this.selectors.facetsContainer);
        this.listItems = (_b3 = this.facetsContainer) == null ? void 0 : _b3.querySelectorAll(this.selectors.facetsItem);
        this.showMoreNumber = window.matchMedia("(min-width: 990px)").matches ? 10 : 5;
        (_c = this.facetsSearchInput) == null ? void 0 : _c.addEventListener("input", this.debouncedSearch);
      }
      disconnectedCallback() {
        var _a4;
        (_a4 = this.facetsSearchInput) == null ? void 0 : _a4.removeEventListener("input", this.debouncedSearch);
      }
    }
    customElements.define("facets-search", FacetsSearch);
  };
  var facets_search_default = initFacetsSearch;

  // src/scripts/components/similar-styles-widget.js
  var similarStylesTemplates = () => ({
    widget: {
      options: { limit: 6, displayFormat: "grid", includeTagalysCSS: false },
      render: (html, args) => {
        const products = args.props.helpers.getProducts();
        if (args.props.loading === false && products.length === 0) return null;
        return html`<${args.templates.products} />`;
      }
    },
    products: {
      render: (html, args) => {
        const products = args.props.helpers.getProducts().filter((product) => {
          var _a4;
          return (_a4 = product.variants) == null ? void 0 : _a4.some((variant) => variant.available);
        });
        return html`
        <div class="product-set-drawer__grid contains-card contains-card--product">
          ${products.map(
          (product, index) => html`<${args.templates.product} key=${index} product=${product} />`
        )}
        </div>
      `;
      }
    },
    product: {
      options: {
        productPageUrl(product) {
          return constructLocalisedProductLink(product);
        }
      },
      render: (html, args) => html`<div
        dangerouslySetInnerHTML=${{ __html: product_card_render_default(args.props.product, args.props.helpers) }}
      />`
    }
  });
  var similar_styles_widget_default = similarStylesTemplates;

  // src/scripts/components/autoplay-video.js
  var AutoplayVideo = class extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        video: "video",
        control: "[data-video-control]"
      };
      this.classes = {
        playing: "autoplay-video__control--playing"
      };
    }
    connectedCallback() {
      var _a4, _b3;
      this.video = this.querySelector(this.selectors.video);
      this.control = this.querySelector(this.selectors.control);
      (_a4 = this.control) == null ? void 0 : _a4.addEventListener("click", this.togglePlayPause.bind(this));
      (_b3 = this.video) == null ? void 0 : _b3.addEventListener("click", () => {
        if (window.matchMedia("(min-width: 750px)").matches) return;
        this.togglePlayPause();
      });
    }
    togglePlayPause() {
      if (!this.video) return;
      if (this.video.paused) {
        this.video.play();
        this.control.classList.add(this.classes.playing);
      } else {
        this.video.pause();
        this.control.classList.remove(this.classes.playing);
      }
    }
  };
  customElements.define("autoplay-video", AutoplayVideo);

  // node_modules/lazyvids/dist/lazyvids.js
  ((t) => {
    window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach), document.addEventListener("DOMContentLoaded", () => {
      var w, f, h, z, m, L;
      const r = { logLevel: (w = t == null ? void 0 : t.logLevel) != null ? w : "silent", ignoreHidden: (f = t == null ? void 0 : t.ignoreHidden) != null ? f : false, minBandwidth: (t == null ? void 0 : t.minBandwidth) ? Number(t.minBandwidth) : 0, reduceData: (h = t == null ? void 0 : t.reduceData) != null ? h : false }, E = (e, a = "") => {
        r.logLevel === "verbose" && window.console.log(`lazyvids: ${e}`, a);
      }, i = (e, a = "") => {
        r.logLevel !== "silent" && window.console.warn(`lazyvids: ${e}`, a);
      }, u = typeof window.IntersectionObserver == "function";
      let y;
      if (r.reduceData && r.minBandwidth && (((z = navigator.connection) == null ? void 0 : z.downlink) < r.minBandwidth || ((m = navigator.connection) == null ? void 0 : m.saveData))) {
        i(`Slow connection (${(L = navigator.connection) == null ? void 0 : L.downlink}mbps). Lazy autoplay disabled.`);
        return;
      }
      const c = (e) => {
        e.muted = true, e.autoplay = true, e.play() !== void 0 ? e.play().then(() => e.dataset.lazyvids = "loaded").catch((a) => i("Autoplay blocked by browser for:", e)) : e.dataset.lazyvids = "loaded";
      }, v = (e) => {
        var n, d;
        if (((n = e.style) == null ? void 0 : n.display) === "none" || r.ignoreHidden && ((d = e.style) == null ? void 0 : d.visibility) === "hidden") return false;
        const a = getComputedStyle(e);
        return a.getPropertyValue("display") === "none" || r.ignoreHidden && a.getPropertyValue("visibility") === "hidden" ? false : e.parentNode && e.parentNode !== document ? v(e.parentNode) : true;
      }, N = (e, a) => {
        e.forEach((s) => {
          window.requestAnimationFrame(() => {
            const n = s.target;
            s.isIntersecting !== false && v(n) !== false && (c(n), a.unobserve(n));
          });
        });
      };
      u && (y = new IntersectionObserver(N));
      const o = (e) => {
        if (u === false) {
          c(e), i("Unsupported browser. Lazy autoplay disabled.");
          return;
        }
        e.dataset.lazyvids = "unloaded", y.observe(e);
      }, p = "video[data-lazyvids]:not([data-lazyvids=loaded]):not([data-lazyvids=false])", l = document.querySelectorAll(p);
      E(`Initialised \u2014 ${l.length} ${l.length === 1 ? "video" : "videos"} detected`), l.forEach((e) => o(e));
      const I = (e) => {
        e.forEach((a) => {
          a.addedNodes.forEach((s) => {
            if (s.tagName === "VIDEO" && s.dataset.lazyvids !== void 0 && s.dataset.lazyvids !== "loaded" && s.dataset.lazyvids !== "false") {
              o(s);
              return;
            }
            if (s.hasChildNodes() === false) return;
            s.querySelectorAll(p).forEach((d) => o(d));
          });
        });
      }, D = { childList: true, subtree: true };
      new MutationObserver(I).observe(document, D);
    });
  })(window.lazyvidsConfig || {});

  // src/scripts/layout/theme.js
  var selectors5 = {
    shopifySections: ".shopify-section",
    tagalysSearchResults: '[data-tagalys-widget="search-results"]'
  };
  var classes = {
    header: "section-header",
    productRecommendations: "product-recommendations-recently",
    sectionCollection: "section-collection",
    sectionSearch: "main-search"
  };
  document.addEventListener("DOMContentLoaded", () => {
    window.theme = window.theme || {};
    window.theme.similarStylesTemplates = similar_styles_widget_default;
    initCustomTabs();
    initCartDrawerRecommendations();
    initTagalys();
    onTagalysReady(() => {
      var _a4;
      if (((_a4 = window.Tagalys) == null ? void 0 : _a4.Analytics) && typeof window.Tagalys.Analytics.trackPlatformEvents === "function") {
        window.Tagalys.Analytics.trackPlatformEvents();
      }
    });
    initTagalysSearchSuggestions();
    const shopifySections = document.querySelectorAll(selectors5.shopifySections);
    shopifySections.forEach((section) => {
      if (section.classList.contains(classes.header)) {
        header_default(section);
        return;
      }
      if (section.classList.contains(classes.productRecommendations)) {
        productRecommendations(section);
        return;
      }
      if (section.classList.contains(classes.sectionCollection) || section.classList.contains(classes.sectionSearch)) {
        facets_vertical_open_default();
        facets_search_default();
      }
      if (section.querySelector(selectors5.tagalysSearchResults)) {
        initTagalysSearchResults(section);
      }
    });
    document.addEventListener("shopify:section:load", (event) => {
      var _a4, _b3, _c;
      const sectionId = (_a4 = event.detail) == null ? void 0 : _a4.sectionId;
      const section = ((_c = (_b3 = event.target) == null ? void 0 : _b3.matches) == null ? void 0 : _c.call(_b3, selectors5.shopifySections)) ? event.target : document.getElementById(`shopify-section-${sectionId}`);
      if (section) productRecommendations(section);
    });
    document.addEventListener("shopify:block:load", (event) => {
      productRecommendations(event.target);
    });
    const copyButtons = document.querySelectorAll("[data-copy-button]");
    copyButtons.forEach((button) => {
      button.addEventListener("click", () => __async(void 0, null, function* () {
        let text = button.dataset.copyButton;
        if (!text) return;
        try {
          yield navigator.clipboard.writeText(text);
          button.disabled = true;
          setTimeout(() => {
            button.disabled = false;
          }, 1500);
        } catch (err) {
          window.console.error("Failed to copy text: ", err);
        }
      }));
    });
  });
})();
/*! Bundled license information:

get-size/get-size.js:
  (*!
   * Infinite Scroll v2.0.4
   * measure size of elements
   * MIT license
   *)

unidragger/unidragger.js:
  (*!
   * Unidragger v3.0.1
   * Draggable base class
   * MIT license
   *)

imagesloaded/imagesloaded.js:
  (*!
   * imagesLoaded v5.0.0
   * JavaScript is all like "You images are done yet or what?"
   * MIT License
   *)

flickity/js/index.js:
  (*!
   * Flickity v3.0.0
   * Touch, responsive, flickable carousels
   *
   * Licensed GPLv3 for open source use
   * or Flickity Commercial License for commercial use
   *
   * https://flickity.metafizzy.co
   * Copyright 2015-2022 Metafizzy
   *)
*/
